/* Warehouse Bold — Cleco Kit Builder */
(function () {
  'use strict';

  var root = document.querySelector('[data-wb-kb]');
  if (!root) return;
  var blob = root.querySelector('[data-wb-kb-config]');
  if (!blob) return;

  var cfg;
  try {
    cfg = JSON.parse(blob.textContent);
  } catch (e) {
    return;
  }

  /* ⚠ Shopify's `t` filter returns an HTML-ESCAPED string, and `| json` then
     preserves the escaping — so "e.g. John's cleco kit" arrives here as
     "e.g. John&#39;s cleco kit". In markup that renders correctly and nobody
     notices; the moment the same key is handed to the DOM as text (a
     placeholder, a textContent, an aria-label) the customer reads the raw
     entity. English has one apostrophe in the whole blob, which is why this
     went unseen — French and Italian have them everywhere.

     Decoded once, here, rather than at 140 call sites. A <textarea> is the
     safe decoder: its content is parsed as RCDATA, so entities resolve and
     markup does not, and nothing can execute. */
  (function () {
    if (!cfg || !cfg.t) return;
    var box = document.createElement('textarea');
    for (var k in cfg.t) {
      var v = cfg.t[k];
      if (typeof v !== 'string' || v.indexOf('&') < 0) continue;
      box.innerHTML = v;
      cfg.t[k] = box.value;
    }
  })();

  var STORE_KEY = 'wb-kb-v1';
  var MAX_UNITS = 999;
  var TRAY_UNIT_CAP = 12;
  var LADDER = ['3/32', '1/8', '5/32', '3/16', '1/4'];

  /* Liquid emits diameters in ladder order and everything else in collection
     order, which reads as random for clamps (1", 1", 1/2", 3", 2"). Sort the
     non-diameter sizes by label once, here, so the grid, the tray and the
     review list can never present them in three different orders.

     ⚠ Not for a series that arrives already in order (keepOrder — drill
     stops). By label, "#10" sorts ahead of "#40" and the cleco ladder pulls
     1/4 to the front, so the smallest drill would land fifth of seven. */
  for (var si = 0; si < cfg.parts.length; si++) {
    if (cfg.parts[si].keepOrder) continue;
    var sz = cfg.parts[si].sizes;
    var lad = [];
    var rest = [];
    for (var zi = 0; zi < sz.length; zi++) {
      (LADDER.indexOf(sz[zi].size) >= 0 ? lad : rest).push(sz[zi]);
    }
    rest.sort(function (a, b) {
      return String(a.label).localeCompare(String(b.label), undefined, { numeric: true });
    });
    cfg.parts[si].sizes = lad.concat(rest);
  }

  var state = {
    project: null,
    pliers: null,
    custom: false,
    name: '',
    qty: {},
    cond: {},
    editingKit: null
  };

  var lastUnsure = null;

  /* ---------------------------------------------------------------- utils */

  function byId(list, id) {
    for (var i = 0; i < list.length; i++) if (list[i].key === id) return list[i];
    return null;
  }

  function fill(tpl, map) {
    var out = tpl == null ? '' : String(tpl);
    for (var k in map) {
      if (Object.prototype.hasOwnProperty.call(map, k)) {
        out = out.split(k).join(map[k]);
      }
    }
    return out;
  }

  function money(cents) {
    if (window.FoxTheme && FoxTheme.Currency && FoxTheme.Currency.formatMoney) {
      /* ⚠ cfg.moneyFormat (shop.money_format) FIRST, not
         FoxTheme.settings.moneyFormat. Every price string rendered by Liquid
         in the config blob came through `| money`, and with
         currency_code_enabled on, FoxTheme's format is
         money_with_currency_format — so the same row showed "$1.95" beside a
         total of "$19.50 AUD". One page, one format. */
      var fmt = cfg.moneyFormat || (FoxTheme.settings && FoxTheme.settings.moneyFormat);
      return FoxTheme.Currency.formatMoney(cents, fmt);
    }
    return (cents / 100).toFixed(2);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function announce(msg) {
    var live = root.querySelector('[data-wb-kb-live]');
    if (live && live.textContent !== msg) live.textContent = msg;
  }

  function qtyKey(seriesKey, sizeKey) {
    return seriesKey + '::' + sizeKey;
  }

  function solve(size, n) {
    /* Prices and buyability are fixed for the life of the page, so a given
       (size, n) always has the same answer. The nudge below probes up to 120
       quantities per row per render, which without this is ~half a million
       operations on a five-row grid every time a stepper is tapped. */
    if (!size.__solveCache) size.__solveCache = {};
    if (size.__solveCache[n]) return size.__solveCache[n];
    var result = solveUncached(size, n);
    size.__solveCache[n] = result;
    return result;
  }

  function ceilingFor(size) {
    var total = 0;
    for (var i = 0; i < size.rungs.length; i++) {
      var r = size.rungs[i];
      if (!r.buyable || r.packQty <= 0) continue;
      if (r.stock == null || r.stock < 0) return MAX_UNITS;
      total += Math.floor(r.stock) * r.packQty;
    }
    return Math.min(total, MAX_UNITS);
  }

  function solveUncached(size, n) {
    var rungs = [];
    for (var i = 0; i < size.rungs.length; i++) {
      var r = size.rungs[i];
      if (r.buyable && r.packQty > 0) rungs.push(r);
    }
    if (!rungs.length || n <= 0) return { lines: [], total: 0, delivered: 0, ok: n <= 0, capped: false };

    var want = Math.min(n, MAX_UNITS);
    var ceiling = ceilingFor(size);
    var capped = false;
    if (ceiling < want) {
      /* Cannot ship what was asked for. Solve for everything that IS
         available rather than returning nothing — a half kit the customer
         can see beats an empty row with no explanation. */
      want = ceiling;
      capped = true;
      if (want <= 0) return { lines: [], total: 0, delivered: 0, ok: false, capped: true };
    }

    var items = [];
    for (var j = 0; j < rungs.length; j++) {
      var rung = rungs[j];
      var maxCount = Math.ceil(want / rung.packQty);
      if (rung.stock != null && rung.stock >= 0) maxCount = Math.min(maxCount, Math.floor(rung.stock));
      var step = 1;
      while (maxCount > 0) {
        var take = Math.min(step, maxCount);
        items.push({ w: rung.packQty * take, c: rung.price * take, rung: j, n: take });
        maxCount -= take;
        step *= 2;
      }
    }
    if (!items.length) return { lines: [], total: 0, delivered: 0, ok: false, capped: capped };

    var cap = want;
    var dp = new Array(cap + 1);
    var got = new Array(cap + 1);
    for (var z = 0; z <= cap; z++) { dp[z] = Infinity; got[z] = 0; }
    dp[0] = 0;

    var took = [];
    for (var it = 0; it < items.length; it++) {
      var flags = new Uint8Array(cap + 1);
      for (var q = cap; q >= 1; q--) {
        var prev = Math.max(0, q - items[it].w);
        if (dp[prev] === Infinity) continue;
        var cost = dp[prev] + items[it].c;
        var delivered = got[prev] + items[it].w;
        /* ⚠ Ties go to MORE units. Breaking ties the other way charged the
           100-pack price and handed over 95 pins, because a combination
           costing the same but delivering less won on strict less-than. */
        if (cost < dp[q] || (cost === dp[q] && delivered > got[q])) {
          dp[q] = cost;
          got[q] = delivered;
          flags[q] = 1;
        }
      }
      took.push(flags);
    }
    if (dp[cap] === Infinity) return { lines: [], total: 0, delivered: 0, ok: false, capped: capped };

    var counts = {};
    var at = cap;
    for (var b = items.length - 1; b >= 0 && at > 0; b--) {
      if (took[b][at]) {
        counts[items[b].rung] = (counts[items[b].rung] || 0) + items[b].n;
        at = Math.max(0, at - items[b].w);
      }
    }

    var lines = [];
    var deliveredTotal = 0;
    for (var k in counts) {
      if (Object.prototype.hasOwnProperty.call(counts, k)) {
        lines.push({ rung: rungs[k], count: counts[k] });
        deliveredTotal += rungs[k].packQty * counts[k];
      }
    }
    lines.sort(function (a, b2) { return b2.rung.packQty - a.rung.packQty; });
    return { lines: lines, total: dp[cap], delivered: deliveredTotal, ok: lines.length > 0, capped: capped };
  }

  function nudge(size, n) {
    if (n <= 0) return null;
    var base = solve(size, n);
    if (!base.ok || !base.delivered) return null;
    var basePer = base.total / base.delivered;
    for (var m = n + 1; m <= Math.min(n + 120, MAX_UNITS); m++) {
      var alt = solve(size, m);
      if (!alt.ok || !alt.delivered) continue;
      var per = alt.total / alt.delivered;
      if (per < basePer * 0.98) {
        /* ⚠ The delta is in REQUESTED units (m - n), not delivered ones.
           This line sits directly under a stepper showing the requested
           count, so "add 8 more" has to mean 8 more taps of that stepper.
           Measuring the delivered delta made it say "add 58" when tapping
           8 was enough. */
        var add = m - n;
        if (add <= 0) continue;
        return { per: per, add: add, at: m };
      }
    }
    return null;
  }

  function eachSize(fn) {
    for (var i = 0; i < cfg.parts.length; i++) {
      var series = cfg.parts[i];
      for (var j = 0; j < series.sizes.length; j++) fn(series, series.sizes[j]);
    }
  }

  /* ── kit-aware pricing ──────────────────────────────────────────────────
     The builder's promise is "we work out the best-value packs" — and the
     store's own pre-made kits are just bigger packs that span sizes. When the
     customer's selections CONTAIN a kit's contents and the kit is strictly
     cheaper, the basket buys the kit SKU and tops up with parts.

     Three rules that carry the whole design:
     - Sub-multiset only. A kit is eligible when every component fits inside
       what the customer asked for — the swap can never add a tool or a size
       nobody wanted. Pack over-delivery is pins; an unasked pair of pliers
       is a different product.
     - Strictly cheaper only, and silent otherwise. Owen, 2026-08-23: kit
       prices are set against competitors, not margin — some kits cost MORE
       than their parts on purpose. Those simply never swap and are never
       mentioned; the comparison only ever surfaces in the customer's favour.
     - Derived, never stored. state.qty stays the customer's requested piece
       counts (steppers, persistence, the pliers warning all read it); the
       swap is a purchasing decision made fresh inside basket(), exactly like
       pack selection. */

  var rungIndexMemo = null;
  function rungIndex() {
    if (rungIndexMemo) return rungIndexMemo;
    rungIndexMemo = {};
    eachSize(function (series, size) {
      for (var i = 0; i < size.rungs.length; i++) {
        rungIndexMemo[String(size.rungs[i].sku).toUpperCase()] = {
          key: qtyKey(series.key, size.size), packQty: size.rungs[i].packQty
        };
      }
    });
    return rungIndexMemo;
  }

  var sizeIndexMemo = null;
  function sizeByKey() {
    if (sizeIndexMemo) return sizeIndexMemo;
    sizeIndexMemo = {};
    eachSize(function (series, size) {
      sizeIndexMemo[qtyKey(series.key, size.size)] = { series: series, size: size };
    });
    return sizeIndexMemo;
  }

  var kitCandsMemo = null;
  function kitCandidates() {
    if (kitCandsMemo) return kitCandsMemo;
    var out = [], seen = {}, idx = rungIndex(), kits = cfg.kits || {};
    for (var slot in kits) {
      var k = kits[slot];
      /* Fail closed at every gate: no contents, an unparsed quantity, or a
         component SKU the builder doesn't sell just means this kit never
         swaps — never a broken page. */
      if (!k || !k.available || !k.sku || !k.contents || !k.contents.length) continue;
      if (seen[k.id]) continue;
      /* ⚠ One picker slot holds AT552M-20 — a plain pack that is ALREADY a
         ladder rung. The knapsack reaches it on its own; treating it as a
         kit as well would count the same pack twice. */
      if (idx[String(k.sku).toUpperCase()]) continue;
      var needs = {}, pieces = 0, ok = true;
      for (var i = 0; i < k.contents.length; i++) {
        var c = k.contents[i];
        /* Integer counts only. Liquid's times:1 preserves a decimal typed
           into a BOM name ("2.5 × ..."), and a fractional need would walk a
           fractional remainder into solve(), which allocates arrays by it. */
        if (!c || !c.sku || typeof c.qty !== 'number' || !(c.qty >= 1) || c.qty % 1 !== 0) { ok = false; break; }
        var hit = idx[String(c.sku).toUpperCase()];
        if (!hit) { ok = false; break; }
        needs[hit.key] = (needs[hit.key] || 0) + hit.packQty * c.qty;
        pieces += hit.packQty * c.qty;
      }
      if (!ok) continue;
      seen[k.id] = true;
      out.push({ id: k.id, sku: String(k.sku).toUpperCase(), title: k.title,
                 /* stock stays SIGNED: -1 is the rung convention for
                    untracked / oversell-enabled — no ceiling. */
                 price: k.price, stock: typeof k.stock === 'number' ? k.stock : 0,
                 needs: needs, pieces: pieces });
    }
    kitCandsMemo = out;
    return out;
  }

  function kitContentsIndex() {
    var out = {};
    kitCandidates().forEach(function (k) { out[k.sku] = k; });
    return out;
  }

  /* Cheapest way to buy the request as kits + remainder parts. Exhaustive
     over kit multiplicities — with ~5 candidates and stock-bounded counts the
     space is tiny, and every remainder price is a memoised solve() lookup.
     ⚠ Never mutates or annotates solve() output: that cache is shared. */
  function bestKitPlan(baseTotal) {
    var cands = kitCandidates();
    if (!cands.length) return null;
    var remaining = {};
    eachSize(function (series, size) {
      var kk = qtyKey(series.key, size.size);
      var n = state.qty[kk] || 0;
      if (n > 0) remaining[kk] = n;
    });

    var byKey = sizeByKey(), best = null, evals = 0;

    function costOf(kitCost) {
      var total = kitCost;
      for (var kk in remaining) {
        var n = remaining[kk];
        if (n <= 0) continue;
        var sol = solve(byKey[kk].size, n);
        /* A not-ok remainder is pieces the store cannot sell right now — the
           baseline basket skips those sizes too, so both sides of the
           comparison ignore them identically. */
        if (sol.ok && sol.lines.length) total += sol.total;
      }
      return total;
    }

    function snapshot() {
      var copy = {};
      for (var kk in remaining) copy[kk] = remaining[kk];
      return copy;
    }

    function dfs(i, chosen, kitCost) {
      if (evals > 4000) return;
      if (i === cands.length) {
        if (!chosen.length) return;
        evals++;
        var total = costOf(kitCost);
        if (total < (best ? best.total : baseTotal)) {
          best = { total: total, kits: chosen.slice(), remaining: snapshot() };
        }
        return;
      }
      var k = cands[i], kk;
      /* The ceiling on how many of this kit the till can sell: -1 means
         untracked/oversell (no ceiling); a tracked count is reduced by what
         is ALREADY in the cart, or a second build of the same kit would ride
         the atomic items[] into a 422 that kills the whole add.
         ⚠ Clamped to >= 0. A negative ceiling once reached the restore line
         below and SUBTRACTED from `remaining` instead of restoring it,
         poisoning every sibling evaluation in the search. */
      var cap = k.stock < 0 ? Infinity : Math.max(0, k.stock - (cartQty[k.id] || 0));
      var mMax = cap;
      for (kk in k.needs) {
        mMax = Math.min(mMax, Math.floor((remaining[kk] || 0) / k.needs[kk]));
      }
      mMax = Math.max(0, mMax);
      dfs(i + 1, chosen, kitCost);
      for (var use = 1; use <= mMax; use++) {
        for (kk in k.needs) remaining[kk] -= k.needs[kk];
        chosen.push({ kit: k, m: use });
        dfs(i + 1, chosen, kitCost + k.price * use);
        chosen.pop();
      }
      /* (remaining[kk] || 0): a kit needing a size the customer never asked
         for has no entry there, and undefined + 0 is NaN. */
      for (kk in k.needs) remaining[kk] = (remaining[kk] || 0) + k.needs[kk] * mMax;
    }

    dfs(0, [], 0);
    return best;
  }

  /* basket() runs several times per render; the plan depends only on the
     requested quantities, so one signature memo makes the repeats free. */
  var kitPlanMemo = { sig: null, plan: null };
  function kitPlan(baseTotal) {
    var sig = JSON.stringify(state.qty) + '|' + JSON.stringify(cartQty);
    if (kitPlanMemo.sig === sig) return kitPlanMemo.plan;
    /* ⚠ The memo is written only AFTER the search returns. Written before,
       a throw left the OLD plan filed under the NEW signature, and a later
       basket() silently priced these quantities with a plan computed for
       different ones. And the search itself fails OPEN: a bad plan is worse
       than no plan, so any error just means baseline pricing. */
    var plan = null;
    try { plan = bestKitPlan(baseTotal); } catch (e) { plan = null; }
    kitPlanMemo.sig = sig;
    kitPlanMemo.plan = plan;
    return kitPlanMemo.plan;
  }

  /* What the cart already holds, by variant id — the kit ceiling subtracts
     it. Fetched once at boot and maintained locally after each add; a page
     that never adds never refetches. */
  var cartQty = {};
  function loadCartQty() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var next = {};
        (c.items || []).forEach(function (it) {
          next[it.variant_id] = (next[it.variant_id] || 0) + it.quantity;
        });
        cartQty = next;
        kitPlanMemo.sig = null;
        render();
      })
      .catch(function () { /* no cart yet — ceilings just stay page-load */ });
  }

  /* Kit titles carry a marketing tail; the head before the first dash is the
     name — same trim the bench's short labels use. */
  function kitShortTitle(t) {
    var head = String(t).split(' | ')[0].split(' \u2013 ')[0].split(' - ')[0].trim();
    return head || String(t).trim();
  }
  function kitNames(b) {
    var out = [];
    for (var i = 0; i < b.kitSwap.kits.length; i++) {
      var kw = b.kitSwap.kits[i];
      out.push((kw.m > 1 ? kw.m + ' \u00d7 ' : '') + kitShortTitle(kw.kit.title));
    }
    return out.join(' + ');
  }

  function basket() {
    var out = { groups: [], lines: [], total: 0, units: 0 };
    eachSize(function (series, size) {
      var n = state.qty[qtyKey(series.key, size.size)] || 0;
      if (n <= 0) return;
      var sol = solve(size, n);
      if (!sol.ok || !sol.lines.length) return;
      out.groups.push({ series: series, size: size, want: n, sol: sol });
      out.total += sol.total;
      out.units += sol.delivered;
      for (var i = 0; i < sol.lines.length; i++) out.lines.push(sol.lines[i]);
    });

    var plan = kitPlan(out.total);
    if (plan && plan.total < out.total) {
      out.kitSwap = { kits: plan.kits, saving: out.total - plan.total, baseTotal: out.total };
      out.total = plan.total;
      out.groups = []; out.lines = []; out.units = 0;
      eachSize(function (series, size) {
        var kk2 = qtyKey(series.key, size.size);
        var left = plan.remaining[kk2] || 0;
        if (left <= 0) return;
        var sol2 = solve(size, left);
        if (!sol2.ok || !sol2.lines.length) return;
        out.groups.push({ series: series, size: size, want: left, sol: sol2 });
        out.units += sol2.delivered;
        for (var j = 0; j < sol2.lines.length; j++) out.lines.push(sol2.lines[j]);
      });
      for (var ki = 0; ki < plan.kits.length; ki++) {
        out.units += plan.kits[ki].kit.pieces * plan.kits[ki].m;
      }
    }
    return out;
  }

  function hasSpringParts() {
    var found = false;
    eachSize(function (series, size) {
      if (!series.needsPliers) return;
      if ((state.qty[qtyKey(series.key, size.size)] || 0) > 0) found = true;
    });
    return found;
  }

  function pliersRung() {
    var found = null;
    eachSize(function (series, size) {
      if (series.key !== 'pliers' || found) return;
      for (var i = 0; i < size.rungs.length; i++) {
        if (size.rungs[i].buyable && size.rungs[i].packQty === 1) {
          found = { series: series, size: size };
          return;
        }
      }
    });
    return found;
  }

  /* Which row was last cut back, and to what. Read by the row renderers so
     the customer is told, rather than left thinking the control is broken. */
  var clampedKey = null, clampedTo = 0;

  /* Rows still holding nothing but the quantity the PICK step put there.
     Picking a size is choosing it, not ordering one of it, and the 1 that
     lands on the bench is a placeholder saying "this one, quantity to
     follow". Pressing +10 against it gave 11, so every size had to be
     corrected by hand — Owen, 2026-09-06: "for the + buttons on the first
     initial press, add it like there's 0". Cleared by setQty, so the moment
     the customer touches a row in any way the seed stops being special and
     +10 means +10. */
  var seeded = {};

  function setQty(key, n) {
    /* ⚠ Not in save(), which render() calls on every pass — including the
       render addToCart fires immediately after setting justAdded, which would
       clear the panel before it ever painted. A quantity changing is the
       actual signal that the customer has started building again. */
    justAdded = null;
    var want = Math.max(0, Math.min(MAX_UNITS, Math.floor(n || 0)));
    var v = want;
    /* Clamp to real availability. A row can never ask for more than the
       store can ship, so the optimiser is never handed an impossible
       target and /cart/add is never sent a quantity Shopify will refuse. */
    var found = findSize(key);
    if (found) {
      var ceiling = ceilingFor(found.size);
      if (v > ceiling) v = ceiling;
    }
    /* ⚠ Silent until 2026-09-06. Adrian asked for 100 heavy-duty 3/16, got
       18, and reasonably concluded the field was broken — nothing on screen
       mentioned stock. cfg.t.max_available was written for exactly this and
       had never been read by anything. Announced only when the row CHANGES,
       so "add 10 of each size" does not read out a paragraph. */
    if (v < want) {
      if (clampedKey !== key) announce(fill(cfg.t.max_available, { '@@N@@': v }));
      clampedKey = key;
      clampedTo = v;
    } else if (clampedKey === key) {
      clampedKey = null;
    }
    delete seeded[key];
    if (v <= 0) delete state.qty[key];
    else state.qty[key] = v;
  }

  function capNote(key) {
    if (clampedKey !== key) return '';
    return '<em class="wb-kb__capnote">' +
      esc(fill(cfg.t.max_available, { '@@N@@': clampedTo })) + '</em>';
  }

  function findSize(key) {
    var parts = key.split('::');
    for (var i = 0; i < cfg.parts.length; i++) {
      if (cfg.parts[i].key !== parts[0]) continue;
      for (var j = 0; j < cfg.parts[i].sizes.length; j++) {
        if (cfg.parts[i].sizes[j].size === parts[1]) {
          return { series: cfg.parts[i], size: cfg.parts[i].sizes[j] };
        }
      }
    }
    return null;
  }

  /* Every size in the series takes part in an Unsure fill. It used to filter
     to a hard-coded list of "core" diameters, which referenced a constant
     that lived in the old view layer — the filter threw ReferenceError and
     took the whole fill down with it. The one size that genuinely deserves
     different treatment, 1/4in, is handled where that decision belongs: in
     unsure(), by halving it. */
  function presetSizes(series) {
    return series.sizes;
  }

  function buyableSize(size) {
    for (var i = 0; i < size.rungs.length; i++) if (size.rungs[i].buyable) return true;
    return false;
  }

  function unsure(seriesKey) {
    var series = null;
    for (var i = 0; i < cfg.parts.length; i++) if (cfg.parts[i].key === seriesKey) series = cfg.parts[i];
    if (!series) return;
    /* ⚠ Driven by the series' own Unsure quantity, NOT by a project type.
       The project-type question was removed in the redesign, so gating on
       state.project left every Unsure button silently inert — it rendered,
       it was pressable, and it did nothing. */
    var preset = series.unsure || 0;
    if (preset <= 0) return;

    var before = {};
    var touched = 0;
    var sizes = presetSizes(series);
    /* ⚠ Pliers are not sizes. The series' "sizes" are three different plier
       PRODUCTS (the standard H112 and two Clecall models), so filling every
       one of them put two different pairs of pliers in the kit for a customer
       who asked for one. One pair fits every size in the range, so the fill
       takes the first buyable model and stops. */
    if (series.key === 'pliers') {
      for (var pi = 0; pi < sizes.length; pi++) {
        if (buyableSize(sizes[pi])) { sizes = [sizes[pi]]; break; }
      }
    }
    for (var j = 0; j < sizes.length; j++) {
      if (!buyableSize(sizes[j])) continue;
      var key = qtyKey(series.key, sizes[j].size);
      before[key] = state.qty[key] || 0;
      /* 1/4in on the C series gets half the fill: it is a specialty size at
         three times the price, and a first-timer filling it to ten puts
         $59.50 of the size they least need into the kit. */
      var n = (series.key === 'c' && sizes[j].size === '1/4') ? Math.max(1, Math.round(preset / 2)) : preset;
      setQty(key, n);
      touched++;
    }
    if (!touched) return;
    lastUnsure = { series: series.key, before: before };
    /* The C fill is not flat — 1/4in gets half — so it cannot borrow the
       sentence the flat series use. */
    if (series.key === 'c') {
      announce(fill(cfg.t.unsure_done_c, {
        '@@N@@': preset, '@@H@@': Math.max(1, Math.round(preset / 2))
      }));
    } else if (series.key === 'pliers') {
      /* "Set every available size to N" would be a lie to a screen reader:
         the fill above deliberately touches ONE plier model and stops. */
      announce(preset === 1
        ? cfg.t.unsure_done_pliers_one
        : fill(cfg.t.unsure_done_pliers, { '@@N@@': preset }));
    } else if (series.key === 'butt') {
      announce(fill(cfg.t.unsure_done_butt, { '@@N@@': preset }));
    } else {
      announce(fill(cfg.t.unsure_done, { '@@N@@': preset }));
    }
    render();
  }

  /* Set by every state write below and cleared only when the kit reaches
     somewhere it survives — the shelf, or the cart. The leave guard reads it. */
  var dirty = false;

  /* ⚠ Arrived with a kit, rather than built one. True for ?kit= (Customise
     this kit) and ?open= (a saved kit), false for every other entry.
     It changes what the review is FOR: a walker reaches it having answered
     eight questions, so the completion chrome — the full progress bar, the
     end rule, "Nothing left to add" — is the reward. Someone who arrived
     answered nothing, and that same chrome tells them a walk they never took
     is finished, while implying there is nothing more they could add. */
  var arrivedWithKit = false;

  /* ⚠ Set ONLY by ?open= — the id of the shelf record being edited.
     Auto-save is deliberately not universal. A kit opened from a product page
     has never been saved and belongs to nobody yet; writing a shelf entry for
     every visitor who taps a stepper would fill Saved Kits with junk they did
     not ask for and churn a shelf that holds twenty. A kit reopened FROM the
     shelf is the opposite case: it is already there, already named, and not
     writing the edit back is the surprise. */
  var shelfEditId = null;
  var autosaveTimer = null;

  function autosaveShelf() {
    if (!shelfEditId) return;
    clearTimeout(autosaveTimer);
    autosaveTimer = setTimeout(function () {
      /* An emptied bench is not an edit worth keeping — it is more likely
         someone clearing up than someone saving nothing. */
      if (!basket().units) return;
      var kits = shelfRead(), at = -1;
      for (var i = 0; i < kits.length; i++) {
        if (kits[i].id === shelfEditId) { at = i; break; }
      }
      /* Deleted from another tab. Stop writing rather than resurrect it. */
      if (at < 0) { shelfEditId = null; return; }
      var nameEl = root.querySelector('[data-wb-kb-name]');
      var nm = (nameEl && nameEl.value.trim()) || (state.name || '').trim() || kits[at].name;
      var rec = shelfSnapshot(nm);
      rec.id = shelfEditId;
      kits.splice(at, 1, rec);
      if (shelfWrite(kits)) {
        dirty = false;
        savedClean = true;
        setSaveState('done');
        renderShelf();
      }
    }, 700);
  }

  /* ── the Back button ───────────────────────────────────────────────────
     beforeunload cannot carry this on its own. Chrome only draws that dialog
     when the customer has interacted with the DOCUMENT during this visit, so
     arriving on a kit and pressing Back straight away leaves in silence —
     exactly the case this guard exists for.

     So we own a history entry. One extra entry is pushed the moment the kit
     first has something in it, sitting directly above the entry the customer
     arrived on. Walking back through the steps pops the step entries the
     builder pushed itself; the FIRST Back that would take them off the end
     pops ours instead, which fires popstate — same document, page intact —
     and we can put our own dialog up.

     ⚠ One shot, deliberately. The guard disarms as it fires, so a second
     Back always gets out. A customer must never be trapped on a page by a
     dialog they have already answered. */
  var backGuard = false;

  function armBackGuard() {
    if (backGuard) return;
    try {
      history.pushState({ wbKbGuard: 1 }, '', location.href);
      backGuard = true;
    } catch (e) { /* history is unavailable — beforeunload still covers us */ }
  }

  /* Whether what is on the bench right now is exactly what is on the shelf.
     Distinct from `dirty`, which is false at boot for a kit that was never
     saved at all — this one only ever goes true after a successful write. */
  var savedClean = false;

  function save() {
    dirty = true;
    savedClean = false;
    armBackGuard();
    autosaveShelf();
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({
        v: 1, project: state.project, pliers: state.pliers,
        custom: state.custom, name: state.name, qty: state.qty, cond: state.cond,
        noPliers: !!state.noPliers
      }));
    } catch (e) { /* private mode — the wizard still works, it just forgets */ }
  }


  /* ── the shelf: kits the customer explicitly saved ─────────────────────
     TWO stores, deliberately. The in-progress bench stays in sessionStorage
     exactly as it was — render() writes it on every tap, and pointing that at
     a shared store would let a second tab overwrite a kit as it was built.
     Only an explicit Save goes to localStorage, where it survives the tab. */

  /* ⚠ The shelf lives in the MASTHEAD, which snippets/wb-kb-bar.liquid renders
     from layout/theme.liquid — outside [data-wb-kb]. el() is scoped to that
     root, so it cannot see any of it: the control stayed hidden and
     renderShelf() returned at its own guard, silently. Everything addressing
     the bar goes through dEl instead. */
  function dEl(sel) { return document.querySelector(sel); }

  var SHELF_KEY = 'wb-kb-shelf-v1';
  var SHELF_V   = 1;     /* bump when a RECORD's shape changes */
  var SHELF_MAX = 20;
  var storeOk = null;

  /* ⚠ Probed, not assumed. iOS Safari with cookies blocked and the Instagram
     and Facebook in-app browsers THROW on setItem rather than degrading, and
     that is phone traffic — the majority here. The theme already learned this
     once: assets/theme.js probes with its own test write. */
  function localOk() {
    if (storeOk !== null) return storeOk;
    storeOk = false;
    try {
      var k = SHELF_KEY + '~probe';
      window.localStorage.setItem(k, '1');
      storeOk = window.localStorage.getItem(k) === '1';
      window.localStorage.removeItem(k);
    } catch (e) { storeOk = false; }
    return storeOk;
  }

  function shelfRead() {
    if (!localOk()) return [];
    var raw = null;
    try { raw = window.localStorage.getItem(SHELF_KEY); } catch (e) { return []; }
    if (!raw) return [];
    try {
      var d = JSON.parse(raw);
      return (d && Object.prototype.toString.call(d.kits) === '[object Array]') ? d.kits : [];
    } catch (e) { return []; }   /* corrupt shelf is not worth a broken page */
  }

  /* ⚠ A VERIFIED write: set, read back, compare. save() below cannot report
     failure — its catch body is a comment — which is survivable for a kit the
     customer never asked to keep. A button that says "Saved" is a promise, so
     this one returns whether the promise is true. */
  function shelfWrite(kits) {
    if (!localOk()) return false;
    var payload = JSON.stringify({ v: SHELF_V, kits: kits });
    try {
      window.localStorage.setItem(SHELF_KEY, payload);
      return window.localStorage.getItem(SHELF_KEY) === payload;
    } catch (e) { return false; }
  }

  /* One generator, two callers: the saved-kit shelf record and the cart's
     _kit_id. There used to be a second kitId() further down — six random
     base-36 characters, no clock — which hoisted over this one and served
     both. Nothing reads the format (every use is an equality test), but the
     clock is what keeps two kits saved in the same session apart. */
  function kitId() {
    return 'k' + Date.now().toString(36) + Math.floor(Math.random() * 1679616).toString(36);
  }

  function sizeCount() {
    var n = 0;
    for (var k in state.qty) { if ((state.qty[k] || 0) > 0) n++; }
    return n;
  }

  function ageText(ts) {
    var d = Math.floor((Date.now() - (ts || 0)) / 86400000);
    if (d <= 0) return cfg.t.age_today;
    if (d === 1) return cfg.t.age_yesterday;
    if (d < 14) return fill(cfg.t.age_days, { '@@N@@': d });
    if (d < 60) return fill(cfg.t.age_weeks, { '@@N@@': Math.round(d / 7) });
    return fill(cfg.t.age_months, { '@@N@@': Math.round(d / 30) });
  }

  /* ⚠ Takes an optional timestamp. A saved kit's default name was generated
     from ITS save date, so falling back to today's would rename an old kit in
     the one place that is supposed to identify it. */
  function defaultKitName(when) {
    var d = when ? new Date(when) : new Date();
    return fill(cfg.t.kit_untitled, {
      '@@D@@': d.getDate() + ' ' + ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][d.getMonth()]
    });
  }

  /* ⚠ Quantities only. NEVER a price, a total or a stock figure: a price
     frozen at save time is a stale quote by the time it is reopened, and it is
     also the one place a parts-versus-kit comparison could leak. Money is
     resolved when the kit is opened, by the same engine as everything else. */
  function shelfSnapshot(name) {
    return {
      v: SHELF_V, id: kitId(), name: name, savedAt: Date.now(),
      pieces: basket().units, sizes: sizeCount(),
      qty: state.qty, project: state.project, pliers: state.pliers,
      custom: !!state.custom, cond: state.cond, noPliers: !!state.noPliers
    };
  }

  /* The name is the only handle on a saved kit afterwards, and on steps 1-8
     there is no name field on screen at all — so a kit saved from the walk
     could only ever be "Kit 6 Sep". defaultKitName() has exactly one value
     per day, which meant a second save on the same day ALWAYS collided with
     the first and threw up the replace dialog. Owen hit that on his second
     save, 2026-09-06. Asking once removes the collision at its source.

     ⚠ Only when there is no name yet. Someone who already typed one into the
     review's "Name this kit" field has answered this question, and asking
     again is friction on the common path. The field is pre-filled with the
     date name, so Enter is still a one-tap save.

     ⚠ Recurses through saveKit() with NO force, so a name that DOES collide
     still gets the replace dialog — the check is not skipped, only deferred.
     state.name is set by then, so it terminates. */
  function askName(after) {
    askConfirm(cfg.t.name_label, '', [
      { label: cfg.t.del_cancel },
      { label: cfg.t.savekit, primary: true, takes: true, go: function (v) {
          state.name = (v || '').trim() || defaultKitName();
          var nl = root.querySelector('[data-wb-kb-name]');
          if (nl) nl.value = state.name;
          saveKit(null, after);
        } }
    ], { value: defaultKitName(), placeholder: cfg.t.name_placeholder, label: cfg.t.name_label });
  }

  /* The first suffix nobody is using. " (2)" was hardcoded, so a third save
     from a fresh bench collided with the ORIGINAL again, took the same
     branch, and unshifted a second record also called "Kit 6 Sep (2)" —
     two shelf rows with the same name, the same counts and the same date,
     where Open, Rename, Email and Delete are all a coin flip. */
  function freeName(base, kits) {
    var taken = {}, i;
    for (i = 0; i < kits.length; i++) taken[kits[i].name] = true;
    if (!taken[base]) return base;
    for (i = 2; i < 200; i++) {
      var t = base + ' (' + i + ')';
      if (!taken[t]) return t;
    }
    return base + ' (' + Date.now().toString(36) + ')';
  }

  /* `after` runs ONLY when a write actually succeeded. Callers that do
     something destructive next — askSwap replaces the bench — must wait for
     it rather than guess at a delay. */
  function saveKit(force, after) {
    var btn = el('[data-wb-kb-savekit]');
    if (!basket().units) { setSaveState('empty'); return; }
    if (!force && !(state.name || '').trim()) { askName(after); return; }
    var name = (state.name || '').trim() || defaultKitName();
    var kits = shelfRead();                /* read-merge-write, at the click */
    var at = -1;
    for (var i = 0; i < kits.length; i++) { if (kits[i].name === name) { at = i; break; } }
    /* ⚠ Its own record is not a collision. Opening a kit by ?open= or from
       the shelf sets shelfEditId AND fills the name from that record, so
       pressing Save asked "Replace “Wing kit”? — you already have a saved
       kit with this name". They have exactly one, and it is this one. Worse,
       "Save as new" then renamed the bench to "Wing kit (2)" while autosave
       carried on writing that name over the original by id. */
    if (at >= 0 && !force && kits[at].id && kits[at].id === shelfEditId) force = 'replace';
    /* 'auto' is "save without asking, but never overwrite someone else's
       kit". askLeave used plain 'replace' so the naming dialog could not
       stack on the doorway dialog — sound intent, but 'replace' matches by
       NAME, so leaving with the default name overwrote whatever unrelated
       kit already carried it. Resolve it here, where the record in hand is
       known: this kit's own record gets updated, anything else gets a new
       one under a free name. */
    if (force === 'auto') force = (at >= 0 && kits[at].id && kits[at].id === shelfEditId) ? 'replace' : 'new';
    if (at >= 0 && !force) { askReplace(name, after); return; }
    setSaveState('saving');
    if (force === 'new') name = freeName(name, kits);
    var rec = shelfSnapshot(name);
    if (at >= 0 && force === 'replace') { rec.id = kits[at].id; kits.splice(at, 1, rec); }
    else kits.unshift(rec);
    kits.sort(function (a, b) { return (b.savedAt || 0) - (a.savedAt || 0); });
    var dropped = kits.length > SHELF_MAX;
    if (dropped) kits = kits.slice(0, SHELF_MAX);
    var wrote = shelfWrite(kits);
    if (wrote) {
      dirty = false;
      savedClean = true;
      state.name = name;
      var nf = root.querySelector('[data-wb-kb-name]');
      if (nf && nf.value !== name) nf.value = name;
      /* Autosave now maintains the record this save just created or updated,
         not whichever one happened to be open before. */
      shelfEditId = rec.id;
    }
    setSaveState(wrote ? 'done' : 'fail');
    renderShelf();
    if (wrote && after) after();
  }

  var saveTimer = null;
  var saveState = '';
  function setSaveState(st) {
    saveState = st || '';
    var btn = el('[data-wb-kb-savekit]'), lab = el('[data-wb-kb-savekit-label]');
    var fail = el('[data-wb-kb-savefail]');
    if (!btn || !lab) return;
    /* ⚠ The resting state is not always "Save kit". It used to be: 'done'
       flashed "Saved" for 2.6 seconds and then reverted, so a kit that WAS
       on the shelf sat under a button offering to save it — Owen pressed it
       again, collided with his own record, and landed in the replace dialog.
       The timer still runs; it just resolves to the truth rather than to a
       fixed label. Touch a quantity and save() clears savedClean, so it goes
       back to offering the save the moment there is one to make. */
    var resting = savedClean && basket().units;
    btn.classList.toggle('is-done', st === 'done' || (!st && resting));
    btn.classList.toggle('is-fail', st === 'fail' || st === 'empty');
    if (fail) fail.hidden = st !== 'fail';
    var wide = window.innerWidth > 749;
    lab.textContent =
      st === 'saving' ? cfg.t.savekit_saving :
      st === 'done'   ? cfg.t.savekit_done :
      st === 'fail'   ? cfg.t.savekit_fail :
      st === 'empty'  ? cfg.t.savekit_empty :
      resting         ? cfg.t.savekit_done :
      (wide ? cfg.t.savekit : cfg.t.savekit_short);
    if (saveTimer) clearTimeout(saveTimer);
    if (st === 'done' || st === 'empty') saveTimer = setTimeout(function () { setSaveState(''); }, 2600);
  }

  /* The button only exists where it can do something. Hidden outright when the
     browser will not remember, disabled on an empty bench. */
  function syncSaveBtn() {
    var btn = el('[data-wb-kb-savekit]');
    if (!btn) return;
    btn.hidden = !localOk();
    btn.disabled = !basket().units;
    /* ⚠ Repaint the resting label. save() clears savedClean the moment a
       quantity changes, but nothing was redrawing the button, so it went on
       reading "Saved" over a kit that no longer matched the shelf — the same
       lie as before, just in the other direction. Skipped while a transient
       state is on screen so this cannot stomp "Saving…" or "Could not save". */
    if (!saveState) setSaveState('');
    placeSave();
  }

  /* ⚠ On a phone the stage bar is off screen until Preview is pressed, and
     the fixed Preview/Close pill is pinned to the very corner this button
     used to occupy — so pressing Preview stacked Close on top of Save.
     Owen, 2026-09-06: "the close button looks like it is placed on top of
     another button... maybe the save kit button should go on the other
     screen." So the button MOVES to the foot bar under 1080px, where the
     kit total already lives and the walk can see it.

     Moved, never duplicated: setSaveState, syncSaveBtn and the click
     delegation all reach it with el() and closest(), and a second copy in
     the markup would be found by neither — the el()-returns-the-first-match
     trap this file has already paid for four times. */
  var saveHome = null, saveNext = null;
  function placeSave() {
    var btn = el('[data-wb-kb-savekit]'), foot = el('[data-wb-kb-foot]');
    if (!btn || !foot) return;
    if (!saveHome) { saveHome = btn.parentNode; saveNext = btn.nextSibling; }
    if (window.innerWidth <= 1080) {
      if (btn.parentNode !== foot) foot.appendChild(btn);
    } else if (btn.parentNode !== saveHome) {
      saveHome.insertBefore(btn, saveNext);
    }
  }

  function shelfRowHTML(k) {
    var dead = (k.v || 1) > SHELF_V;
    var meta = dead ? cfg.t.shelf_unreadable
      : fill(cfg.t.shelf_meta, { '@@S@@': k.sizes || 0, '@@P@@': k.pieces || 0, '@@A@@': ageText(k.savedAt) });
    return '<div class="wb-kbbar__row' + (dead ? ' is-dead is-stale' : '') + '">' +
      '<b>' + esc(k.name || '') + '</b>' +
      '<em' + (dead ? ' class="is-flag"' : '') + '>' + esc(meta) + '</em>' +
      '<span class="wb-kbbar__acts2">' +
        '<button type="button" class="wb-kbbar__rowbtn" data-wb-kb-shelfopen="' + esc(k.id) + '"' +
          (dead ? ' disabled' : '') + '>' + esc(cfg.t.shelf_open) + '</button>' +
        '<button type="button" class="wb-kbbar__rowbtn" data-wb-kb-shelfrename="' + esc(k.id) + '"' +
          (dead ? ' disabled' : '') + '>' + esc(cfg.t.shelf_rename) + '</button>' +
        '<button type="button" class="wb-kbbar__rowbtn" data-wb-kb-shelfemail="' + esc(k.id) + '"' +
          (dead ? ' disabled' : '') + '>' + esc(cfg.t.shelf_email) + '</button>' +
        '<button type="button" class="wb-kbbar__rowbtn is-del" data-wb-kb-shelfdel="' + esc(k.id) + '">' +
          esc(cfg.t.shelf_del) + '</button>' +
      '</span></div>';
  }

  function renderShelf() {
    var btn = dEl('[data-wb-kb-shelf]'), rows = dEl('[data-wb-kb-shelfrows]'), n = dEl('[data-wb-kb-shelfn]');
    if (!btn || !rows) return;
    /* ⚠ An ABSENT control means "this browser will not remember". A badge
       reading zero means "you deleted them". Never show the second for the
       first — it tells someone their kits vanished. */
    if (!localOk()) { btn.hidden = true; return; }
    var kits = shelfRead();
    /* Nothing saved, nothing to open — the control would be a button that
       opens an empty box. Clear now lives in the overflow menu, so hiding
       this one costs no route to anything. */
    btn.hidden = kits.length === 0;
    if (n) { n.hidden = kits.length === 0; n.textContent = kits.length; }
    if (!kits.length) {
      rows.innerHTML = '<div class="wb-kbbar__empty"><b>' + esc(cfg.t.shelf_none_t) + '</b>' +
        '<span>' + esc(cfg.t.shelf_none_b) + '</span></div>';
      return;
    }
    var html = '';
    for (var i = 0; i < kits.length; i++) html += shelfRowHTML(kits[i]);
    rows.innerHTML = html;
  }

  function toggleMore(force) {
    var btn = dEl('[data-wb-kb-moretoggle]'), menu = dEl('[data-wb-kb-moremenu]');
    if (!btn || !menu) return;
    var open = typeof force === 'boolean' ? force : menu.hidden;
    if (open) {
      /* A dead menu item is worse than a missing one. */
      var clr = dEl('[data-wb-kb-clearkit]');
      if (clr) clr.disabled = !basket().units;
      toggleShelf(false);
    }
    menu.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
  }

  function toggleShelf(force) {
    var btn = dEl('[data-wb-kb-shelf]'), panel = dEl('[data-wb-kb-shelfpanel]');
    if (!btn || !panel) return;
    var open = typeof force === 'boolean' ? force : panel.hidden;
    if (open) renderShelf();
    panel.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
  }

  /* ── opening a saved kit ───────────────────────────────────────────── */

  /* ⚠ Replayed through setQty, never assigned. restore() and fromLink() both
     do `state.qty = d.qty` wholesale, which bypasses ceilingFor() — fine for a
     kit saved seconds ago, wrong for one saved in August. Stock moves, and the
     bench would show pieces the cart could not supply. */
  function loadKit(k) {
    state.project = k.project || null;
    state.pliers = k.pliers || null;
    state.custom = !!k.custom;
    state.cond = k.cond || {};
    state.noPliers = !!k.noPliers;
    state.name = k.name || '';
    state.qty = {};
    var short = [];
    for (var key in (k.qty || {})) {
      var want = k.qty[key] || 0;
      if (want <= 0) continue;
      setQty(key, want);
      var got = state.qty[key] || 0;
      if (got < want) {
        var f = findSize(key);
        short.push((f && f.size && f.size.label ? f.size.label : key) + ' ' + got + '/' + want);
      }
    }
    var nameEl = root.querySelector('[data-wb-kb-name]');
    if (nameEl) nameEl.value = state.name;
    shown = {};
    revealPicked();
    render();
    var err = el('[data-wb-kb-err]');
    if (err) {
      if (short.length) {
        err.textContent = fill(cfg.t.reopen_short, { '@@K@@': k.name || '', '@@L@@': short.join(', ') });
        err.hidden = false;
      } else { err.textContent = ''; err.hidden = true; }
    }
  }

  function openKit(id, force) {
    var kits = shelfRead(), k = null;
    for (var i = 0; i < kits.length; i++) if (kits[i].id === id) { k = kits[i]; break; }
    if (!k || (k.v || 1) > SHELF_V) return;
    if (!force && basket().units) { askSwap(k); return; }
    toggleShelf(false);
    loadKit(k);
  }

  function deleteKit(id) {
    var kits = shelfRead(), out = [];
    for (var i = 0; i < kits.length; i++) if (kits[i].id !== id) out.push(kits[i]);
    shelfWrite(out);
    renderShelf();
  }

  /* ── the confirm dialog ────────────────────────────────────────────────
     position:fixed, not the stage-bound .wb-kb__modal: these are raised from
     the masthead panel as well as the bench, and the stage clips its own
     overflow. */
  var confirmEl = null, confirmGo = null;
  /* Bumped by every askConfirm. A handler that opens a NEW dialog leaves the
     counter changed, which is how the close below knows not to shut it. */
  var confirmGen = 0;
  function buildConfirm() {
    var m = document.createElement('div');
    m.className = 'wb-kb__cmodal';
    m.hidden = true;
    m.innerHTML =
      '<div class="wb-kb__mback" data-wb-kb-cno></div>' +
      '<div class="wb-kb__mcard" role="dialog" aria-modal="true" aria-labelledby="wbKbCT">' +
        /* ⚠ data-wb-kb-cno, the same hook the backdrop carries, so this needs
           no handler of its own. It duplicates the Cancel button on the
           dialogs that have one — deliberately, at Owen's call 2026-09-07.
           Escape and the backdrop already closed these, but neither is
           visible, and an invisible exit is not an exit: that lesson is
           written three comments further down this same file. */
        '<button type="button" class="wb-kb__cx" data-wb-kb-cno' +
          ' aria-label="' + esc(cfg.t.bub_close) + '">&#10005;</button>' +
        '<h3 id="wbKbCT" data-wb-kb-ct></h3>' +
        '<p data-wb-kb-cb></p>' +
        /* Rich content, for the one dialog that is a choice between two
           THINGS rather than a question about one — see askResume. Empty and
           display:none for every other caller. */
        '<div class="wb-kb__chtml" data-wb-kb-chtml></div>' +
        '<input type="text" class="wb-kb__cfield" data-wb-kb-cfield hidden>' +
        '<div class="wb-kb__cbtns" data-wb-kb-cbtns></div>' +
      '</div>';
    document.body.appendChild(m);
    confirmEl = m;
  }

  /* `opts` is for the resume dialog and nothing else: { html, wire }. The html
     goes in above the buttons and `wire` is handed that container plus a close
     function, so a control drawn inside it can act and dismiss. Everything
     else calls this with four arguments and behaves exactly as before. */
  function askConfirm(title, body, buttons, field, opts) {
    if (!confirmEl) buildConfirm();
    confirmGen++;
    el('[data-wb-kb-ct]', confirmEl).textContent = title;
    var rich = el('[data-wb-kb-chtml]', confirmEl);
    if (rich) {
      rich.innerHTML = (opts && opts.html) || '';
      rich.hidden = !(opts && opts.html);
    }
    var bodyEl = el('[data-wb-kb-cb]', confirmEl);
    bodyEl.textContent = body;
    bodyEl.hidden = !body;
    var f = el('[data-wb-kb-cfield]', confirmEl);
    if (f) {
      f.hidden = !field;
      f.type = (field && field.type) || 'text';
      f.value = (field && field.value) || '';
      f.placeholder = (field && field.placeholder) || '';
      f.setAttribute('aria-label', (field && field.label) || title);
    }
    var host = el('[data-wb-kb-cbtns]', confirmEl);
    host.innerHTML = '';
    var takes = null;
    buttons.forEach(function (b, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      /* Three styles, not two. `danger` is the red one and must stay
         reserved for destroying something — a red "Copy" or a red "Save kit
         and leave" reads as a warning about the very action the customer
         chose. `primary` is the solid navy confirm. */
      var kind = b.danger ? (b.quiet ? 'wb-kb__cwarn' : 'wb-kb__cyes')
        : (b.primary ? 'wb-kb__cgo' : 'wb-kb__cno');
      btn.className = kind + (b.wide ? ' wb-kb__cwide' : '');
      btn.textContent = b.label;
      btn.addEventListener('click', function () {
        /* A button that consumes the field may veto its own close by returning
           false, so a rejected address keeps what was typed. */
        /* ⚠ A `takes` button runs its handler BEFORE closing, so the handler
           can veto the close by returning false and keep what was typed. That
           means a handler which opens ANOTHER dialog gets it shut a line
           later: the name prompt's Save opened the replace dialog and closed
           it in the same tick, and the press vanished with nothing saved and
           no error. Introduced 2026-09-06 with the name prompt, found by the
           save-flow audit the same hour.
           The generation stamp settles it — close only if this is still the
           dialog this button was drawn in. */
        var gen = confirmGen;
        if (b.takes) {
          if (b.go && b.go(f ? f.value : '', btn) === false) return;
          if (confirmGen === gen) closeConfirm();
          return;
        }
        closeConfirm();
        if (b.go) b.go();
      });
      if (b.takes) takes = btn;
      host.appendChild(btn);
      /* ⚠ Not when a rich block is up. Focusing the first button drew a
         focus ring around it on a phone — Owen's screenshot, 2026-09-07 —
         and the first button is the one that abandons the task, so the ring
         was pointing at the wrong answer as well as being unasked for. */
      if (i === 0 && !field && !(opts && opts.html)) {
        setTimeout(function () { try { btn.focus(); } catch (e) {} }, 30);
      }
    });
    /* ⚠ AFTER the buttons exist. wire() used to run the moment the rich block
       was written, which is before this loop — so a wire that reached for its
       own Send button got null, and the "disable until both fields are filled"
       gate silently never armed. Owen found it by sending with an empty name
       (2026-09-07). A wire is handed a FINISHED dialog now. */
    if (rich && opts && opts.wire) opts.wire(rich, closeConfirm);

    if (f && field) {
      f.onkeydown = function (e) {
        if (e.key === 'Enter' && takes) { e.preventDefault(); takes.click(); }
      };
      setTimeout(function () { try { f.focus(); f.select(); } catch (e) {} }, 30);
    } else if (f) { f.onkeydown = null; }
    confirmEl.hidden = false;
  }

  function closeConfirm() { if (confirmEl) confirmEl.hidden = true; }

  /* ── the kit, drawn ────────────────────────────────────────────────────
     A JS twin of snippets/wb-kit-photo.liquid, which draws a kit in the cart
     from its own lines. That one is Liquid and reads cart.items, so it cannot
     be called for a kit that is only on the shelf — but the picture is the
     thing that tells two saved kits apart at a glance, so the dialog draws
     the same plate from a saved record's quantities.

     ⚠ The ladder, the band order and the class names are COPIED from that
     snippet on purpose, and have to stay in step with it: the styling lives in
     assets/wb-kit-band.css under .wb-kitphoto, which the cart drawer loads on
     every page. Heights fall as the count rises so the plate stays about the
     same size whether the kit is twelve pieces or nine hundred, and the bands
     run fasteners, clamps, pliers — the way a real kit is laid out to be
     photographed. */
  var PHOTO_STEPS = [12, 20, 32, 50, 80, 130, 210, 340, 550, 900];
  var PHOTO_HS    = [60, 46, 37, 30, 24, 19, 15, 12, 10,   8];

  function kitPhotoHTML(qty, plate, hmul) {
    var bands = { fastener: [], clamp: [], plier: [] }, total = 0;
    eachSize(function (series, size) {
      var n = qty[qtyKey(series.key, size.size)] || 0;
      if (n <= 0) return;
      var src = artFor(size);
      if (!src) return;
      total += n;
      /* Same two-character test the snippet uses on _art. */
      var p2 = String(size.artKey || '').slice(0, 2);
      bands[p2 === 'sg' ? 'clamp' : (p2 === 'h1' ? 'plier' : 'fastener')].push({ src: src, n: n });
    });
    if (!total) return '';

    var h = 6, i;
    for (i = 0; i < PHOTO_STEPS.length; i++) {
      if (total <= PHOTO_STEPS[i]) { h = PHOTO_HS[i]; break; }
    }
    /* The ladder is tuned for a 160px plate; a narrower one wraps the same
       pieces into more rows, so the height comes down with the square root of
       the width ratio. The Liquid takes that factor as a parameter because it
       has no sqrt; here it can just be computed. */
    h = Math.round(h * (hmul || 1));
    if (h < 4) h = 4;
    var gap = h < 20 ? 1 : 2;

    var out = '';
    ['fastener', 'clamp', 'plier'].forEach(function (band) {
      bands[band].forEach(function (g) {
        var img = '<img class="is-' + band + '" src="' + esc(g.src) + '" alt="" loading="lazy">';
        for (var c = 0; c < g.n; c++) out += img;
      });
    });
    return '<span class="wb-kitphoto" aria-hidden="true" style="--wb-piece-h:' + h +
      'px;--wb-piece-gap:' + gap + 'px;width:' + plate + 'px">' + out + '</span>';
  }

  /* The same kit as a short parts list, for the email.

     Deliberately NOT the drawn mass above. A cut-out repeated nine hundred
     times is about 180KB of markup — past the 102KB where Gmail clips a
     message and hides the button — and close to a megabyte of image requests
     on someone's phone. One thumbnail with a count says the same thing about
     the kit, survives any size of kit, and names the sizes, which a field of
     identical clecos cannot.

     Order matches the drawn photo: fasteners, then clamps, then pliers.

     ⚠ Absolute https. The config carries protocol-relative URLs, which resolve
     against the page on the storefront and against nothing at all in a mail
     client. */
  function kitItems(qty) {
    var bands = { fastener: [], clamp: [], plier: [] }, out = [];
    eachSize(function (series, size) {
      var n = qty[qtyKey(series.key, size.size)] || 0;
      if (n <= 0) return;
      var src = artFor(size);
      if (!src) return;
      var p2 = String(size.artKey || '').slice(0, 2);
      bands[p2 === 'sg' ? 'clamp' : (p2 === 'h1' ? 'plier' : 'fastener')].push({
        img: src.indexOf('//') === 0 ? 'https:' + src : src,
        label: size.short || size.label || size.size,
        series: series.label,
        n: n
      });
    });
    ['fastener', 'clamp', 'plier'].forEach(function (band) { out = out.concat(bands[band]); });

    /* ⚠ A size label is only unique WITHIN a series. A kit holding both a
       standard and a stubby 3/16 renders as two cells both reading 3/16",
       with different counts — which looks like a duplicate or a mistake
       rather than two different parts. Seen on a real kit (7 sizes, two of
       them 3/16). Qualify only the labels that actually collide, so the
       common single-series kit keeps its short clean labels. */
    var times = {};
    out.forEach(function (it) { times[it.label] = (times[it.label] || 0) + 1; });
    out.forEach(function (it) {
      if (times[it.label] > 1 && it.series) it.label = it.series + ' ' + it.label;
      delete it.series;
    });
    return out;
  }

  /* ── resume, or start fresh ─────────────────────────────────────────────
     Raised on arrival from a promo carrying ?open=<id>. Owen, 2026-09-07:
     "even if there is only 1 saved kit, give the option to choose."

     The layout is his: the kit drawn on the left, its name and Resume beside
     it, and Start a new kit under the whole block — so the choice reads as
     "this kit, or not this kit" rather than as two words of equal weight. It
     replaced a plain two-button confirm whose primary was heavier than the
     decision deserved and whose first button took a focus ring on arrival. */
  function askResume(id) {
    var kits = shelfRead(), k = null, readable = 0, i;
    for (i = 0; i < kits.length; i++) {
      if (kits[i] && (kits[i].v || 1) <= SHELF_V) readable++;
      if (kits[i] && kits[i].id === id) k = kits[i];
    }
    /* Deleted on another tab, or written by a newer builder than this one can
       read. Either way leave the customer on the clean start they already
       have rather than asking about a kit that cannot be opened. */
    if (!k || (k.v || 1) > SHELF_V) return;

    var name = k.name || defaultKitName(k.savedAt);
    var meta = fill(cfg.t.shelf_meta, {
      '@@S@@': k.sizes || 0, '@@P@@': k.pieces || 0, '@@A@@': ageText(k.savedAt)
    });
    /* 118px square at 86%: the plate lands about square at this width, the
       same trick the cart drawer's thumbnail uses at 104px and 78%. */
    var shot = kitPhotoHTML(k.qty || {}, 118, 0.86);

    var html =
      '<div class="wb-kb__rzcard">' +
        '<span class="wb-kb__rzshot">' + shot + '</span>' +
        '<span class="wb-kb__rztx">' +
          '<b class="wb-kb__rzname">' + esc(name) + '</b>' +
          '<span class="wb-kb__rzmeta">' + esc(meta) + '</span>' +
          '<button type="button" class="wb-kb__rzgo" data-wb-kb-rzgo>' +
            esc(cfg.t.resume_go) + '</button>' +
        '</span>' +
      '</div>';

    /* Start a new kit is the dialog's own button so it sits under the whole
       block, as Owen drew it. Choose another only exists when there is
       genuinely another one — a chooser holding the single kit already named
       above it is a dead end wearing a choice's clothes. */
    var buttons = [{
      label: cfg.t.resume_new, wide: true,
      /* The promo's own ?new=1 was replaced by ?open= before the link ever
         reached the browser, so this is where that instruction lands. */
      go: function () { try { sessionStorage.removeItem(STORE_KEY); } catch (e) {} }
    }];
    if (readable > 1) {
      buttons.push({ label: cfg.t.resume_other, wide: true, go: function () { toggleShelf(true); } });
    }

    askConfirm(cfg.t.resume_t, '', buttons, null, {
      html: html,
      wire: function (host, close) {
        var go = host.querySelector('[data-wb-kb-rzgo]');
        if (!go) return;
        go.addEventListener('click', function () {
          close();
          /* ⚠ Every side effect of the ?open= branch this replaced, not just
             the load. Dropping two of them was a regression an adversarial
             review caught before it shipped:
             1. shelfEditId — without it autosaveShelf() dies at its first
                guard so edits to a resumed kit never reach the shelf, and
                saveKit()'s "its own record is not a collision" test fails, so
                Save raises "Replace ...?" about the kit just opened and the
                back guard writes a duplicate.
             2. arrivedWithKit + is-editing — the editor chrome. Applied at
                boot, which has already run by the time this is answered.
             3. Navigation. restore() returning true is what used to trigger
                the jump to the review; it returns false now, and
                startStepping() has already pinned the phase to 'pick' off an
                empty bench — so without this the customer landed on the size
                chooser with the stage hidden and eight Next presses between
                them and their kit, and any stock shortfall was written into a
                review that was not on screen.
             loadKit direct rather than openKit: the record is in hand and
             already validated, so re-reading the shelf only adds a way for
             this to become a silent no-op if another tab deleted it midway. */
          arrivedWithKit = true;
          root.classList.add('is-editing');
          shelfEditId = k.id;
          toggleShelf(false);
          loadKit(k);
          /* replace, not push: matches the old boot-time jump, so Back still
             leaves the page rather than landing on a step behind the kit. */
          scrollToSec('review', { replace: true });
        });
      }
    });
  }

  function askReplace(name, after) {
    /* ⚠ A cancel, first. Both of the other two SAVE something, so a customer
       who only wanted to look at the question had no way out that did not
       write to their shelf. Escape and the backdrop both closed it already —
       neither is visible, and an invisible exit is not an exit. Owen,
       2026-09-06: "I tried to escape but it didnt let me escape." */
    askConfirm(fill(cfg.t.replace_t, { '@@K@@': name }), cfg.t.replace_b, [
      { label: cfg.t.del_cancel },
      { label: cfg.t.replace_new, go: function () { saveKit('new', after); } },
      { label: cfg.t.replace_go, danger: true, go: function () { saveKit('replace', after); } }
    ]);
  }

  function askSwap(k) {
    askConfirm(cfg.t.swap_t, fill(cfg.t.swap_b, { '@@N@@': basket().units }), [
      { label: cfg.t.swap_keep, wide: true },
      /* ⚠ Was saveKit() plus a 60ms timer. saveKit can now stop to ask for a
         name, and the timer fired straight through the dialog: the bench was
         swapped out underneath it, so whatever the customer typed was saved
         against the INCOMING kit and their own was gone. A fixed delay cannot
         outrun a dialog that waits on a person. */
      { label: cfg.t.swap_save, go: function () { saveKit(null, function () { openKit(k.id, true); }); } },
      { label: cfg.t.swap_go, danger: true, go: function () { openKit(k.id, true); } }
    ]);
  }

  /* ── share, and the guard on leaving ─────────────────────────────────
     Reachable from the masthead's ⋮ at any step, unlike the review's save
     panel, which only exists once you have walked to the end. */
  function shareKit() {
    toggleMore(false);
    var href = linkFor();
    if (!href) {
      askConfirm(cfg.t.share_kit, cfg.t.save_empty, [{ label: cfg.t.email_close }]);
      return;
    }
    askConfirm(cfg.t.share_kit, cfg.t.save_blurb, [
      { label: cfg.t.email_close },
      { label: cfg.t.save_copy, primary: true, takes: true, go: function (v) {
        var body = el('[data-wb-kb-cb]', confirmEl);
        /* Clipboard access is refused outright in some embedded views, and
           the promise rejects in others — both land on the same honest
           fallback telling the customer to copy the selected text. */
        try {
          navigator.clipboard.writeText(v).then(
            function () { if (body) body.textContent = cfg.t.save_copied; },
            function () { if (body) body.textContent = cfg.t.save_manual; }
          );
        } catch (e) { if (body) body.textContent = cfg.t.save_manual; }
        return false;
      } }
    ], { value: href, label: cfg.t.save_label });
  }

  var leaving = null;

  /* href === null means the customer pressed BACK: there is no destination to
     send them to, we just let the history go where it was already going. */
  function askLeave(href) {
    var go = function () {
      leaving = href || 'back';
      backGuard = false;
      if (href) { window.location.href = href; return; }
      /* Raised by the Back button, so there is no destination in hand. A
         single history.back() is NOT enough: the entry below the sentinel is
         usually another of the builder's own, and the customer would land
         back on the page they just asked to leave. The referrer is where
         Back was actually heading. */
      var ref = document.referrer;
      if (ref && ref.indexOf(window.location.origin) === 0 && ref.indexOf('cleco-kit-builder') < 0) {
        window.location.href = ref;
      } else {
        var exit = dEl('[data-wb-kbbar-exit]');
        window.location.href = (exit && exit.getAttribute('href')) || '/';
      }
    };
    askConfirm(cfg.t.leave_t, fill(cfg.t.leave_b, { '@@N@@': basket().units }), [
      { label: cfg.t.leave_save, primary: true, go: function () {
          /* 'replace' so leaving never opens the name-clash dialog on top of
             this one — the doorway is not the place to ask about naming.
             localStorage is synchronous, so the navigation cannot outrun it. */
          saveKit('auto');
          dirty = false;
          go();
        } },
      { label: cfg.t.leave_discard, danger: true, quiet: true, go: function () {
          /* ⚠ Empty the bench BEFORE clearing storage. Removing the key alone
             left state.qty populated, so the next render called save() and
             wrote the very kit that had just been discarded straight back. */
          state.qty = {};
          state.custom = false;
          state.name = '';
          try { sessionStorage.removeItem(STORE_KEY); } catch (e) {}
          dirty = false;
          go();
        } },
      { label: cfg.t.leave_stay, go: function () { armBackGuard(); } }
    ]);
  }


  function askClear() {
    var n = basket().units;
    if (!n) return;
    askConfirm(cfg.t.clear_t, fill(cfg.t.clear_b, { '@@N@@': n }), [
      { label: cfg.t.clear_keep },
      { label: cfg.t.clear_go, danger: true, go: function () {
          state.qty = {}; state.custom = false; state.name = '';
          var nl = root.querySelector('[data-wb-kb-name]'); if (nl) nl.value = '';
          shown = {};
          toggleShelf(false);
          /* ⚠ All the way back to "which sizes do you need?", not the
             quantities half of step one. Clearing empties the bench, and the
             count screen with nothing on it is a dead end — the first thing
             it asks is how many of sizes you no longer have. */
          if (active !== PICK_STEP) showStep(PICK_STEP, { replace: true });
          enterPick();
          render();
        } }
    ]);
  }

  function askDelete(id) {
    var kits = shelfRead(), k = null;
    for (var i = 0; i < kits.length; i++) if (kits[i].id === id) { k = kits[i]; break; }
    if (!k) return;
    askConfirm(fill(cfg.t.del_t, { '@@K@@': k.name || '' }), cfg.t.del_b, [
      { label: cfg.t.del_cancel },
      { label: cfg.t.del_go, danger: true, go: function () { deleteKit(id); } }
    ]);
  }

  function shelfFind(id) {
    var kits = shelfRead();
    for (var i = 0; i < kits.length; i++) if (kits[i].id === id) return kits[i];
    return null;
  }

  function askRename(id) {
    var k = shelfFind(id);
    if (!k) return;
    askConfirm(cfg.t.rename_t, '', [
      { label: cfg.t.del_cancel },
      { label: cfg.t.rename_go, primary: true, takes: true, go: function (v) { renameKit(id, v); } }
    ], { value: k.name || '', placeholder: cfg.t.rename_ph, label: cfg.t.rename_t });
  }

  /* Read-merge-write at the click, like saveKit — another tab may have
     changed the shelf since this panel was drawn. */
  function renameKit(id, raw) {
    var name = (raw || '').trim();
    if (!name) return;
    var kits = shelfRead(), hit = false;
    for (var i = 0; i < kits.length; i++) {
      if (kits[i].id === id) { kits[i].name = name.slice(0, 120); hit = true; break; }
    }
    if (!hit) return;
    shelfWrite(kits);
    renderShelf();
  }

  /* The share link for a kit that is NOT on the bench. linkFor() reads live
     state, so the saved record is swapped in and put straight back — nothing
     renders in between, and setQty re-applies today's stock ceilings. */
  function linkForKit(k) {
    var keep = {
      qty: state.qty, project: state.project, pliers: state.pliers,
      custom: state.custom, cond: state.cond, noPliers: state.noPliers
    };
    var nameEl = root.querySelector('[data-wb-kb-name]');
    var keepName = nameEl ? nameEl.value : null;
    var href = '';
    try {
      state.qty = {};
      state.project = k.project || null;
      state.pliers = k.pliers || null;
      state.custom = !!k.custom;
      state.cond = k.cond || {};
      state.noPliers = !!k.noPliers;
      for (var key in (k.qty || {})) setQty(key, k.qty[key] || 0);
      if (nameEl) nameEl.value = k.name || '';
      href = linkFor();
    } catch (e) { href = ''; }
    state.qty = keep.qty;
    state.project = keep.project;
    state.pliers = keep.pliers;
    state.custom = keep.custom;
    state.cond = keep.cond;
    state.noPliers = keep.noPliers;
    if (nameEl && keepName !== null) nameEl.value = keepName;
    return href;
  }

  function askEmailSaved(id) {
    var k = shelfFind(id);
    if (!k) return;
    /* Honest about being unfinished rather than a button that does nothing. */
    if (!cfg.t.email_url) {
      askConfirm(cfg.t.email_off_t, cfg.t.email_off_b, [{ label: cfg.t.email_close }]);
      return;
    }
    var href = linkForKit(k);
    if (!href) {
      askConfirm(cfg.t.emailsaved_t, cfg.t.email_empty, [{ label: cfg.t.email_close }]);
      return;
    }
    askConfirm(cfg.t.emailsaved_t, fill(cfg.t.emailsaved_b, { '@@K@@': k.name || '' }), [
      { label: cfg.t.email_close },
      { label: cfg.t.emailsaved_go, primary: true, takes: true, go: function (v, btn) {
        var addr = (v || '').trim();
        var body = el('[data-wb-kb-cb]', confirmEl);
        if (!addr || addr.indexOf('@') < 1 || addr.indexOf('.', addr.indexOf('@')) < 0) {
          if (body) body.textContent = cfg.t.email_bad;
          return false;
        }
        if (body) body.textContent = cfg.t.email_sending;
        btn.disabled = true;
        postKit(addr, href, k.name || '', k.pieces || 0, k.sizes || 0,
          kitItems(k.qty || {}), false, function (ok) {
          btn.disabled = false;
          if (body) body.textContent = ok ? cfg.t.email_done : cfg.t.email_fail;
        });
        return false;
      } }
    ], { type: 'email', value: '', placeholder: cfg.t.email_ph || '', label: cfg.t.emailsaved_t });
  }

  function fromLink() {
    var q = window.location.search;
    if (!q || q.indexOf('kit=') < 0) return false;
    var params = new URLSearchParams(q);
    var spec = params.get('kit');
    if (!spec) return false;

    var index = rungIndex();
    var kitIdx = kitContentsIndex();

    var parts = spec.split(',');
    var got = 0;
    var missing = [];
    for (var p = 0; p < parts.length; p++) {
      var bits = parts[p].split(':');
      if (bits.length !== 2) continue;
      var sku = bits[0].trim().toUpperCase();
      var n = parseInt(bits[1], 10);
      if (!sku || !n || n < 0) continue;
      var hit = index[sku];
      if (hit) {
        state.qty[hit.key] = (state.qty[hit.key] || 0) + hit.packQty * n;
        got++;
        continue;
      }
      /* A kit SKU in the link expands to its component piece counts; the
         swap pass re-selects the kit when it is still the cheapest way to
         buy them. Deterministic, so an edited kit round-trips. */
      var kc = kitIdx[sku];
      if (kc) {
        for (var kk in kc.needs) state.qty[kk] = (state.qty[kk] || 0) + kc.needs[kk] * n;
        got++;
        continue;
      }
      missing.push(bits[0].trim());
    }
    if (!got) return false;

    state.custom = true;
    state.project = state.project || 'stock';
    state.pliers = state.pliers || 'own';
    state.editingKit = params.get('kid') || null;
    state.name = params.get('name') || '';
    var nameEl = root.querySelector('[data-wb-kb-name]');
    if (nameEl && state.name) nameEl.value = state.name;
    if (missing.length) {
      var lost = fill(cfg.t.link_missing, { '@@S@@': missing.join(', ') });
      announce(lost);
      /* ⚠ announce() is a visually-hidden live region — screen readers hear
         it, sighted customers do not. A dropped SKU here is pieces missing
         from a kit someone came back to EDIT, so it goes in the visible error
         line too. */
      var errEl = el('[data-wb-kb-err]');
      if (errEl) { errEl.textContent = lost; errEl.hidden = false; }
    }

    /* The name comes from the cart, not the link: Liquid hands back line item
       properties HTML-escaped, so a name round-tripped through the URL would
       arrive as "John&#39;s Cleco Kit". The cart's own JSON has the real
       characters. Async and best-effort — the kit is already usable without
       it, so a failed lookup just leaves the field empty. */
    if (state.editingKit) {
      var routes = (window.FoxTheme && FoxTheme.routes) || {};
      fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          for (var i = 0; i < cart.items.length; i++) {
            var pr = cart.items[i].properties;
            if (pr && pr._kit_id === state.editingKit && pr._kit_name) {
              state.name = pr._kit_name;
              if (nameEl) nameEl.value = state.name;
              save();
              return;
            }
          }
        })
        .catch(function () {});
    }
    return true;
  }

  /* The id a promo asked us to reopen, held until the page can ask about it. */
  var pendingOpen = null;

  /* Drop one query parameter from the address bar, keeping the rest and the
     hash. Both entry flags are instructions for the ARRIVAL — leaving either
     in place means every refresh re-fires it, which is how a 50-piece kit was
     lost to ?new=1 (Owen, 2026-09-07). */
  function stripParam(name) {
    try {
      var keep = window.location.search.replace(/^\?/, '').split('&')
        .filter(function (part) {
          return part && part.split('=')[0] !== name;
        }).join('&');
      history.replaceState(history.state, '',
        window.location.pathname + (keep ? '?' + keep : '') + window.location.hash);
    } catch (e) { /* history unavailable — the flag just repeats */ }
  }

  function restore() {
    /* ⚠ An entry point carrying ?new=1 means "start a new kit". Every promo
       placement appends it (see snippets/wb-kb-promo.liquid). Without it a
       shopper who clicked the mega-menu tile landed in the middle of a
       half-built kit from earlier in the same tab, on the counting screen,
       with no way to tell where it had come from. sessionStorage is cleared
       here rather than merely ignored, or the ghost returns on the next
       plain visit. */
    /* ?open=<id> — a resume link from one of the promos. Applied straight to
       state rather than through loadKit(), because restore() runs before
       `active` is set and loadKit() renders. Mirrors the session branch below. */
    var wantOpen = /[?&]open=([^&]+)/.exec(window.location.search);
    if (wantOpen) {
      /* ⚠ Remembered, NOT opened. This used to load the kit on sight, and
         that is the whole reason there was no way to start a fresh one:
         assets/wb-kb-resume.js rewrites every generic promo on the site from
         ?new=1 to ?open=<newest kit> the moment a single kit is saved, so the
         fresh-start link the promo would otherwise carry no longer exists
         anywhere. askResume() puts the choice back — see the boot sequence,
         which raises it once the page is standing up.

         ⚠ And the session copy is skipped rather than restored, so the bench
         behind the dialog is empty and neither answer destroys something the
         customer can still see. Not cleared, though: "Start a new kit" clears
         it, and only then. */
      pendingOpen = decodeURIComponent(wantOpen[1]);
      /* Out of the URL for the same reason ?new=1 is: it is an instruction
         for the arrival, and left in place it re-asks on every refresh. */
      stripParam('open');
      return false;
    }

    if (window.location.search.indexOf('new=1') >= 0) {
      try { sessionStorage.removeItem(STORE_KEY); } catch (e) {}
      /* ⚠ And take the flag OUT of the URL, because it is an instruction for
         the ARRIVAL and not a property of the page. It used to survive: every
         promo placement appends it, startStepping's replaceState only ever
         writes a hash (which keeps the query), so the whole session sat on
         ".../cleco-kit-builder?new=1" — and every refresh, every tab restore,
         every back-forward that re-ran the boot wiped the kit the customer
         had just spent ten minutes building. Owen lost a 50-piece kit to it,
         2026-09-07. Reproduced and fixed here: honour it once, then forget it. */
      stripParam('new');
      return false;
    }

    /* A link is an explicit instruction and beats whatever the session
       remembers — otherwise clicking "Edit kit" would silently reopen the
       last kit instead of the one the customer asked for. */
    /* ⚠ Returns TRUE, and that is the whole point. The caller does
       `if (restored) scrollToSec('review')`, and every path here used to
       return undefined — so a customer arriving on a ?kit= link landed on
       step 1 with no sign their kit had been read. On the PDP band's
       "Customise this kit" that reads as a dead button. */
    if (fromLink()) { arrivedWithKit = true; return true; }

    var raw;
    try { raw = sessionStorage.getItem(STORE_KEY); } catch (e) { return; }
    if (!raw) return;
    try {
      var d = JSON.parse(raw);
      if (!d || d.v !== 1) return;
      state.project = d.project || null;
      state.pliers = d.pliers || null;
      state.custom = !!d.custom;
      state.name = d.name || '';
      state.qty = d.qty || {};
      state.noPliers = !!d.noPliers;
      state.cond = d.cond || {};
    } catch (e) { /* corrupt state is not worth a broken page */ }

    var nameEl = root.querySelector('[data-wb-kb-name]');
    if (nameEl && state.name) nameEl.value = state.name;
    for (var c in state.cond) {
      if (state.cond[c]) openCond(c, true);
    }
  }

  function clearEditedKit() {
    if (!state.editingKit) return Promise.resolve();
    var routes = (window.FoxTheme && FoxTheme.routes) || {};
    return fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        var found = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (it.properties && it.properties._kit_id === state.editingKit) {
            updates[it.key] = 0;
            found++;
          }
        }
        if (!found) return null;
        return fetch(routes.cart_update_url || '/cart/update', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .catch(function () {
        /* A failed clear must not block the add — the customer still gets the
           kit they built, and a duplicate they can remove beats a silent
           no-op that looks like the button is broken. */
        return null;
      });
  }

  function addToCart() {
    var b = basket();
    /* A fully-covered request has NO component lines — the kit is the whole
       cart payload — so the guard has to accept a kit-only basket. */
    if (!b.lines.length && !(b.kitSwap && b.kitSwap.kits.length)) return;

    /* ⚠ data-wb-kb-addcart, not data-wb-kb-add. The CTA's attribute was
       renamed when the quick-chips collision was fixed, and this selector was
       left matching the first +5 chip — so the actual button was never
       disabled, and a double-click posted the whole kit twice. */
    var btn = root.querySelector('[data-wb-kb-addcart]');
    var err = root.querySelector('[data-wb-kb-err]');
    if (err) { err.hidden = true; err.textContent = ''; }
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    announce(state.editingKit ? cfg.t.updating : cfg.t.adding);

    var nameEl = root.querySelector('[data-wb-kb-name]');
    var name = (nameEl && nameEl.value.trim()) || cfg.t.default_name;
    var id = kitId();

    /* Walked by GROUP rather than by line so each line still knows the SIZE it
       came from — the cart band needs that to redraw the kit, and solve()'s
       output is cached, so hanging the art off the line objects would be
       writing into a shared cache. Same lines either way. */
    var items = [];
    for (var gi = 0; gi < b.groups.length; gi++) {
      var g = b.groups[gi];
      for (var li = 0; li < g.sol.lines.length; li++) {
        var ln = g.sol.lines[li];
        items.push({
          id: ln.rung.id,
          quantity: ln.count,
          properties: {
            _source: 'cleco-builder', _kit_id: id, _kit_name: name,
            /* The cut-out KEY and how many pieces one unit of this line is.
               Both are what the cart band needs to draw the kit as a photo:
               the key resolves to an asset wherever it is rendered, and
               pieces-per-unit stays correct if the quantity is edited later
               (a stored TOTAL would not). */
            _art: g.size.artKey || '',
            _pack: String(ln.rung.packQty)
          }
        });
      }
    }

    /* The optimiser's kit swaps ride the same atomic items[] and the same
       _kit_id, so the band, removal and rollback already cover them.
       _art is blank ON PURPOSE — wb-kit-photo falls back to the line's own
       product image, which for a kit line IS the kit photo — and _pack is
       "1", never the piece count: the photo draws _pack x quantity copies of
       that image, and "87" would tile 87 Deluxe-kit boxes. */
    if (b.kitSwap) {
      for (var kx = 0; kx < b.kitSwap.kits.length; kx++) {
        var kw = b.kitSwap.kits[kx];
        items.push({
          id: kw.kit.id,
          quantity: kw.m,
          properties: { _source: 'cleco-builder', _kit_id: id, _kit_name: name, _art: '', _pack: '1' }
        });
      }
    }

    var sections = [];
    document.dispatchEvent(new CustomEvent('cart:grouped-sections', { detail: { sections: sections } }));

    /* Editing an existing kit REPLACES it. The old lines are zeroed first and
       only then is the new set added, so a customer who edits twice does not
       end up with three copies of their kit in the cart. Clearing first also
       means a size dropped during the edit actually disappears. */
    clearEditedKit()
      .then(function () {
        return fetch((window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({
            items: items,
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        });
      })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok || (res.data && res.data.status)) {
          throw new Error((res.data && res.data.description) || cfg.t.add_failed);
        }
        /* Fold what was just posted into the local cart picture, so the
           NEXT build's kit ceilings already know about it without a refetch. */
        for (var pi = 0; pi < items.length; pi++) {
          cartQty[items[pi].id] = (cartQty[items[pi].id] || 0) + items[pi].quantity;
        }
        kitPlanMemo.sig = null;
        /* ⚠ Snapshot BEFORE state.qty is thrown away, and take a copy rather
           than the live object: renderDone draws its counts from this, and
           "Save this kit" writes it to the shelf, both after the bench has
           been emptied. `b` is the basket measured at the top of this
           function, so its totals are the ones that were actually posted. */
        var snap = {};
        for (var sk in state.qty) if (state.qty.hasOwnProperty(sk)) snap[sk] = state.qty[sk];
        justAdded = {
          name: name, id: id, qty: snap,
          lines: items.length, pieces: b.units, total: b.total, saved: false
        };
        state.qty = {};
        state.custom = false;
        state.editingKit = null;
        /* ⚠ The name goes with the kit it named. It never used to be cleared,
           which did not show while the customer was left on an emptied review
           — but "Build another kit" now hands them that field again, and a
           second kit pre-filled "Wing rib kit" would collide with the first
           on the shelf the moment they pressed Save. justAdded.name keeps it
           for the panel, so nothing is lost. */
        state.name = '';
        var nameField = root.querySelector('[data-wb-kb-name]');
        if (nameField) nameField.value = '';
        try { sessionStorage.removeItem(STORE_KEY); } catch (e) {}
        dirty = false;
        render();
        /* ⚠ Take the customer back to the top, where the confirmation now is.
           The review they were reading was long enough to scroll — a full kit
           runs several screens — and the panel that replaces it is one card at
           the very top, so adding to the cart left them looking at blank space
           with the confirmation off screen above them. Owen, 2026-09-07.

           ⚠ Before the cart:refresh below, not after: the drawer locks the
           body when it opens, and a scroll issued against a locked body is
           either ignored or restored to where the lock was taken.

           ⚠ Instant, not smooth. <html> carries scroll-behavior:smooth from
           the theme, and an animated scroll would still be in flight when the
           drawer takes that lock. Phones only — desktop keeps the review
           beside the bench, so the panel is already in view. */
        if (window.innerWidth <= 1080) {
          try { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); }
          catch (e) { window.scrollTo(0, 0); }
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      })
      .catch(function (e) {
        /* ⚠ A failed add is not proof that nothing was added. /cart/add with
           items[] is atomic on Shopify's side today, but the request can also
           fail after a partial mutation (network drop mid-response, a retry),
           and this kit's lines are identifiable — so roll back anything
           carrying THIS kit id before reporting. The customer's quantities
           are deliberately left intact: losing a twenty-line kit to a
           transient error is a far worse outcome than a duplicate. */
        rollback(id).then(function () {
          if (err) {
            err.textContent = (e && e.message) ? e.message : cfg.t.add_failed;
            err.hidden = false;
          }
          announce(cfg.t.add_failed);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      });
  }

  function rollback(id) {
    var routes = (window.FoxTheme && FoxTheme.routes) || {};
    return fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        var found = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (it.properties && it.properties._kit_id === id) { updates[it.key] = 0; found++; }
        }
        if (!found) return null;
        return fetch(routes.cart_update_url || '/cart/update', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .catch(function () { return null; });
  }

  function addKitProduct(variantId) {
    var btn = root.querySelector('[data-wb-kb-addkit]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    announce(cfg.t.adding);

    var sections = [];
    document.dispatchEvent(new CustomEvent('cart:grouped-sections', { detail: { sections: sections } }));

    fetch((window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1, properties: { _source: 'cleco-builder' } }],
        sections: sections.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok || (res.data && res.data.status)) {
          throw new Error((res.data && res.data.description) || cfg.t.add_failed);
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      })
      .catch(function (e) {
        /* Visible, not only announced: the previous version put this in the
           live region alone, so a sighted customer saw the button flicker and
           nothing else happen. */
        var card = root.querySelector('[data-wb-kb-fastcard]');
        if (card) {
          var msg = card.querySelector('.wb-kb__err');
          if (!msg) {
            msg = document.createElement('p');
            msg.className = 'wb-kb__err';
            card.appendChild(msg);
          }
          msg.textContent = (e && e.message) ? e.message : cfg.t.add_failed;
          msg.hidden = false;
        }
        announce(cfg.t.add_failed);
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      });
  }

  /* ══ view ══════════════════════════════════════════════════════════════
     Everything below paints. Nothing below decides what a part costs, what
     is buyable, or which SKUs a quantity resolves to — that is the engine
     above, and it stays the single source of truth for money and stock. */

  var CAP = 50;              /* past this a group shows a boundary and a count */
  var MAX_Z = 2;             /* how far the bench may grow when it is nearly empty */
  var WIDE_PER = 24;         /* pieces per line while the bench runs full-bleed */
  var BOARD_H = 76;          /* piece height on the active section */
  var BOARD_SMALL = 30;      /* ... and on a section already behind you */
  var DUR = 460;
  var EASE = 'cubic-bezier(.22,.9,.25,1)';

  var active = null, trayOpen = false, modalSec = null;
  var lastRemoved = null, undoTimer = null, typeTimer = null;
  /* Which steps have already typed. A step animates ONCE per page load: come
     back to it — scrolling up, or the trigger line crossing it again on the
     way down — and it is simply already written. A scalar "the step we typed
     last" was not enough, because scrolling up genuinely changes the active
     step, so the guard passed and the sentence unwrote itself and retyped. */
  var typedOnce = {};
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function el(sel, ctx) { return (ctx || root).querySelector(sel); }
  function all(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  function seriesOf(key) {
    for (var i = 0; i < cfg.parts.length; i++) if (cfg.parts[i].key === key) return cfg.parts[i];
    return null;
  }

  function unitPrice(size) {
    /* The single is the honest per-unit figure to show on a row; the packs
       are what the optimiser reaches for once a quantity justifies them. */
    for (var i = 0; i < size.rungs.length; i++) {
      if (size.rungs[i].buyable && size.rungs[i].packQty === 1) return size.rungs[i];
    }
    for (var j = 0; j < size.rungs.length; j++) if (size.rungs[j].buyable) return size.rungs[j];
    return size.rungs[0] || null;
  }

  function artFor(size) {
    if (size.art) return size.art;
    /* ⚠ The SINGLE's photo, then anything. Rungs arrive biggest-pack-first, so
       the old "first rung with an image" handed back a pack shot — the butt
       clamp thumbnail was a photograph of sixteen clamps in a grid, drawn at
       34px wherever one clamp belonged. Same reasoning as unitPrice(): the
       single is what a row is a picture OF. */
    for (var i = 0; i < size.rungs.length; i++) {
      if (size.rungs[i].packQty === 1 && size.rungs[i].image) return size.rungs[i].image;
    }
    for (var j = 0; j < size.rungs.length; j++) if (size.rungs[j].image) return size.rungs[j].image;
    return null;
  }

  /* Whether that thumbnail is a hand-made cut-out or a raw product photo.
     A cut-out is transparent and sits on any surface; a photo carries an
     opaque white square that has to be blended away. Four series have no
     cut-outs at all (cwnl, chn, chnl, butt), so this is not a rare path. */
  function artIsPhoto(size) { return !size.art && !!artFor(size); }

  /* One thumbnail, one decision. Every wrapper that can hold a product photo
     wears `is-photo`, and the stylesheet does the rest — the class carries
     both halves of the treatment (blend the white away, and keep a pale face
     under it so the blend has something light to work against, which matters
     in dark mode where the panel is nearly black). Owen, 2026-09-05: "some of
     the images have failed to mask. The white background is shown on top of
     the grey." */
  function artCell(cls, size, h, extra) {
    var src = size ? artFor(size) : null;
    return '<span class="' + cls + (src && artIsPhoto(size) ? ' is-photo' : '') + '">' +
      (src ? '<img src="' + esc(src) + '" alt="" height="' + h + '" loading="lazy">' : '') +
      (extra || '') +
    '</span>';
  }

  /* ── the steps on the right ───────────────────────────────────────── */

  function optRow(series, size) {
    var key = qtyKey(series.key, size.size);
    var n = state.qty[key] || 0;
    var rung = unitPrice(size);
    var sub = [];
    /* Millimetres FIRST, then the drill. They answer different questions —
       what size is this in the units I measure in, and what do I drill to fit
       it — and someone here usually needs both. Millimetres lead because they
       convert the inch label directly above them; the drill number follows,
       which is also the order the job happens in. */
    if (size.mm) sub.push(fill(cfg.t.mm_line, { '@@M@@': esc(size.mm) }));
    if (size.drill) sub.push(fill(cfg.t.drill_line, { '@@D@@': esc(size.drill) }));
    if (series.showGrip && size.grip) sub.push(esc(size.grip));

    var quick = '';
    if (series.quick && series.quick.length) {
      quick = '<span class="wb-kb__quick">' + series.quick.map(function (q) {
        return '<button type="button" class="wb-kb__q" data-wb-kb-add="' + esc(key) + '" ' +
          'data-wb-kb-amt="' + q + '">' + fill(cfg.t.quick_add, { '@@N@@': q }) + '</button>';
      }).join('') + '</span>';
    } else if (series.bulk > 0) {
      quick = '<button type="button" class="wb-kb__ten" data-wb-kb-add="' + esc(key) + '" ' +
        'data-wb-kb-amt="' + series.bulk + '">' + fill(cfg.t.add_n, { '@@N@@': series.bulk }) + '</button>';
    }

    var buyable = buyableSize(size);
    return '<div class="wb-kb__opt' + (n > 0 ? ' is-on' : '') + (buyable ? '' : ' is-out') + '" ' +
        'data-wb-kb-opt="' + esc(key) + '">' +
      /* ⚠ Emitted empty and filled by syncRows, NOT by this function.
         buildLists() runs once at boot, so a number baked in here would be
         the quantity at page load for the rest of the session. Owen's ask
         was specifically that it track the stepper live. */
      artCell('wb-kb__optart', size, 52,
        '<b class="wb-kb__optbadge" data-wb-kb-badge="' + esc(key) + '" hidden></b>') +
      '<span class="wb-kb__optbody">' +
        '<span class="wb-kb__optname">' + esc(size.label) + '</span>' +
        '<span class="wb-kb__optsub">' + sub.join(' &middot; ') + '</span>' +
        /* ⚠ rung.stateHtml, not size.stateHtml. The Liquid emits this on each
           RUNG (it is a per-variant fact) and the row read it off the size,
           which has no such property — so the "Low stock — only 3 left"
           ladder the PDP shows has never once rendered here. Reading it from
           the row's own rung is what tells someone there are 18 before they
           type 100. */
        '<span class="wb-kb__optstate">' + rowState(rung) + '</span>' +
        '<span class="wb-kb__optprice">' + (rung ? esc(rung.priceText) : '') + '</span>' +
      '</span>' +
      (buyable
        ? '<span class="wb-kb__optctl">' +
            stepperHTML(key, size.label) + quick + capNote(key) +
          '</span>' +
          rowRemove(key, size.label, false)
        : '<span class="wb-kb__optout">' + esc(cfg.t.sold_out) + '</span>') +
    '</div>';
  }

  /* The stock ladder, but only the half that changes a decision. Owen,
     2026-09-06: "no need to show stock availability in the builder. Only if
     insufficient stock then tell user the reason." A row reading "In Stock,
     1,000+ available" is reassurance nobody asked for on a page where every
     row would say it; "Low stock, only 18 left" is the reason a quantity is
     about to be cut back, and worth saying BEFORE it happens rather than
     only in the clamp note afterwards.
     wb-cleco-state's ladder is ok / low / note / bad — this drops `ok` and
     keeps the other three. */
  function rowState(rung) {
    var html = (rung && rung.stateHtml) || '';
    return html.indexOf('wb-kb__state ok') >= 0 ? '' : html;
  }

  function stepperHTML(key, label) {
    return '<span class="wb-kb__step">' +
      '<button type="button" data-wb-kb-dec="' + esc(key) + '" aria-label="' + esc(label) + ' &minus;">&minus;</button>' +
      '<input type="text" inputmode="numeric" value="0" data-wb-kb-in="' + esc(key) + '" ' +
        'aria-label="' + esc(label) + '">' +
      '<button type="button" data-wb-kb-inc="' + esc(key) + '" aria-label="' + esc(label) + ' +">+</button>' +
    '</span>';
  }

  /* Two glyphs for one action, because the visible consequence differs. In a
     step list the row stays and its count returns to zero, so a bin reads
     right. In the review the row VANISHES, and a cross is what people already
     read as "take this off the list". */
  function rowRemove(key, label, asCross) {
    var glyph = asCross
      ? '<path d="M4 4l8 8M12 4l-8 8"/>'
      : '<path d="M2.5 4h11M6.5 4V2.5h3V4M4 4l.7 9.5h6.6L12 4M6.5 7v4M9.5 7v4"/>';
    return '<button type="button" class="wb-kb__rowx' + (asCross ? ' is-cross' : '') + '" ' +
      'data-wb-kb-rowclear="' + esc(key) + '" ' +
      'aria-label="' + esc(fill(cfg.t.remove_row, { '@@S@@': label })) + '">' +
      '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" ' +
      'stroke-width="1.8" stroke-linecap="round" aria-hidden="true">' + glyph + '</svg></button>';
  }

  function buildLists() {
    for (var i = 0; i < cfg.parts.length; i++) {
      var s = cfg.parts[i];
      var host = el('[data-wb-kb-list="' + s.key + '"]');
      if (!host) continue;
      var html = '';
      for (var j = 0; j < s.sizes.length; j++) html += optRow(s, s.sizes[j]);
      host.innerHTML = html;
    }
  }

  /* ── the bench ────────────────────────────────────────────────────── */

  /* Two shapes, because the bench has two jobs.

     The square-ish block below is right for the compact corner the bench
     settles into once the walk moves on: several cells share the stage and a
     long thin strip would waste the height. But on the C-series quantities
     step the bench owns the whole page, and there the same formula wrapped a
     run of eight clecos into two stubby rows — it is driven purely by the
     count and never once looks at the room available. Wide mode simply runs
     the pieces out in ONE line until there are more than a line can hold;
     fitBoard() then scales whatever that comes to. */
  function perLine(n, wide) {
    if (wide) return Math.min(n, WIDE_PER);
    return Math.min(16, Math.max(5, Math.ceil(Math.sqrt(n) * 1.45)));
  }

  /* The plate leads with the COUNT and carries the SHORT label.

     Count first because the heading directly above already names the series,
     so the number is the only thing on the plate the reader does not already
     know — and because the swatch is conditional (it comes from the size-guide
     metaobject and is blank for some sizes), leading with <u> is the only way
     every plate in a cell starts at the same left edge. The swatch stays with
     the label: it is that SIZE's colour, not the count's.

     Short label because the plate is white-space:nowrap inside a board that
     fitBoard() scales to fit — a 67-character plier title did not merely look
     bad, it widened the bench and shrank every part on it. The option rail and
     the review keep the FULL title; that is where a customer decides what to
     buy. Falls back to label so a size emitted before "short" existed draws. */
  function groupHTML(series, size, n, wide) {
    var art = artFor(size);
    if (!art) return '';
    var capped = n > CAP, shown = capped ? CAP : n, per = perLine(shown, wide);
    var lines = '';
    for (var i = 0; i < shown; i += per) {
      var row = '';
      for (var j = i; j < Math.min(i + per, shown); j++) {
        row += '<img src="' + esc(art) + '" alt="" loading="lazy">';
      }
      lines += '<span class="wb-kb__line">' + row + '</span>';
    }
    /* A size that carries its own scale (drill stops: 34 mm for a #40, 60 mm
       for a 1/4) overrides the cell's series-wide one for its own pieces —
       the stylesheet reads --wb-kb-sc off the nearest ancestor. */
    var sc = Number(size.scale) > 0 ? ' style="--wb-kb-sc:' + Number(size.scale) + '"' : '';
    return '<div class="wb-kb__grp' + (capped ? ' is-capped' : '') +
      (artIsPhoto(size) ? ' is-photo' : '') +
      '"' + sc + ' data-wb-kb-grp="' + esc(qtyKey(series.key, size.size)) + '">' +
      '<div class="wb-kb__rows">' + lines +
        (capped ? '<span class="wb-kb__cap">&times;' + n + '</span>' : '') + '</div>' +
      '<span class="wb-kb__plate">' +
        '<u>&times;' + n + '</u>' +
        (size.swatch ? '<s style="background:' + esc(size.swatch) + '"></s>' : '') +
        '<b>' + esc(size.short || size.label) + '</b></span>' +
    '</div>';
  }

  /* Every section keeps its place. The one in hand is drawn large; the rest
     shrink and settle, so nothing is thrown away as you move on. */
  function cellHTML(series, isActive) {
    var body = '', n = 0;
    for (var i = 0; i < series.sizes.length; i++) {
      var q = state.qty[qtyKey(series.key, series.sizes[i].size)] || 0;
      /* Only the cell in hand spreads out: an inactive cell is a thumbnail
         off to the side, where a 24-wide line would be a hairline. */
      if (q > 0) { body += groupHTML(series, series.sizes[i], q, isActive && isCountList()); n += q; }
    }
    if (!body) return '';
    return '<div class="wb-kb__cell' + (isActive ? ' is-active' : '') + '" ' +
        /* Drawn size relative to a standard cleco — see the Liquid that emits
           it. Multiplied into --h by the stylesheet, so the active/inactive
           sizes and the hero all scale together. */
        'style="' + jitterFor(series.key) + ';--wb-kb-sc:' + (Number(series.scale) > 0 ? Number(series.scale) : 1) + '" ' +
        'data-wb-kb-cell="' + esc(series.key) + '" role="button" tabindex="0" ' +
        'aria-label="' + esc(series.label) + '">' +
      /* ⚠ "25 pieces", never a bare "25". The bare number sat immediately
         above the first size row, so a customer who had just typed 20 of one
         size read the group total as that row's count and thought they had
         mis-keyed it. The word is what disambiguates; the stylesheet also
         pushes it to the far edge of the card header, away from the rows. */
      '<div class="wb-kb__celltop"><span class="wb-kb__cellname">' + esc(series.label) + '</span>' +
        '<span class="wb-kb__celln">' +
          esc(n === 1 ? cfg.t.cell_one : fill(cfg.t.cell_pieces, { '@@N@@': n })) +
        '</span></div>' +
      '<div class="wb-kb__cellbody">' + body + '</div>' +
    '</div>';
  }

  function boardHTML() {
    var out = '';
    for (var i = 0; i < cfg.parts.length; i++) {
      out += cellHTML(cfg.parts[i], cfg.parts[i].key === active);
    }
    /* The cue points AT the list rather than just meaning "add": a bare +
       says something can be added but not where from, which is the one
       thing an empty bench has to answer. CSS turns it down 90 degrees
       below 1080px, where the list sits under the bench instead of beside
       it — so the arrow is never pointing at nothing. */
    /* An empty state, not a signpost. The nudging arrow badge and the dashed
       frame earned their place when the walk was a scroll and the list was off
       to the side; one step at a time they point at the only other thing on
       screen. */
    /* ⚠ Inside the board, not in the chrome around it: on a phone the board
       is the scrolling list, so a hint anywhere else would sit still while
       the thing it describes moved. The stylesheet shows it on the phone's
       preview only — every cell has been tappable at every width since the
       bench was built, but it is only there that tapping is the ONLY way to
       change a quantity, the walk being off screen.
       Not on an empty bench: there is nothing to tap, and the empty state
       already says what to do. */
    if (out) out = '<div class="wb-kb__benchhint">' + esc(cfg.t.bench_tap) + '</div>' + out;
    /* ⚠ The empty bench has two meanings now, and only one of them is "you
       have not started". Beside a panel saying the kit is in the cart,
       "Your kit is empty" reads as a contradiction. The second line still
       holds either way — a size added now really does appear here. */
    var emptyT = justAdded ? cfg.t.done_bench : cfg.t.board_empty_t;
    return out || '<div class="wb-kb__prompt"><div class="wb-kb__promptbox">' +
      '<b>' + esc(emptyT) + '</b>' +
      '<span>' + esc(cfg.t.board_empty_b) + '</span></div></div>';
  }

  /* Measure unscaled at the width it will get, then scale to fit. Adding
     parts shrinks the whole kit rather than pushing it off the edge. */
  /* How far down the viewport the site's pinned chrome reaches. This used to
     be MEASURED here — a scroll/rAF/ResizeObserver rig reading
     getBoundingClientRect() off whatever was sticky — and it was wrong by
     design: the mobile header collapses its search row by TRANSFORM,
     deliberately keeping its layout height (see assets/wb-header-metrics.js),
     so no box anywhere changes when the header condenses. Every event fired
     and every reading said 141px; the bench sat low with a gap above it.

     --wb-kb-top now lives entirely in the stylesheet, derived from the
     theme's own contract (--wb-header-h, minus --search-row-height under
     html.header-search-collapsed). Nothing here writes it any more — an
     inline setProperty would beat those stylesheet rules and pin the stale
     value right back.

     This helper only RESOLVES the value for scroll arithmetic. Read the
     computed `top` of whichever builder element is currently sticky: for a
     real property the calc() collapses to a px length at computed-value
     time, whereas the custom property itself keeps its calc() unresolved and
     parseInt would see NaN. */
  function stickyTop() {
    var els = [el('.wb-kb__stagecol'), el('.wb-kb__stage')];
    for (var i = 0; i < els.length; i++) {
      if (!els[i]) continue;
      var cs = window.getComputedStyle(els[i]);
      if (cs.position !== 'sticky') continue;
      var v = parseFloat(cs.top);
      if (!isNaN(v)) return v;
    }
    return 0;
  }

  /* ── expanding one pane into the other's space ──────────────────────────
     A phone shows the bench and the walk stacked, and either one can take
     the whole screen below the site header. Which pane is showing is a CLASS
     on the split — the sizes themselves live in the stylesheet, so this only
     ever names a state.

     The walk gets its own toggle rather than both living on the bench: with
     the walk expanded the bench is not rendered, so a control up there could
     never bring the split back. */
  var VIEWS = { stage: 'is-stage-full', flow: 'is-flow-full' };
  var view = '';
  var stageMark = 0;

  /* ⚠ The expanded bench is FIXED, so it needs the header's real BOTTOM —
     which is NOT the same as its height. An announcement bar sits above the
     header and scrolls away, so once the page has moved the two agree; at the
     very top of the page the header is pushed down and they do not. Expanding
     the bench removes the walk, which collapses the document to about one
     screen and forces the scroll back to zero — landing on exactly the case
     where they disagree. Pinning at the height instead put 23px of the
     collapse button underneath the header, with nothing to scroll, so the
     only way out of the expanded view was unreachable.

     This does NOT reintroduce the measurement rig that was removed: that one
     re-read the header's HEIGHT on every scroll to catch a condense that
     never changes any box. This reads a POSITION once, on entry, at a moment
     when there is nothing left to scroll — so it cannot go stale. It writes
     its own property and never touches --wb-kb-top, which stays pure CSS. */
  function pinBench() {
    var cands = ['.header-section', 'header.header', '.header__top'];
    for (var i = 0; i < cands.length; i++) {
      var h = document.querySelector(cands[i]);
      if (!h) continue;
      var cs = window.getComputedStyle(h);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
      var r = h.getBoundingClientRect();
      /* Same trap as wb-header-metrics.js: on desktop .header-section keeps
         its sticky position while `display: contents` removes its box, so it
         matches first and measures zero. Take the height as the signal. */
      if (r.height <= 0) continue;
      root.style.setProperty('--wb-kb-pin', Math.max(0, Math.round(r.bottom)) + 'px');
      return;
    }
  }

  function syncFs() {
    var btns = root.querySelectorAll('[data-wb-kb-fs]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var on = view && view === VIEWS[b.getAttribute('data-wb-kb-fs')];
      /* The label names the ACTION the button will take, so it has to change
         with the state — which rules out aria-pressed with a fixed label. */
      var lab = b.getAttribute(on ? 'data-fs-close' : 'data-fs-open') || '';
      b.setAttribute('aria-label', lab);
      b.setAttribute('title', lab);
    }
  }

  function setView(next) {
    var split = el('.wb-kb__split');
    if (!split || view === next) return;
    var prev = view;
    var flow = el('.wb-kb__flow');
    /* ⚠ Both panes are in the document FLOW, so hiding one moves the other:
       dropping the bench lifts the whole walk by the bench's height and the
       step being read jumps for no reason the reader can see.

       Correct by what ACTUALLY moved, never by the bench's measured height.
       Chrome anchors scrolling automatically when content above the viewport
       resizes and has already absorbed the shift by the time this runs, while
       Safari has never shipped scroll anchoring and has absorbed nothing —
       so subtracting a height double-corrects on one and under-corrects on
       the other. A measured delta is right on both, and is zero when the
       browser already did the work. */
    var y0 = flow ? flow.getBoundingClientRect().top : 0;

    /* Expanding the bench REMOVES the walk, so the document collapses to about
       one screen and the browser clamps the scroll to the top. Remember where
       the reader was, because coming back cannot recover it otherwise. */
    if (next === VIEWS.stage) stageMark = window.scrollY;

    split.classList.remove(VIEWS.stage, VIEWS.flow);
    /* Cleared whenever the bench is not expanded, so a value measured for one
       scroll position can never be reused at another. */
    if (next !== VIEWS.stage) root.style.removeProperty('--wb-kb-pin');
    if (next) split.classList.add(next);
    view = next;
    syncFs();
    /* After the class, so the bench is already fixed and the header is at the
       position the mode will actually hold. */
    if (next === VIEWS.stage) pinBench();

    if (prev === VIEWS.stage && !next) {
      window.scrollTo(0, stageMark);
    } else if (flow && next !== VIEWS.stage) {
      /* Skipped when the walk is being hidden — a display:none box reports a
         zero rect, which is not a position it ever had. */
      var d = flow.getBoundingClientRect().top - y0;
      if (d) window.scrollTo(0, Math.max(0, window.scrollY + d));
    }

    /* The bench's viewport just changed size, so the board's zoom is stale.
       fitBoard already bails on a zero-sized box, so the hidden case is safe
       without a guard here. */
    fitBoard();
  }

  /* The bench has two shapes and this is the only place that decides which.
     The C-series count step (desktop) is a left-aligned column — the chips fly
     in to it and each add appends to the right. Everywhere else it is a bench:
     cells spread evenly across the whole stage. Same predicate as the panel's
     wide mode and perLine's wide lines, so the three can never disagree. */
  function syncBoardMode() {
    var board = el('[data-wb-kb-board]');
    if (board) board.classList.toggle('is-column', isCountList());
  }

  /* A few pixels of SIDEWAYS drift per cell, hashed from the series key so a
     re-render puts every cell back exactly where it was. Horizontal only:
     the bench rows align to the top so every title in a row shares one
     height, and the rotation and vertical drift this used to carry undid
     precisely that. */
  function jitterFor(key) {
    var h = 0;
    for (var i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
    var x = (((h >>> 10) % 1000) / 1000 - 0.5) * 12;
    return '--wb-kb-jx:' + x.toFixed(1) + 'px';
  }

  function fitBoard() {
    var vp = el('[data-wb-kb-viewport]'), board = el('[data-wb-kb-board]');
    if (!vp || !board) return;
    /* Before measuring: the mode class changes the layout being measured. */
    syncBoardMode();
    /* ⚠ clientWidth/clientHeight INCLUDE padding, and the board is inset by
       exactly that padding — so measuring them raw claimed room the board
       never gets. The bottom padding is the tray's clearance, which made this
       worst precisely where it mattered: the fit believed the bench was
       taller than the tray allowed and pushed the last groups underneath it.
       Desktop had enough slack to hide the error for weeks. */
    var vcs = window.getComputedStyle(vp);
    var availW = vp.clientWidth - parseFloat(vcs.paddingLeft) - parseFloat(vcs.paddingRight);
    var availH = vp.clientHeight - parseFloat(vcs.paddingTop) - parseFloat(vcs.paddingBottom);
    if (availW <= 0 || availH <= 0) return;

    /* ⚠ The phone's preview does not scale at all — it SCROLLS. Everything
       below this point exists to make a kit fit a fixed frame, and on a phone
       that frame is one screen: 130 pieces came out at 44%, which is a cleco
       13px tall. Owen, 2026-09-06: "make it scrollable and spread out the
       elements so they exceed the vertical fold... so a user can see every
       part in a good size."

       The stylesheet turns the board into a one-per-row list at that
       breakpoint; all this has to do is stop fighting it. Height to its
       content, no transform, viewport scrolls.

       ⚠ `height: max-content`, not `auto`. The board is absolutely positioned
       with `inset: 6px 16px 66px` — top AND bottom — so `auto` resolves to
       the frame's height and the list would be clipped at exactly the fold it
       is supposed to pass. An explicit height over-constrains the box, and
       `bottom` is the declaration that gets dropped.

       ⚠ The width is CLEARED rather than set. The inset already gives the
       board the frame's width, and a px value written here would survive into
       the desktop branch's measuring pass on a resize across 1080. */
    if (window.innerWidth <= 1080 && el('.wb-kb__split.is-stage-full')) {
      syncBoardMode();
      board.style.width = '';
      board.style.height = 'max-content';
      board.style.transform = 'none';
      var zlm = el('[data-wb-kb-zoom]');
      if (zlm) zlm.hidden = true;
      vp.style.overflowY = 'auto';
      return;
    }
    /* ⚠ Do NOT clear the transform to measure. It was cleared here for a long
       time, and because the reset is COMMITTED (the reflow below) before the
       transition is restored, every single render restarted the scale
       animation from 1 — the board snapped to full size and glided back, on
       each individual +1. That is the flicker, and it is invisible in a
       still: the inline style read scale(2) while the computed value, which
       is where a transition begins, read the identity matrix.

       Clearing it was never needed anyway: transform does not participate in
       layout, so scrollWidth/scrollHeight are identical with it applied. Only
       width and height have to be freed, and those are restored below within
       the same task, so no intermediate state is ever painted. */
    /* ⚠ And no transition suppression either. The old `transition:'none'` +
       forced reflow, meant to hide a measuring pass, COMMITS whatever the
       board is mid-glide at its target — so a second add 120ms after the
       first cut the first glide dead and jumped. Width and height are not in
       the transition list, so nothing in this pass needs suppressing. */
    /* ⚠ Measure at max-content, NOT at the available width. Pinning the board
       to availW before measuring made scrollWidth come back as availW, so the
       width ratio was ALWAYS exactly 1 and the fit could never grow — which is
       why the old cap of 1 looked harmless. The board is a column of
       non-wrapping lines, so its layout does not depend on the width it is
       given, and measuring free is safe. */
    /* ⚠ HEIGHT has to be freed too. The board is absolutely positioned with
       `inset: 12px 30px 92px`, which sets top AND bottom — so its box height
       is the stage's height no matter what is in it, and scrollHeight can
       never come back smaller than the space. Both ratios were therefore
       pinned at 1 and the bench could not grow. */
    var prevW = board.style.width, prevH = board.style.height;
    var natW, natH, z;
    if (isCountList()) {
      board.style.width = 'max-content';
      board.style.height = 'max-content';
      natW = board.scrollWidth; natH = board.scrollHeight;
      z = Math.min(MAX_Z, availW / Math.max(1, natW), availH / Math.max(1, natH));
    } else {
      /* The bench WRAPS, so it cannot be measured free: at max-content a
         wrapping row is one endless line and the fit collapses to a sliver.
         It has to be laid out at the width it will actually get — and that
         width depends on the scale (availW / z), which depends on the height
         the wrap produces, which depends on the width. Bigger z = narrower
         box = more wrapping = taller, so "fits" is monotone in z, and a
         handful of candidates walked from the cap downwards finds the largest
         one that fits without ever oscillating. */
      board.style.height = 'max-content';
      var cands = [MAX_Z, 1.6, 1.3, 1.15, 1], found = false;
      for (var ci = 0; ci < cands.length; ci++) {
        z = cands[ci];
        board.style.width = (availW / z) + 'px';
        natH = board.scrollHeight; natW = board.scrollWidth;
        if (natH * z <= availH && natW * z <= availW + 1) { found = true; break; }
      }
      if (!found) {
        /* Too much for the stage even at 1: shrink, then re-measure at the
           wider box that shrink allows, which un-wraps some rows. */
        z = Math.min(availH / Math.max(1, natH), availW / Math.max(1, natW));
        board.style.width = (availW / z) + 'px';
        natH = board.scrollHeight; natW = board.scrollWidth;
        z = Math.min(1, availH / Math.max(1, natH), availW / Math.max(1, natW));
      }
    }
    board.style.width = prevW;
    board.style.height = prevH;
    /* Below about a third a cleco stops being a recognisable object, so the
       board stops shrinking and the stage scrolls instead of turning to mush.

       ⚠ On a phone that floor is the wrong trade. The stage is a third of the
       screen there, so a real kit hits the floor almost immediately and the
       overflow becomes an inner scroll area inside a sticky panel — which
       nobody finds, and which fights the page scroll. A bench you can see all
       of, small, beats a bench that is cut off at a readable size: the job on
       a phone is watching the kit accumulate, and the review reads it back
       properly further down. */
    var floor = window.innerWidth <= 1080 ? 0.16 : 0.32;
    /* ⚠ The cap used to be 1, so a bench holding two pieces sat tiny in a
       panel built for a hundred. It may now grow into the space it has, up to
       MAX_Z — bounded because a single cleco blown up to fill a desktop bench
       stops reading as a product and starts reading as a bug. */
    z = Math.max(floor, z);
    /* ⚠ The scale paints from the layout box, so the box has to be the size
       the scaled result should END UP. At z>1 that is SMALLER than the space:
       leave it at availW and a bench grown to 1.5x paints half of itself
       outside the stage. */
    board.style.width = (availW / z) + 'px';
    board.style.height = (availH / z) + 'px';
    board.style.transform = 'scale(' + z + ')';
    var zl = el('[data-wb-kb-zoom]');
    /* ⚠ 0.9, not 0.999. Any scaling at all used to announce itself, so a
       phone showed "99%" beside the title permanently — a number that tells
       a customer nothing and, at 375px, collided with the heading. It is
       worth saying only once the bench is small enough that someone might
       wonder whether they are seeing everything. */
    if (zl) { zl.hidden = z >= 0.9; zl.textContent = Math.round(z * 100) + '%'; }
    vp.style.overflowY = (natH * z > availH + 2) ? 'auto' : 'hidden';
  }

  /* Pieces that just arrived, eased in one after another so a +10 reads as
     ten things landing rather than a block appearing.
     ⚠ Above BURST the tail lands together: fifty individually staggered
     pieces is a second and a half of waiting for someone who already knew
     what they wanted. */
  var CASCADE_STEP = 26, BURST = 20;
  function cascadeIn(key, added) {
    if (REDUCED || added <= 0) return;
    var grp = el('[data-wb-kb-grp="' + cssq(key) + '"]');
    if (!grp) return;
    var imgs = all('img', grp);
    var fresh = imgs.slice(Math.max(0, imgs.length - added));
    fresh.forEach(function (img, i) {
      img.animate(
        [{ opacity: 0, transform: 'translateY(7px) scale(.82)' },
         { opacity: 1, transform: 'none' }],
        { duration: 260, delay: Math.min(i, BURST) * CASCADE_STEP,
          easing: 'cubic-bezier(.22,.9,.25,1)', fill: 'backwards' }
      );
    });
  }

  var pendingCascade = null;
  function renderBoard() {
    var board = el('[data-wb-kb-board]');
    if (!board) return;
    board.innerHTML = boardHTML();
    paintStageHead();
    fitBoard();
    if (pendingCascade) { cascadeIn(pendingCascade.key, pendingCascade.n); pendingCascade = null; }
  }

  function paintStageHead() {
    var s = seriesOf(active);
    var meta = el('[data-wb-kb-stagemeta]');
    var b = basket();
    /* The stage title is the page's H1 now — a fixed name, rendered in
       Liquid. It used to be repainted with the active series, which only
       repeated the step heading already on screen to its right. */
    if (!meta) return;
    if (!s) { meta.textContent = fill(cfg.t.board_total, { '@@N@@': b.units }); return; }
    var n = 0;
    for (var i = 0; i < s.sizes.length; i++) n += state.qty[qtyKey(s.key, s.sizes[i].size)] || 0;
    /* Owen, 2026-09-06: "Nothing added from this step yet. Not needed." An
       empty step is self-evidently empty; the line only added noise beside
       a heading that already said so. */
    meta.textContent = n === 0 ? ''
      : (n === 1 ? cfg.t.board_one : fill(cfg.t.board_pieces, { '@@N@@': n }));
  }

  /* FLIP: measure, let the board change, then start the cells where they were
     and ease them to where they now belong. Scale is inverted as well as
     position — a re-render destroys the old <img> elements, so their height
     transition never runs and the shrink lands instantly without it.

     ⚠ Reflow is forced synchronously rather than waiting on rAF, which does
     not fire in a document that is not being displayed. */
  function flip(mutate) {
    var before = [];
    all('[data-wb-kb-cell]').forEach(function (c) {
      before.push([c.getAttribute('data-wb-kb-cell'), c.getBoundingClientRect()]);
    });
    mutate();
    if (REDUCED) return;
    all('[data-wb-kb-cell]').forEach(function (c) {
      var id = c.getAttribute('data-wb-kb-cell'), was = null;
      for (var i = 0; i < before.length; i++) if (before[i][0] === id) { was = before[i][1]; break; }
      if (!was) return;
      var now = c.getBoundingClientRect();
      if (!now.width || !now.height) return;
      var dx = was.left - now.left, dy = was.top - now.top;
      var sx = was.width / now.width, sy = was.height / now.height;
      if (Math.abs(dx) < 1 && Math.abs(dy) < 1 && Math.abs(sx - 1) < 0.02 && Math.abs(sy - 1) < 0.02) return;
      c.style.transformOrigin = 'top left';
      c.style.transition = 'none';
      c.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + sx + ',' + sy + ')';
      void c.offsetWidth;
      c.style.transition = 'transform ' + DUR + 'ms ' + EASE;
      c.style.transform = '';
      setTimeout(function () { c.style.transition = ''; }, DUR + 60);
    });
  }

  function setActiveCell() {
    var known = false;
    all('[data-wb-kb-cell]').forEach(function (c) {
      var on = c.getAttribute('data-wb-kb-cell') === active;
      if (on) known = true;
      c.classList.toggle('is-active', on);
    });
    if (!known) { renderBoard(); return; }
    paintStageHead();
    fitBoard();
    setTimeout(fitBoard, DUR + 20);
  }

  /* ── the typed question ──────────────────────────────────────────── */

  /* ⚠ Driven by ELAPSED TIME, not by counting ticks. Browsers throttle timers
     hard whenever a tab is backgrounded, and a tick-counting typewriter then
     stalls a few characters in and never finishes. The full sentence also
     sits in the DOM as a hidden ghost so typing cannot change the page's
     height — that fed back into the scroll trigger and restarted itself. */
  var typingNode = null, typingText = '';

  /* Settle whatever sentence is in flight: stop the timer and put the WHOLE
     text on screen.

     ⚠ Every path that stops the typewriter goes through here. Clearing the
     timer without finishing the sentence used to leave the previous step
     reading "Spring cl" permanently — the step was already marked as typed,
     so it never retyped and the question stayed truncated. */
  function finishTyping() {
    if (typeTimer) { clearInterval(typeTimer); typeTimer = null; }
    if (typingNode) {
      typingNode.textContent = typingText;
      if (typingNode.parentNode) typingNode.parentNode.classList.remove('is-typing');
    }
    typingNode = null; typingText = '';
  }

  function typeInto(node, text) {
    finishTyping();
    if (!node) return;
    typingNode = node; typingText = text;
    if (REDUCED) { node.textContent = text; node.parentNode.classList.remove('is-typing'); return; }
    node.textContent = '';
    node.parentNode.classList.add('is-typing');
    var started = Date.now(), PER_CHAR = 13;
    typeTimer = setInterval(function () {
      var i = Math.min(text.length, Math.round((Date.now() - started) / PER_CHAR));
      node.textContent = text.slice(0, i);
      if (i >= text.length) {
        clearInterval(typeTimer); typeTimer = null;
        node.parentNode.classList.remove('is-typing');
      }
    }, 16);
  }

  /* A step you have already seen: the finished sentence, at once, no caret.

     ⚠ Unless this is the node currently typing — that is its one and only
     pass. typeActive() runs TWICE at start-up (startStepping() shows the first
     step, then the boot sequence calls it again), and flushing there would
     mean the very first step never animated at all. */
  function showTyped(typed, ghost) {
    if (typingNode === typed) return;
    finishTyping();
    typed.textContent = ghost.textContent;
    if (typed.parentNode) typed.parentNode.classList.remove('is-typing');
  }

  function typeActive() {
    if (!active) return;
    var sec = el('[data-wb-kb-sec="' + cssq(active) + '"]');
    if (!sec) return;
    var typed = el('.wb-kb__typed', sec), ghost = el('.wb-kb__ghost', sec);
    /* The review carries no lede, so there is nothing to type and nothing to
       remember about it. The old guard marked the step typed BEFORE this
       check and burned the slot. */
    if (!typed || !ghost) return;
    if (typedOnce[active]) { showTyped(typed, ghost); return; }
    typedOnce[active] = true;
    typeInto(typed, ghost.textContent);
  }

  /* ── tray, shipping, savings ──────────────────────────────────────── */

  function renderTray() {
    var b = basket();
    var rows = '';
    eachSize(function (series, size) {
      var n = state.qty[qtyKey(series.key, size.size)] || 0;
      if (!n) return;
      var line = solve(size, n);
      rows += '<div class="wb-kb__trayrow"><span>' + esc(series.label) + ' &middot; ' +
        esc(size.label) + ' &times; ' + n + '</span><b>' + esc(money(line.total)) + '</b></div>';
    });
    /* The rows above price what was ASKED for; when a kit swap is in force
       the till pays less, and this row is the difference — so the column
       still adds up to the total under it. */
    if (b.kitSwap && b.kitSwap.saving > 0) {
      rows += '<div class="wb-kb__trayrow wb-kb__trayrow--kit"><span>' +
        fill(cfg.t.kitswap_tray, { '@@K@@': esc(kitNames(b)) }) +
        '</span><b>&minus;' + esc(money(b.kitSwap.saving)) + '</b></div>';
    }
    var host = el('[data-wb-kb-trayrows]');
    if (host) host.innerHTML = rows || '<div class="wb-kb__trayrow"><span>' + esc(cfg.t.empty_kit) + '</span></div>';

    /* ⚠ all(), not el(). The phone carries a SECOND copy of these two — the
       fixed bar at the foot of the screen — because the bench that used to
       hold the running total is not on screen there any more. Fourth time
       this file has needed the plural. */
    all('[data-wb-kb-traytot]').forEach(function (tot) { tot.textContent = money(b.total); });
    var cntText = b.units
      ? (b.units === 1 ? cfg.t.summary_one : fill(cfg.t.summary_items, { '@@N@@': b.units }))
      : cfg.t.tray_empty;
    all('[data-wb-kb-traycount]').forEach(function (cnt) { cnt.textContent = cntText; });

    /* ⚠ ALL of them. There are two bars now — one in the tray, one under the
       kit total on the review — and el() returns only the first, which left
       whichever came second frozen at its initial state. */
    var ships = root.querySelectorAll('[data-wb-kb-ship]');
    if (ships.length) {
      /* Free shipping is one number the whole site reads. Zero means the
         setting is empty or the market is not AU, and then there is no tier
         to advertise. */
      var goal = cfg.freeShip || 0;

      /* ⚠ Judged on the ORDER, not on this kit. cfg.cartTotal was already
         fetched and refreshed after every cart change but never actually
         read here, so a customer holding $150 of other parts was told they
         were $47 short of a threshold they had already cleared.
         The exception is EDITING a kit that is already in the cart: those
         lines are still counted in cartTotal and are about to be replaced by
         this one, so adding both would double the kit and promise free
         shipping that is not there. There we fall back to the kit alone,
         which under-promises rather than over-promises. */
      var other = state.editingKit ? 0 : (cfg.cartTotal || 0);
      var progress = b.total + other;

      var hide = goal <= 0 || b.total <= 0;
      var remain = goal - progress;
      var pct = goal > 0 ? Math.max(0, Math.min(100, Math.round(progress / goal * 100))) : 0;
      var msg = remain <= 0 ? cfg.t.ship_free : fill(cfg.t.ship_away, { '@@A@@': money(remain) });
      /* ⚠ Say what the number is counting. "Your order ships free" under a
         $57 kit reads as a mistake when the threshold is $199 — it is right,
         but only because the cart already holds the rest, and nothing on
         this screen said so. */
      var note = other > 0 ? fill(cfg.t.ship_cart, { '@@A@@': money(other) }) : '';

      for (var si = 0; si < ships.length; si++) {
        var sh = ships[si];
        sh.hidden = hide;
        if (hide) continue;
        var fillEl = sh.querySelector('[data-wb-kb-shipfill]');
        if (fillEl) fillEl.style.width = pct + '%';
        sh.classList.toggle('is-free', remain <= 0);
        var txtEl = sh.querySelector('[data-wb-kb-shiptext]');
        if (txtEl) txtEl.textContent = msg;
        var noteEl = sh.querySelector('[data-wb-kb-shipnote]');
        if (noteEl) noteEl.textContent = note;
      }
    }
  }

  /* ── the review ───────────────────────────────────────────────────── */

  /* "3.2 mm · Drill #30 · $1.95 each" — assembled from whatever the size
     actually has. Clamps and pliers carry neither a bore nor a drill, so the
     separator has to come from joining the parts that exist rather than from
     a fixed format string. */
  function sizeDetail(size, rung) {
    var bits = [];
    if (size.mm) bits.push(fill(cfg.t.mm_line, { '@@M@@': size.mm }));
    if (size.drill) bits.push(fill(cfg.t.drill_line, { '@@D@@': size.drill }));
    if (rung && rung.priceText) bits.push(rung.priceText + ' ' + cfg.t.each_suffix);
    return bits.join(' \u00b7 ');
  }

  /* The editor's header. Up to three real pieces from the kit stand in for a
     product shot: the builder never receives the product's photography, but
     it already owns the artwork for every piece the kit is made of. */
  function renderEdHead(b) {
    var host = el('[data-wb-kb-edhead]');
    if (!host) return;
    if (!b.units) { host.innerHTML = ''; return; }

    var thumbs = '', shown = 0, lines = 0;
    for (var i = 0; i < cfg.parts.length; i++) {
      var s = cfg.parts[i];
      for (var j = 0; j < s.sizes.length; j++) {
        if (!(state.qty[qtyKey(s.key, s.sizes[j].size)] > 0)) continue;
        lines++;
        if (shown >= 3) continue;
        var a = artFor(s.sizes[j]);
        if (!a) continue;
        thumbs += '<img src="' + esc(a) + '" alt="" height="30" loading="lazy"' +
          (artIsPhoto(s.sizes[j]) ? ' class="is-photo"' : '') + '>';
        shown++;
      }
    }

    var nameEl = root.querySelector('[data-wb-kb-name]');
    var nm = (nameEl && nameEl.value.trim()) || (state.name || '').trim() || defaultKitName();
    var meta = (lines === 1 ? cfg.t.ed_lines_one : fill(cfg.t.ed_lines, { '@@N@@': lines })) +
      ' \u00b7 ' + (b.units === 1 ? cfg.t.cell_one : fill(cfg.t.cell_pieces, { '@@N@@': b.units }));

    host.innerHTML =
      '<span class="wb-kb__edshot">' + thumbs + '</span>' +
      '<span class="wb-kb__edtx">' +
        '<span class="wb-kb__edeyebrow">' + esc(arrivedWithKit ? cfg.t.editing : cfg.t.q_review) + '</span>' +
        '<b class="wb-kb__edname">' + esc(nm) + '</b>' +
        '<span class="wb-kb__edmeta">' + esc(meta) + '</span>' +
      '</span>' +
      /* ⚠ data-wb-kb-fs, not a handler of its own. The expanded bench already
         exists as a view and already knows how to pin and scale itself; this
         is that control wearing the editor's clothes. */
      '<button type="button" class="wb-kb__preview" data-wb-kb-fs="stage"' +
        ' data-fs-say-open="' + esc(cfg.t.view_now_bench) + '"' +
        ' data-fs-say-close="' + esc(cfg.t.view_now_split) + '">' +
        '<svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor"' +
        ' stroke-width="1.7" aria-hidden="true"><rect x="1.6" y="3.4" width="12.8" height="9.2" rx="1.6"/>' +
        '<path d="M1.6 10.2 5 7l3 2.6 2.4-2 3 2.6"/></svg>' +
        esc(cfg.t.preview_kit) +
      '</button>';
  }

  /* ── "Add to this kit" ─────────────────────────────────────────────────
     The types the kit does NOT contain. Bubbles rather than rows because the
     question here is "what IS this", not "how many" — a customer who has
     never held a stubby cleco cannot rank it against a wing-nut from the name
     alone, so the picture comes first and the quantity only after they open
     it. Everything already in the kit stays a plain editable row above; being
     made to expand a panel to change a number you can already see would be a
     step backwards from the list this replaced. */
  var openBubble = null;

  function seriesQty(s) {
    var n = 0;
    for (var j = 0; j < s.sizes.length; j++) n += state.qty[qtyKey(s.key, s.sizes[j].size)] || 0;
    return n;
  }

  /* ⚠ Every buyable size taken, not "any quantity at all". The tray used to
     drop a type the moment one of its sizes was on the bench, so Adrian —
     holding 1/8 standard clecos — had no way to add 5/32 from the editor at
     all, and the type he wanted had vanished from the one place that offers
     types. Owen's rule, 2026-09-06: only hide a type once there is nothing
     left in it to add. A single-size series (pliers, butt clamps) satisfies
     that the moment its one size is on the bench, which is the old behaviour
     falling out of the new rule rather than a case of its own. */
  function seriesComplete(s) {
    var sizes = buyableSizes(s);
    if (!sizes.length) return true;
    for (var j = 0; j < sizes.length; j++) {
      if (!(state.qty[qtyKey(s.key, sizes[j].size)] > 0)) return false;
    }
    return true;
  }

  function buyableSizes(s) {
    var out = [];
    for (var j = 0; j < s.sizes.length; j++) if (buyableSize(s.sizes[j])) out.push(s.sizes[j]);
    return out;
  }

  /* ── which size a bubble wears ───────────────────────────────────────
     On a cleco the colour IS the diameter — 3/32 silver, 1/8 copper, 5/32
     black, 3/16 brass, 1/4 copper — and the tray used to take each series'
     FIRST buyable size, which is 3/32 in every one of them. Nine bubbles,
     nine identical silver pins, and nothing to tell them apart but the
     caption. Owen, 2026-09-05: "can you use different coloured clecos inside
     this section".

     So each type steps one place further along its OWN size list. The lists
     run in the same order everywhere (3/32, 1/8, 5/32, 3/16), so stepping the
     index steps the colour, and it degrades honestly: a series with three
     sizes left simply wraps sooner, where wishing for a particular diameter
     would drop several types onto the same fallback. (It did — 1/4 exists in
     only two series and 3/16 is sold out in a third, so a diameter-led rota
     put brass on three bubbles in a row.)

     ⚠ The offset is the series' position in cfg.parts, NOT its position in
     the tray. A bubble that changed colour whenever the type above it was
     added to the kit would be worse than all-silver.

     Nothing is claimed by the choice: the panel that opens lists every size
     with its own art, and edu_c already tells the customer colour means size. */
  /* Which type the panel was last opened FOR, so the scroll nudge fires on
     opening a type and not on every quantity change inside it. */
  var lastOpenedBubble = null;
  /* One explanation open at a time, like the tray's bubbles. */
  var openEdu = null;

  function bubbleSize(s) {
    var all = buyableSizes(s), sizes = [], j;
    for (j = 0; j < all.length; j++) if (artFor(all[j])) sizes.push(all[j]);
    if (!sizes.length) return null;
    var at = 0;
    for (j = 0; j < cfg.parts.length; j++) if (cfg.parts[j].key === s.key) { at = j; break; }
    return sizes[at % sizes.length];
  }

  /* ⚠ NOT stepperHTML. This is the tray's own stepper and it takes (series,
     size) objects, where the step list's takes (key, label) strings. Sharing
     the name meant the LATER declaration won for the whole IIFE — function
     declarations hoist — so optRow() and openModal() were silently calling
     THIS one with two strings. s.key and size.size are undefined on a string,
     so every quantity input in the walk was stamped
     data-wb-kb-in="undefined::undefined": one key shared by all 29 of them.
     The fields moved together, typing wrote a quantity nothing read, and the
     bench never changed. Owen found it on step 1, 2026-09-05. */
  function bubStepper(s, size) {
    var key = qtyKey(s.key, size.size), n = state.qty[key] || 0;
    return '<span class="wb-kb__step">' +
      '<button type="button" data-wb-kb-dec="' + esc(key) + '" aria-label="&minus;">&minus;</button>' +
      '<input type="text" inputmode="numeric" value="' + n + '" data-wb-kb-in="' + esc(key) + '"' +
        ' aria-label="' + esc(size.label) + '">' +
      '<button type="button" data-wb-kb-inc="' + esc(key) + '" aria-label="+">+</button>' +
    '</span>';
  }

  /* ── where the open panel sits ────────────────────────────────────────
     Under the ROW you clicked, not under the whole tray. The panel used to be
     the last child of the section, so with nine bubbles wrapped into three
     rows a customer who tapped one on the top row got their answer three rows
     further down, off the bottom of the screen — Owen, 2026-09-05: "when I
     press on it, it loads below the fold, so as a new user they might assume
     nothing is happening."

     The tray is a wrap-enabled flex row and the rows are not elements, so
     there is nothing to append to. Geometry answers it instead: every bubble
     sharing the clicked one's offsetTop is on its row, and the panel goes
     after the last of them. That holds at any width and any column count, so
     nothing here has to know how many fit per row.

     ⚠ The panel is taken OUT of the flow before measuring. Left in, it is
     itself a row, and every bubble below it reports a shifted offsetTop —
     which is how the panel ends up walking one row further down on each
     re-render. */
  function placeBubPanel() {
    var tray = el('.wb-kb__bubs'), panel = el('.wb-kb__bubpanel');
    if (!tray || !panel) return;
    var btn = el('.wb-kb__bub.is-on', tray);
    if (!btn) return;
    panel.style.display = 'none';
    var top = btn.offsetTop, after = btn, bs = all('.wb-kb__bub', tray);
    for (var i = 0; i < bs.length; i++) if (bs[i].offsetTop === top) after = bs[i];
    panel.style.display = '';
    if (after.nextSibling !== panel) tray.insertBefore(panel, after.nextSibling);
  }

  /* The tray's last built markup, with quantities normalised out — see the
     comparison at the end of renderAdd. */
  var addShape = null;

  function renderAdd() {
    /* ⚠ addtray, not add — see the note on the host in the section. */
    var host = el('[data-wb-kb-addtray]');
    if (!host) return;

    var absent = [];
    for (var i = 0; i < cfg.parts.length; i++) {
      var s = cfg.parts[i];
      if (!buyableSizes(s).length) continue;
      /* Anything with a quantity is already a group in the list above, so it
         leaves the tray — what you own and what you could own do not both
         claim the same part.

         ⚠ EXCEPT the panel you have open. Dropping it the instant the first
         unit landed pulled the controls out from under anyone who wanted
         four: you tapped +, the type moved upstairs, and the panel you were
         using vanished. It now stays until you close it, which is also when
         the count you were setting stops changing. */
      if (seriesComplete(s) && s.key !== openBubble) continue;
      absent.push(s);
    }
    if (!absent.length) { host.innerHTML = ''; addShape = null; openBubble = null; return; }

    /* Only if the type vanished for another reason — everything sold out, or
       a series removed from the catalogue mid-session. */
    var stillThere = false;
    for (var a = 0; a < absent.length; a++) if (absent[a].key === openBubble) stillThere = true;
    if (!stillThere) openBubble = null;

    /* Every type, always. It used to show five and hide the rest behind a
       "+N more types" bubble — Owen, 2026-09-05: "I had to click on see more
       to view all the options I could add on. Always have them visible."
       A tray that hides half its contents behind a control that looks like
       one more type is not a tray, it is a quiz. */
    var bubs = '';
    for (var v = 0; v < absent.length; v++) {
      var s2 = absent[v], z2 = bubbleSize(s2), on = s2.key === openBubble;
      bubs += '<button type="button" class="wb-kb__bub' + (on ? ' is-on' : '') + '"' +
        ' data-wb-kb-bub="' + esc(s2.key) + '" aria-expanded="' + (on ? 'true' : 'false') + '"' +
        /* Only while it is open: aria-controls pointing at an id that is not
           in the document is worse than none at all. Safe on a <button> —
           the leave guard's aria-controls escape hatch tests a[href] only. */
        (on ? ' aria-controls="wb-kb-bubpanel"' : '') + '>' +
        artCell('wb-kb__bubdisc', z2, 34) +
        '<span class="wb-kb__bubnm">' + esc(s2.label) + '</span>' +
        '<span class="wb-kb__bubplus" aria-hidden="true">' + (on ? '&minus;' : '+') + '</span>' +
      '</button>';
    }
    var panel = '';
    if (openBubble) {
      for (var p = 0; p < absent.length; p++) {
        if (absent[p].key !== openBubble) continue;
        var s3 = absent[p], sizes = buyableSizes(s3), rows = '';
        for (var q = 0; q < sizes.length; q++) {
          var sz = sizes[q], rung = unitPrice(sz);
          rows += '<div class="wb-kb__bubrow">' +
            artCell('wb-kb__bubart', sz, 26) +
            '<span class="wb-kb__bubid"><b>' + esc(sz.short || sz.label) + '</b>' +
              '<span>' + esc(sizeDetail(sz, rung)) + '</span></span>' +
            bubStepper(s3, sz) +
          '</div>';
        }
        panel = '<div class="wb-kb__bubpanel" id="wb-kb-bubpanel">' +
          '<div class="wb-kb__bubhd">' +
            artCell('wb-kb__bubdisc', bubbleSize(s3), 34) +
            '<span class="wb-kb__bubtx"><b>' + esc(s3.label) + '</b>' +
              (s3.edu ? '<span>' + esc(s3.edu) + '</span>' : '') + '</span>' +
            '<button type="button" class="wb-kb__bubx" data-wb-kb-bub=""' +
              ' aria-label="' + esc(cfg.t.bub_close) + '">&#10005;</button>' +
          '</div>' +
          '<div class="wb-kb__bubsizes">' + rows + '</div>' +
        '</div>';
      }
    }

    var html = '<div class="wb-kb__addcap">' + esc(cfg.t.add_to_kit) + '</div>' +
      '<div class="wb-kb__bubs">' + bubs + panel + '</div>';

    /* ⚠ Only when the SHAPE changed — this is the flicker Owen filmed on
       2026-09-07. renderAdd() runs on every press of a stepper, and rewriting
       innerHTML destroys and recreates every <img> in the tray: the bubble
       discs, the open panel's header and all of its size thumbnails. On iOS
       they come back a frame late, so every single "+" blanked every picture
       on screen and painted them again. Verified in the DOM: identical srcs,
       different nodes.

       A quantity is the ONE thing in here that does not change the shape, and
       it is also the one thing already handled without a rebuild — syncRows()
       walks every [data-wb-kb-in] in the document, the tray's included, and
       sets the value and the "−" disabled state. So the value attributes are
       normalised out of the comparison and everything else still forces the
       rebuild: a series leaving the tray once it is complete, a different
       bubble opening, a price moving, a size selling out.

       ⚠ placeBubPanel() still runs either way. It positions the open panel
       under the row it belongs to, and that row moves when the tray rewraps
       at a new width, with or without new markup. */
    var shape = html.replace(/value="\d+"/g, 'value=""');
    if (shape !== addShape) {
      addShape = shape;
      host.innerHTML = html;
    }
    placeBubPanel();

    /* Only when a DIFFERENT type was opened. renderAdd() runs again on every
       press of the panel's own + and −, and a tray that re-scrolled under the
       thumb each time you added a clamp would be worse than the problem. */
    if (openBubble && openBubble !== lastOpenedBubble) {
      var opened = el('.wb-kb__bubpanel');
      if (opened && opened.scrollIntoView) {
        /* `nearest` is the whole point: it does nothing at all when the panel
           already fits on screen, and otherwise moves the least it can. */
        try {
          opened.scrollIntoView({ block: 'nearest', behavior: REDUCED ? 'auto' : 'smooth' });
        } catch (e) { opened.scrollIntoView(false); }
      }
    }
    lastOpenedBubble = openBubble;
  }

  function renderReview() {
    var host = el('[data-wb-kb-review]');
    if (!host) return;
    var b = basket();
    var out = '';
    for (var i = 0; i < cfg.parts.length; i++) {
      var s = cfg.parts[i], rows = '', secN = 0, secCents = 0;
      for (var j = 0; j < s.sizes.length; j++) {
        var size = s.sizes[j], key = qtyKey(s.key, size.size), n = state.qty[key] || 0;
        if (!n) continue;
        var line = solve(size, n);
        secN += n; secCents += line.total;
        var rung = unitPrice(size);
        rows += '<div class="wb-kb__rev">' +
          artCell('wb-kb__revart', size, 42) +
          /* ⚠ short, not label — the bench has always used it (cellHTML) and
             the summary had not. "Cleco Pliers – Standard Black Sheet Metal
             Fastener Installation Tool" wrapped to eight lines in a row built
             for one, squeezing the stepper and the price. The group heading
             above already names the series, so the short form is unambiguous.
             The input's aria-label below deliberately keeps the FULL name: a
             bare number field needs the unambiguous one read out. */
          '<span class="wb-kb__revname">' + esc(size.short || size.label) +
            '<em>' + esc(sizeDetail(size, rung)) + '</em></span>' +
          '<span class="wb-kb__step wb-kb__revstep">' +
            '<button type="button" data-wb-kb-dec="' + esc(key) + '" aria-label="&minus;">&minus;</button>' +
            '<input type="text" inputmode="numeric" value="' + n + '" data-wb-kb-in="' + esc(key) + '" aria-label="' + esc(size.label) + '">' +
            '<button type="button" data-wb-kb-inc="' + esc(key) + '" aria-label="+">+</button>' +
          '</span>' +
          '<b class="wb-kb__revtot">' + esc(money(line.total)) + '</b>' +
          capNote(key) +
          rowRemove(key, size.label, true) +
        '</div>';
      }
      if (rows) {
        /* ⚠ Adrian, testing as a first-timer, added side-grip clamps on the
           walk and then had no way to remind himself what they were for —
           the explanation lives on the step he had already left. The copy is
           the same edu_* string the walk uses, so nothing new had to be
           written or translated; the heading comes from film_t_*, which asks
           the same question ("Why heavy duty") and is also already
           translated. Click, not hover: 53.6% of sessions are phones. */
        /* ⚠ `why`, not `edu`. The kit summary is past the decision — see the
           note beside these two in the section. eduTitle stays as the
           button's accessible name ("Why heavy duty"), but no longer heads
           the panel: "How it works" over a plain statement of purpose was
           labelling it as something it is not, and the group name is
           directly above it anyway. */
        var eduText = s.why || s.edu;
        var eduOn = openEdu === s.key;
        var eduBtn = eduText
          ? '<button type="button" class="wb-kb__revinfo' + (eduOn ? ' is-on' : '') + '"' +
              ' data-wb-kb-edu="' + esc(s.key) + '" aria-expanded="' + (eduOn ? 'true' : 'false') + '"' +
              ' aria-label="' + esc(s.eduTitle || s.label) + '">i</button>'
          : '';
        var eduBox = (eduOn && eduText)
          ? '<p class="wb-kb__revedu">' + esc(eduText) + '</p>'
          : '';
        out += '<div class="wb-kb__revsec">' +
          '<div class="wb-kb__revhead"><span>' + esc(s.label) + eduBtn + '</span>' +
          '<span>' + (secN === 1 ? cfg.t.summary_one : fill(cfg.t.summary_items, { '@@N@@': secN })) +
          ' &middot; ' + esc(money(secCents)) + '</span></div>' + eduBox + rows + '</div>';
      }
    }

    /* The one saving this builder can honestly claim: when the parts add up
       to one of the store's own kits, the basket buys the KIT — a real SKU at
       its real price — and this line is the difference. Owen, 2026-08-23: kit
       prices are set against competitors, not margin, so the comparison only
       ever surfaces in the direction that favours the customer — a kit that
       costs more than its parts never swaps and is never mentioned.
       (Replaces a line that had never rendered once: it read b.singles,
       which basket() never set.) */
    var swapLine = '';
    if (b.kitSwap && b.kitSwap.saving > 0) {
      swapLine = '<div class="wb-kb__savedline">' +
        '<b class="wb-kb__savedamt">' +
          fill(cfg.t.you_save, { '@@A@@': esc(money(b.kitSwap.saving)) }) + '</b>' +
        '<span class="wb-kb__savedwhy">' +
          fill(cfg.t.kitswap_review, { '@@K@@': esc(kitNames(b)) }) + '</span></div>';
    }
    /* Two homes, one line. The walk keeps it directly above the list's own
       closing total. The editor moves it to the foot beside the kit total,
       because in the editor the list is followed by the add-to-kit tray and a
       green block between the two separated the tray from the steppers it
       reads as part of. Whichever host is not in use is emptied, not left
       holding a stale copy. */
    var savedHost = el('[data-wb-kb-saved]');
    if (savedHost) savedHost.innerHTML = arrivedWithKit ? swapLine : '';
    host.innerHTML = out
      ? out + (arrivedWithKit ? '' : swapLine) +
        '<div class="wb-kb__revtotal"><span>' + esc(cfg.t.kit_total) + '</span><b>' + esc(money(b.total)) + '</b></div>'
      : '<p class="wb-kb__revempty">' + esc(cfg.t.empty_kit) + '</p>';

    renderEdHead(b);
    renderAdd();

    var head = el('[data-wb-kb-revhead]');
    if (head) head.textContent = money(b.total);
    var warn = el('[data-wb-kb-warn]');
    /* Dismissed for the rest of the session — see the handler. It is not a
       validation, it is a reminder, and a reminder someone has answered should
       not come back every time they add another cleco. */
    if (warn) warn.hidden = !(hasSpringParts() && !pliersInKit() && !state.noPliers);
  }

  function pliersInKit() {
    var found = false;
    eachSize(function (series, size) {
      if (series.key !== 'pliers') return;
      if ((state.qty[qtyKey(series.key, size.size)] || 0) > 0) found = true;
    });
    return found;
  }

  /* ── walking on ───────────────────────────────────────────────────── */

  function sectionIds() {
    return all('[data-wb-kb-sec]').map(function (s) { return s.getAttribute('data-wb-kb-sec'); });
  }

  function labelFor(id) {
    var ids = sectionIds(), i = ids.indexOf(id);
    var nextId = ids[i + 1];
    if (!nextId) return cfg.t.to_review;
    var ns = seriesOf(nextId);
    var where = ns ? ns.label : cfg.t.q_review;
    var s = seriesOf(id), has = false;
    if (s) {
      for (var j = 0; j < s.sizes.length; j++) {
        if ((state.qty[qtyKey(s.key, s.sizes[j].size)] || 0) > 0) { has = true; break; }
      }
    }
    return fill(has ? cfg.t.next_continue : cfg.t.next_skip, { '@@W@@': where });
  }

  function syncAdvance() {
    /* The buy CTA names the action it will actually perform. With ?kid= the
       customer came from the cart band, addToCart deletes those lines and
       posts the replacement, so this is an update — and saying "Add" there
       reads as "you are about to have two kits". Owen, 2026-09-05.
       ⚠ state.editingKit, not arrivedWithKit: a ?kit= link from a product
       page and a saved kit opened from the shelf both create a NEW cart
       entry, and for those "Add kit to cart" is the honest label.
       ⚠ Skipped while disabled — addToCart owns the button mid-flight. */
    var cta = el('[data-wb-kb-addcart]');
    if (cta && !cta.disabled) {
      cta.textContent = state.editingKit ? cfg.t.update_kit : cfg.t.add_kit;
    }

    /* ⚠ Before the generic labelling: in the picking phase the button is not
       going to the next SERIES, and labelFor() would name one. */
    if (inPick()) { paintPhase(); return; }
    all('[data-wb-kb-next]').forEach(function (btn) {
      var span = btn.querySelector('[data-wb-kb-golabel]');
      var txt = labelFor(btn.getAttribute('data-wb-kb-next'));
      if (span && span.textContent !== txt) span.textContent = txt;
    });
    all('[data-wb-kb-jump]').forEach(function (b) {
      var id = b.getAttribute('data-wb-kb-jump');
      b.classList.toggle('is-here', id === active);
      var s = seriesOf(id), has = false;
      if (s) {
        for (var j = 0; j < s.sizes.length; j++) {
          if ((state.qty[qtyKey(s.key, s.sizes[j].size)] || 0) > 0) { has = true; break; }
        }
      }
      b.classList.toggle('has', has);
    });
  }

  /* The wing-nut step holds two grip ranges behind one switch. Rendering is
     untouched — BOTH lists are in the DOM and both get their rows built the
     usual way; this only decides which one is on screen.

     ⚠ Marking the step here rather than in the stylesheet is deliberate. The
     CSS that hides a group is gated on .is-grip, so if this never runs both
     groups simply stay open: a worse layout, never a missing product. */
  /* Each panel opens on its own.

     ⚠ They used to move together — open one, open them all — on the reasoning
     that wanting the explanation is a fact about the reader rather than the
     step. Owen, 2026-08-22: it is not what pressing one looks like it will do,
     and it was the bigger half of the scroll jump. Opening one panel adds a
     few dozen pixels below the thing you pressed; opening seven adds them on
     six other steps too, several of them ABOVE the viewport, so the page
     lurched and there was no way to tell where it had gone.

     ⚠ The rest of the jump is ordinary: expanding anything moves what follows
     it. The summary you pressed is held still across the toggle, so the panel
     grows downward from under your finger and nothing you were looking at
     moves. Scroll behaviour is forced to auto for that one correction — the
     theme sets scroll-behavior:smooth on <html>, which would animate a
     correction that is supposed to be invisible. */
  function initFilm() {
    all('[data-wb-kb-film]').forEach(function (d) {
      d.open = false;
      var sum = d.querySelector('summary');
      if (!sum) return;
      var before = 0;
      sum.addEventListener('mousedown', function () { before = sum.getBoundingClientRect().top; });
      sum.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') before = sum.getBoundingClientRect().top;
      });
      d.addEventListener('toggle', function () {
        /* The clamp film is a video, and it is the reason preload is off: it
           costs nothing until somebody opens the panel, and nothing again once
           they shut it. Left on its poster where motion is unwelcome. */
        var vid = d.querySelector('video');
        if (vid) {
          if (d.open && !REDUCED) { var pl = vid.play(); if (pl && pl.catch) pl.catch(function () {}); }
          else { try { vid.pause(); } catch (e) {} }
        }
        if (!before) return;
        var after = sum.getBoundingClientRect().top;
        var dy = after - before;
        if (!dy) return;
        var root = document.documentElement;
        var prev = root.style.scrollBehavior;
        root.style.scrollBehavior = 'auto';
        window.scrollBy(0, dy);
        root.style.scrollBehavior = prev;
      });
    });
  }

  function initGrip() {
    all('[data-wb-kb-grip]').forEach(function (btn) {
      var sec = btn.closest('.wb-kb__sec');
      if (sec) sec.classList.add('is-grip');
    });
  }

  function setGrip(key) {
    var btn = el('[data-wb-kb-grip="' + cssq(key) + '"]');
    if (!btn) return;
    var sec = btn.closest('.wb-kb__sec');
    if (!sec) return;
    all('[data-wb-kb-grip]', sec).forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    all('[data-wb-kb-gripgroup]', sec).forEach(function (g) {
      g.classList.toggle('is-on', g.getAttribute('data-wb-kb-gripgroup') === key);
    });
    /* The Unsure shortcut fills whichever grip is showing. Leaving it pointed
       at the parent would quietly add standard clecos while the customer is
       looking at the long ones. */
    var uns = el('[data-wb-kb-unsure]', sec);
    if (uns) uns.setAttribute('data-wb-kb-unsure', key);
  }

  function syncRows() {
    all('[data-wb-kb-in]').forEach(function (input) {
      var key = input.getAttribute('data-wb-kb-in');
      var n = state.qty[key] || 0;
      if (document.activeElement !== input && String(input.value) !== String(n)) input.value = n;
      /* ⚠ all(), not el(). The same quantity key has a "−" in the walk row,
         the review row, the tray panel and the bench modal at once, and el()
         disables whichever comes first in the document. Once the bench modal
         had been opened its buttons sat earlier in the DOM than nothing in
         particular — the practical effect was that the walk's "−" froze at
         whatever state the modal's copy wanted, and every duplicate stepper
         kept a live-looking button that did nothing. Third instance of this
         trap in this file; the free-shipping bar was the second. */
      all('[data-wb-kb-dec="' + cssq(key) + '"]').forEach(function (dec) {
        dec.disabled = n <= 0;
      });
    });
    all('[data-wb-kb-opt]').forEach(function (row) {
      row.classList.toggle('is-on', (state.qty[row.getAttribute('data-wb-kb-opt')] || 0) > 0);
    });
    /* The count on the picture. Hidden at zero rather than showing "0" — an
       empty row is already visibly empty, and a badge on every size would
       stop meaning anything. */
    all('[data-wb-kb-badge]').forEach(function (b) {
      var bn = state.qty[b.getAttribute('data-wb-kb-badge')] || 0;
      b.hidden = bn <= 0;
      if (bn > 0) b.textContent = bn;
    });
    /* ⚠ Runs LAST of the paint steps. It walks the DOM setting each remove
       button visible or not, and the review rows are rebuilt on every render
       — running it earlier left every fresh row's button at its default
       hidden, which a script can still click while nobody can see it. */
    all('[data-wb-kb-rowclear]').forEach(function (b) {
      b.style.visibility = (state.qty[b.getAttribute('data-wb-kb-rowclear')] || 0) > 0 ? 'visible' : 'hidden';
    });
    paintShown();
  }

  function cssq(s) { return String(s).replace(/["\\]/g, '\\$&'); }

  /* ── undo ─────────────────────────────────────────────────────────── */

  function offerUndo(key, n) {
    var found = findSize(key);
    if (!found) return;
    lastRemoved = { key: key, qty: n };
    var bar = el('[data-wb-kb-undobar]');
    if (!bar) return;
    var t = el('[data-wb-kb-undotext]');
    if (t) t.textContent = fill(cfg.t.undo_removed, { '@@N@@': n, '@@S@@': found.size.label });
    bar.hidden = false;
    if (undoTimer) clearTimeout(undoTimer);
    undoTimer = setTimeout(hideUndo, 9000);
  }

  function hideUndo() {
    lastRemoved = null;
    if (undoTimer) { clearTimeout(undoTimer); undoTimer = null; }
    var bar = el('[data-wb-kb-undobar]');
    if (bar) bar.hidden = true;
  }

  /* ── the edit modal, opened from a bench tile ─────────────────────── */

  function buildModal() {
    var m = document.createElement('div');
    m.className = 'wb-kb__modal';
    m.hidden = true;
    m.setAttribute('data-wb-kb-modal', '');
    m.innerHTML = '<div class="wb-kb__mback" data-wb-kb-mclose></div>' +
      '<div class="wb-kb__mcard" role="dialog" aria-modal="true">' +
        '<div class="wb-kb__mhead"><b data-wb-kb-mtitle></b>' +
          '<button type="button" class="wb-kb__mx" data-wb-kb-mclose ' +
            'aria-label="' + esc(cfg.t.edit_close) + '">&times;</button></div>' +
        '<div class="wb-kb__mbody no-empty" data-wb-kb-mbody></div>' +
        '<div class="wb-kb__mfoot"><button type="button" class="wb-kb__mok" data-wb-kb-mclose>' +
          esc(cfg.t.edit_ok) + '</button></div>' +
      '</div>';
    var stage = el('.wb-kb__stage');
    if (stage) stage.appendChild(m);
  }

  function openModal(key) {
    var s = seriesOf(key);
    if (!s) return;
    modalSec = key;
    var t = el('[data-wb-kb-mtitle]');
    if (t) t.textContent = s.label;
    var body = el('[data-wb-kb-mbody]');
    if (body) {
      body.innerHTML = s.sizes.map(function (size) {
        var k = qtyKey(s.key, size.size);
        return '<div class="wb-kb__mrow">' +
          artCell('wb-kb__mart', size, 40) +
          /* ⚠ The SHORT label, the same one the bench plate carries. The full
             title is up to 35 characters ("1\" Cleco Side Grip Clamp - Brass")
             in a column that is 101px wide on a phone, so two variants of one
             clamp both ellipsised to "1\" Cleco Side G..." — the exact
             distinction the customer opened this dialog to make. The dialog's
             own heading already names the series, so the short label is the
             only part of the title that is news. aria-label keeps the FULL
             title, which is what a screen reader should hear. */
          '<span class="wb-kb__mname">' + esc(size.short || size.label) + '</span>' +
          stepperHTML(k, size.label) +
          rowRemove(k, size.label, false) +
        '</div>';
      }).join('');
    }
    var m = el('[data-wb-kb-modal]');
    if (m) m.hidden = false;
    /* ⚠ The phone's Preview/Close pill is FIXED to the top-right corner, so
       it floats over this dialog — two round white "close" controls on one
       screen, and the higher one closes the whole preview rather than the
       dialog. Owen, 2026-09-06: "it's easy for the user to confuse that
       preview close button for the modal close button."
       A class on the root rather than :has() in the stylesheet: this file
       already drives is-editing the same way, and the two functions that own
       the dialog's open state are the two that own the flag. */
    root.classList.add('is-modal');
    syncRows();
  }

  function closeModal() {
    modalSec = null;
    var m = el('[data-wb-kb-modal]');
    if (m) m.hidden = true;
    root.classList.remove('is-modal');
  }

  /* ── save my kit ──────────────────────────────────────────────────── */

  /* The share link. fromLink() has always been able to READ one — this is the
     half that was missing, which is why the field showed the word "undefined":
     copyLink() was assigning save(), and save() only writes sessionStorage.

     Emits the OPTIMISER's chosen rungs as SKU:count, the same shape
     snippets/wb-cart-kit.liquid builds for its "edit kit" link and the same
     shape fromLink() decodes (it multiplies each count by that rung's packQty
     to get back to a piece count). So a link always restores the kit someone
     would actually be charged for, not a pile of singles.

     ⚠ Built from the builder's OWN page URL, not location.pathname: the
     section also renders behind a ?view= preview, and a link built from that
     path would send someone to a page that is not the builder.

     ⚠ The kit NAME goes in, but the kid does NOT. kid identifies a kit already
     sitting in the sender's cart; putting it in a link someone else opens
     would have them editing a cart line they do not have. */
  function linkFor() {
    var b = basket();
    if (!b.lines.length && !(b.kitSwap && b.kitSwap.kits.length)) return '';
    var spec = [];
    for (var i = 0; i < b.lines.length; i++) {
      var r = b.lines[i].rung;
      if (!r || !r.sku) continue;
      spec.push(encodeURIComponent(r.sku) + ':' + b.lines[i].count);
    }
    /* Swapped kits ship in the link as their own SKU. fromLink() expands them
       back into component piece counts, and the swap pass re-derives the kit
       on arrival — so the link stays a plain SKU:qty list and old links stay
       readable. */
    if (b.kitSwap) {
      for (var kx = 0; kx < b.kitSwap.kits.length; kx++) {
        spec.push(encodeURIComponent(b.kitSwap.kits[kx].kit.sku) + ':' + b.kitSwap.kits[kx].m);
      }
    }
    if (!spec.length) return '';
    var base = cfg.pageUrl || window.location.pathname;
    var url = window.location.origin + base + '?kit=' + spec.join(',');
    var nameEl = root.querySelector('[data-wb-kb-name]');
    var nm = nameEl && nameEl.value.trim();
    if (nm) url += '&name=' + encodeURIComponent(nm);
    return url;
  }

  /* ── emailing the kit ──────────────────────────────────────────────────
     Posted to OUR proxy, never straight to Klaviyo. Klaviyo's client endpoint
     takes the public site key, which is public by definition — anyone could
     make it send Pilot Gear email to addresses of their choosing. The proxy
     holds the private key, checks the address, rate-limits, and stamps a token
     the flow filters on, so a client-side forgery triggers nothing. */
  /* ── email me my kit ────────────────────────────────────────────────────
     One popup, two fields. It was an inline panel under the button until
     2026-09-07, and on a phone it opened below the fold — Owen: press the
     button, nothing appears to happen.

     ⚠ Name AND address together. The kit needs a name because the subject
     line is "Your cleco kit <name>" and the shelf, the resume dialog and the
     cart line all key off the same string; asking afterwards meant answering
     a question that arrived after the decision.

     ⚠ Built in JS, so every string comes from cfg.t. Anything only `| t`'d in
     the section's markup arrives undefined — the trap that has cost this file
     six keys, two of them during this change. */
  function askEmail() {
    var href = linkFor();
    if (!href) { announce(cfg.t.email_empty); return; }
    /* ⚠ NOT defaultKitName(). A generated "Kit 7 Sep" sitting in the field
       reads as a name the customer chose, and the placeholder is the honest
       way to suggest one. An existing name IS pre-filled — that one they did
       choose. Owen, 2026-09-07: "let the user name the field." */
    var nm = (state.name || '').trim();

    var html =
      '<div class="wb-kb__emform">' +
        '<label class="wb-kb__emlab" for="wbKbEmName">' + esc(cfg.t.name_label) + '</label>' +
        '<input type="text" id="wbKbEmName" class="wb-kb__cfield" maxlength="60"' +
          ' data-wb-kb-emname value="' + esc(nm) + '"' +
          ' placeholder="' + esc(cfg.t.name_placeholder) + '">' +
        '<label class="wb-kb__emlab" for="wbKbEmAddr">' + esc(cfg.t.email_addr) + '</label>' +
        '<input type="email" id="wbKbEmAddr" class="wb-kb__cfield" inputmode="email"' +
          ' autocomplete="email" data-wb-kb-emaddr' +
          ' placeholder="' + esc(cfg.t.email_ph) + '">' +
        '<label class="wb-kb__optin">' +
          '<input type="checkbox" data-wb-kb-emoptin>' +
          '<span>' + esc(cfg.t.email_optin) + '</span>' +
        '</label>' +
        '<span class="wb-kb__copynote no-empty" data-wb-kb-emnote></span>' +
      '</div>';

    askConfirm(cfg.t.email_btn, cfg.t.email_b, [
      { label: cfg.t.del_cancel },
      { label: cfg.t.email_go, primary: true, takes: true, go: function () {
          var host = el('[data-wb-kb-chtml]', confirmEl);
          var nameEl = host.querySelector('[data-wb-kb-emname]');
          var addrEl = host.querySelector('[data-wb-kb-emaddr]');
          var optEl  = host.querySelector('[data-wb-kb-emoptin]');
          var note   = host.querySelector('[data-wb-kb-emnote]');
          var name = (nameEl.value || '').trim();
          var addr = (addrEl.value || '').trim();
          /* ⚠ No defaultKitName() fallback any more. It used to fill in for an
             empty field, which is how Owen sent a kit with no name at all
             after clearing it — the gate below now stops that happening, and
             this is the second lock on the same door. */
          if (!name) { note.textContent = cfg.t.name_label; nameEl.focus(); return false; }
          /* Deliberately loose. The proxy and Klaviyo both validate properly;
             this only catches the obvious typo. */
          if (!addr || addr.indexOf('@') < 1 || addr.indexOf('.', addr.indexOf('@')) < 0) {
            note.textContent = cfg.t.email_bad;
            addrEl.focus();
            return false;
          }

          state.name = name;
          var nl = root.querySelector('[data-wb-kb-name]');
          if (nl) nl.value = name;
          /* save(), so the name reaches sessionStorage and the shelf record
             rather than living only in this tab's memory. */
          save();

          note.textContent = cfg.t.email_sending;
          /* ⚠ Stamp the dialog generation. The response lands whenever it
             lands, and by then the customer may have closed this and opened
             something else — acting on "the dialog" from a stale callback
             would rewrite whatever is up now. */
          var gen = confirmGen;
          var b = basket();
          postKit(addr, href, name, b.units, sizeCount(), kitItems(state.qty),
            !!(optEl && optEl.checked),
            function (ok) {
              if (confirmGen !== gen) return;
              note.textContent = ok
                ? fill(cfg.t.email_done, { '@@E@@': addr })
                : cfg.t.email_fail;
              announce(note.textContent);
              if (!ok) return;
              /* ⚠ It stays open. It used to close itself a second and a half
                 after sending, which took the confirmation with it — Owen,
                 2026-09-07: "don't close the modal automatically, just remove
                 the button and say email sent." So: the send control goes,
                 the form is frozen because editing it can no longer do
                 anything, and Cancel becomes Close because there is nothing
                 left to cancel. */
              var btns = el('[data-wb-kb-cbtns]', confirmEl);
              var goBtn = btns && btns.querySelector('.wb-kb__cgo');
              if (goBtn) goBtn.remove();
              var quit = btns && btns.querySelector('.wb-kb__cno');
              if (quit) quit.textContent = cfg.t.bub_close;
              all('input', host).forEach(function (i) { i.disabled = true; });
            });
          /* false: hold the dialog open while the request is in flight. */
          return false;
        } }
    ], null, {
      html: html,
      wire: function (host) {
        var send = el('[data-wb-kb-cbtns] .wb-kb__cgo', confirmEl);
        var nameEl = host.querySelector('[data-wb-kb-emname]');
        var addrEl = host.querySelector('[data-wb-kb-emaddr]');

        /* ⚠ Send is dead until both fields have something in them. Owen sent a
           kit with an empty name by clearing the pre-filled one, and a dead
           button says "not yet" before the press rather than after it. */
        function sync() {
          if (!send) return;
          send.disabled = !(nameEl.value || '').trim() || !(addrEl.value || '').trim();
        }
        [nameEl, addrEl].forEach(function (inp) {
          inp.addEventListener('input', sync);
          /* ⚠ Enter has to be bound here. askConfirm wires it to the `takes`
             button only for its OWN single field, and this form brings two.
             isConnected, because the button is removed once the kit is sent. */
          inp.addEventListener('keydown', function (e) {
            if (e.key !== 'Enter') return;
            e.preventDefault();
            if (send && send.isConnected && !send.disabled) send.click();
          });
        });
        sync();

        /* The name is the first thing being asked for now that it is not
           pre-filled. select() matters only for a kit that already has one. */
        setTimeout(function () {
          try { nameEl.focus({ preventScroll: true }); } catch (e) { nameEl.focus(); }
          try { nameEl.select(); } catch (e) {}
        }, 40);
      }
    });
  }

  /* Twelve thumbnails is already a full grid in a 600px email, and the art
     files are ~60KB each with no CDN resize available on theme assets, so the
     cap is about the customer's data as much as the layout. Anything past it
     is counted, not drawn. */
  var EMAIL_ITEM_CAP = 12;

  function postKit(addr, href, name, pieces, sizes, items, optin, done) {
    if (!cfg.t.email_url) { done(false); return; }
    var req, list = items || [];
    try {
      req = window.fetch(cfg.t.email_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: addr, kit_link: href, kit_name: name,
          pieces: pieces, sizes: sizes, optin: !!optin,
          items: list.slice(0, EMAIL_ITEM_CAP),
          items_more: Math.max(0, list.length - EMAIL_ITEM_CAP)
        })
      });
    } catch (e) { done(false); return; }
    req.then(function (r) { done(r && r.ok); }, function () { done(false); });
  }

  var linkTimer = null, linkLabel = '';

  function copyLink() {
    var input = el('[data-wb-kb-linkfield]');
    var note = el('[data-wb-kb-copynote]');
    if (!input) return;
    var href = linkFor();
    /* An empty kit has nothing to link to. Say so rather than handing over a
       bare URL that would restore nothing. */
    if (!href) { input.value = ''; if (note) note.textContent = cfg.t.save_empty; return; }
    input.value = href;
    input.select();
    try { input.setSelectionRange(0, 99999); } catch (e) {}
    function done(ok) { if (note) note.textContent = ok ? cfg.t.save_copied : cfg.t.save_manual; }
    /* The async clipboard is refused outright in some embedded contexts, so
       the old selection-based copy stays as the fallback rather than leaving
       the button silently dead. */
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(input.value).then(function () { done(true); }, function () {
        try { done(document.execCommand('copy')); } catch (e2) { done(false); }
      });
    } else {
      try { done(document.execCommand('copy')); } catch (e3) { done(false); }
    }
  }

  /* ── the one render ───────────────────────────────────────────────── */

  /* ── the finished state ────────────────────────────────────────────────
     What the builder shows once a kit is in the cart. Owen, 2026-09-06: the
     drawer opens, but "a user's instinct might be to close it if they are not
     wanting to buy yet and then they are left with an empty builder on the
     kit review part of it."

     Deliberately NOT a redirect. The drawer is open when this runs, and any
     navigation would tear down the confirmation the customer just triggered;
     /cart is also pure duplication of the drawer, and the builder page is
     exactly where someone goes to build a second kit. What was wrong was
     narrower than the page — the wizard simply never left the review step.

     Holds a SNAPSHOT of what went into the cart, because addToCart empties
     state.qty on the way out. The snapshot is what "Save this kit" writes, and
     what the counts are drawn from. */
  var justAdded = null;

  function doneHTML() {
    var routes = (window.FoxTheme && FoxTheme.routes) || {};
    var cartUrl = cfg.t.cart_url || routes.cart_url || '/cart';
    var lines = justAdded.lines === 1
      ? cfg.t.ed_lines_one
      : fill(cfg.t.ed_lines, { '@@N@@': justAdded.lines });
    var meta = [lines, fill(cfg.t.cell_pieces, { '@@N@@': justAdded.pieces }), money(justAdded.total)];
    return '' +
      '<div class="wb-kb__donecard">' +
        '<b class="wb-kb__donet">' +
          esc(fill(cfg.t.done_t, { '@@NAME@@': justAdded.name })) + '</b>' +
        '<span class="wb-kb__donemeta">' + esc(meta.join(' \u00b7 ')) + '</span>' +
        '<span class="wb-kb__donesub">' + esc(cfg.t.done_sub) + '</span>' +
        '<div class="wb-kb__doneacts">' +
          /* ⚠ A real form post with name="checkout", the same pattern
             sections/cart-drawer.liquid uses. There is no routes.checkout_url
             in Liquid and a hardcoded "/checkout" is not safe across the 21
             locales this store runs; posting to routes.cart_url is. */
          '<form class="wb-kb__donebuy" action="' + esc(cartUrl) + '" method="post">' +
            '<button type="submit" name="checkout" class="wb-kb__donego">' +
              esc(cfg.t.checkout) + '</button>' +
          '</form>' +
          '<a class="wb-kb__donelink" href="' + esc(cartUrl) + '">' + esc(cfg.t.view_cart) + '</a>' +
        '</div>' +
        '<div class="wb-kb__donemore">' +
          '<button type="button" class="wb-kb__donetext" data-wb-kb-again>' +
            esc(cfg.t.done_again) + '</button>' +
          '<button type="button" class="wb-kb__donetext' + (justAdded.saved ? ' is-done' : '') + '"' +
            ' data-wb-kb-donesave' + (justAdded.saved ? ' disabled' : '') + '>' +
            esc(justAdded.saved ? cfg.t.savekit_done : cfg.t.savekit) + '</button>' +
          (cfg.t.shop_url
            ? '<a class="wb-kb__donetext" href="' + esc(cfg.t.shop_url) + '">' +
                esc(cfg.t.keep_shopping) + '</a>'
            : '') +
        '</div>' +
      '</div>';
  }

  function renderDone() {
    var host = el('[data-wb-kb-done]');
    root.classList.toggle('is-done', !!justAdded);
    if (!host) return;
    host.innerHTML = justAdded ? doneHTML() : '';
  }

  /* ⚠ shelfEditId is cleared afterwards, NOT left pointing at the new record.
     autosaveShelf() writes whatever is on the bench over the record that id
     names, on a 700ms debounce after any quantity change — so leaving it set
     would mean the customer's NEXT kit silently overwrote the one they just
     asked to keep. This record is a snapshot of something already in the
     cart; nothing that happens on the bench afterwards belongs in it. */
  function saveAdded() {
    if (!justAdded || justAdded.saved) return;
    var keepQty = state.qty, keepName = state.name;
    state.qty = justAdded.qty;
    state.name = justAdded.name;
    saveKit('auto');
    state.qty = keepQty;
    state.name = keepName;
    shelfEditId = null;
    justAdded.saved = saveState !== 'fail';
    renderDone();
  }

  function render() {
    renderBoard();
    renderTray();
    renderReview();
    renderDone();
    syncAdvance();
    syncRows();
    /* ⚠ Persist on every render. save() used to be called ONLY from the three
       places that wanted a link out of it, so a kit built without ever opening
       the save panel was never written down and restore() had nothing to read
       — the wizard forgot everything on refresh. The two jobs were tangled in
       one function: save() writes, linkFor() addresses. */
    save();
    syncSaveBtn();
    var panel = el('[data-wb-kb-savepanel]');
    if (panel && !panel.hidden) {
      var lrow = el('[data-wb-kb-linkrow]');
      var f = (!lrow || !lrow.hidden) ? el('[data-wb-kb-linkfield]') : null;
      if (f) f.value = linkFor();
      var n = el('[data-wb-kb-copynote]');
      if (n) n.textContent = '';
    }
  }

  /* Kept for the engine, which opens a conditional group when a saved kit is
     restored into one. Sections are always present now, so this only needs to
     bring the group into view. */
  function openCond(name, on) {
    if (!on) return;
    var sec = el('[data-wb-kb-sec="' + cssq(name) + '"]');
    if (sec) sec.hidden = false;
  }

  /* ── scroll drives the stage ──────────────────────────────────────── */

  /* ── step one: pick, then count ────────────────────────────────────────
     The first step asks WHICH sizes before HOW MANY. It is a PHASE of step
     'c', not a step of its own — the walk is still 8 steps and the counter
     still says so.

     ⚠ Selection is deliberately NOT new state. Everything downstream already
     tests qty > 0 to decide what is in the kit, so choosing a size IS setting
     its quantity: pick = setQty(20), unpick = setQty(0). A parallel `picked`
     set would desynchronise the moment anything else wrote a quantity behind
     it — the share link, restore(), unsure(), or the steppers on this very
     step — and would have to be versioned into save()/restore(). This way
     none of that is touched.

     ⚠ 20 goes through setQty, never into state.qty directly, so it is clamped
     to what the store can actually sell: a size with 3 units left lands on 3. */
  var PICK_STEP = 'c';
  /* ⚠ ONE, not twenty. Owen, 2026-09-03: the point of the counting screen is
     watching the kit grow, and seeding 20 hands over a finished pile with
     nothing to do. The quick-adds (+5/+10/+20/+50) carry anyone who knows
     what they want. */
  var PICK_QTY = 1;
  var phase = '';   /* '' once past it; 'pick' while choosing */

  function pickSection(){ return el('[data-wb-kb-sec="' + PICK_STEP + '"]'); }

  function inPick(){ return phase === 'pick'; }

  function pickSizes(){
    var sr = seriesOf(PICK_STEP);
    return sr ? sr.sizes.filter(function (z) { return buyableSize(z) && artFor(z); }) : [];
  }

  function buildPick(){
    var host = el('[data-wb-kb-chips="' + cssq(PICK_STEP) + '"]');
    if (!host) return;
    var html = '';
    pickSizes().forEach(function (z) {
      var k = qtyKey(PICK_STEP, z.size);
      var on = (state.qty[k] || 0) > 0;
      html += '<button type="button" class="wb-kb__chip' + (on ? ' is-on' : '') +
        '" data-wb-kb-pick="' + esc(k) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
        '<span class="wb-kb__chiptick" aria-hidden="true">\u2713</span>' +
        '<span class="wb-kb__chipart"><img src="' + esc(artFor(z)) + '" alt="" loading="lazy"></span>' +
        '<span class="wb-kb__chipsz">' + esc(z.label || z.size) + '</span>' +
        (function () {
          /* The same two templates the option rows use, so "2.4" reads as
             "2.4 mm" here too and the unit never goes missing on one screen. */
          var bits = [];
          if (z.mm) bits.push(fill(cfg.t.mm_line, { '@@M@@': esc(z.mm) }));
          if (z.drill) bits.push(fill(cfg.t.drill_line, { '@@D@@': esc(z.drill) }));
          return bits.length ? '<span class="wb-kb__chipsp">' + bits.join(' \u00b7 ') + '</span>' : '';
        })() +
        '</button>';
    });
    host.innerHTML = html;
  }

  function syncPickChips(){
    all('[data-wb-kb-pick]').forEach(function (b) {
      var on = (state.qty[b.getAttribute('data-wb-kb-pick')] || 0) > 0;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', String(on));
    });
  }

  function anyPicked(){
    return pickSizes().some(function (z) { return (state.qty[qtyKey(PICK_STEP, z.size)] || 0) > 0; });
  }

  /* ⚠ TWO different things used to share this predicate, and that is why the
     panel floated on the counting step and then snapped back to a column on
     the next one. They are separate questions:

       isWide()      — does the PANEL float over a full-bleed stage?  Every
                       step from counting onward, so the chrome never changes
                       shape mid-walk. Not during picking, which is its own
                       centred full-bleed screen with no panel to float.
       isCountList() — is the BENCH a left-aligned column?  Only the counting
                       step, where the chips fly in to a list and each add
                       appends to the right. Everywhere else it is a bench. */
  function isWide() {
    return window.innerWidth > 1080 && !inPick();
  }

  /* FIRST/LAST on the panel alone. The card and the column are different
     widths in different places, so without this the panel teleports while
     the bench beside it eases — the one thing that would give the move away
     as two separate effects rather than one. Position only: scaling a panel
     full of text smears it, and the reflow underneath is a single frame. */
  function flipPanel(mutate) {
    var panel = el('.wb-kb__flow');
    if (!panel || REDUCED || typeof panel.animate !== 'function') { mutate(); return; }
    var a = panel.getBoundingClientRect();
    mutate();
    var b = panel.getBoundingClientRect();
    var dx = a.left - b.left, dy = a.top - b.top;
    if (!dx && !dy) return;
    panel.animate(
      [{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }],
      { duration: 520, easing: 'cubic-bezier(.22,.9,.25,1)' });
  }

  /* Returns whether the shape changed, because the caller then has to redraw
     the board: perLine() bakes the line length into the markup, so a cell
     that merely gets re-sized keeps the wrong one. */
  var lastColumn = null;
  function syncWide() {
    var split = el('.wb-kb__split');
    if (!split) return false;
    /* Either change forces a redraw: the panel's width changes how much room
       the bench has, and the column flag changes the markup perLine bakes in. */
    var col = isCountList(), colChanged = col !== lastColumn;
    lastColumn = col;
    var want = isWide();
    if (want === split.classList.contains('is-wide')) return colChanged;
    flipPanel(function () { split.classList.toggle('is-wide', want); });
    return true;
  }

  function paintPhase(){
    var sec = pickSection(), split = el('.wb-kb__split');
    /* ⚠ The chips read their tick from state.qty, and nothing in render()
       repaints them — showStep sets the phase directly rather than going
       through enterPick(). So a bench emptied by anything other than a chip
       press (addToCart clears state.qty wholesale) left every tick where it
       was: "Build another kit" landed on step one with sizes apparently
       selected and "Set quantities" greyed out beside them, which is the
       contradiction Owen photographed. Cheap enough to do on every paint. */
    syncPickChips();
    /* ⚠ The pick phase and the expanded bench hide OPPOSITE panes, and with
       both classes on they hide the whole page: is-pick hides the stage
       (css:1526, deliberate — the chooser is full-bleed) while is-stage-full
       hides the walk. The result is a white screen carrying no control at
       all, because the one way back out lives in the stage bar that is-pick
       just collapsed to 0x0. Only a reload escapes it. Owen hit it from the
       Preview button on step 1, 2026-09-06.

       Hiding that button is the other half of this fix, but it is not
       sufficient on its own: pressing Back from the counting phase returns
       to picking, and would have carried a live is-stage-full straight into
       the same dead end. Leaving the view here closes both doors. */
    if (inPick() && view === VIEWS.stage) setView('');
    if (sec) sec.classList.toggle('is-pick', inPick());
    if (split) split.classList.toggle('is-pick', inPick());
    var go = sec && el('[data-wb-kb-next]', sec);
    if (go) {
      var lab = el('[data-wb-kb-golabel]', go);
      /* ⚠ The gate is "is there a kit yet", NOT "has a standard cleco been
         picked". anyPicked() only ever looks at the C series, so a customer
         who came back to step one with 25 clamps in the kit met a dead grey
         button and the only way on was to add a standard cleco they did not
         want — this is the greyed Next Owen reported, 2026-09-07. Every other
         step in the walk offers "Skip"; this one had no way past at all.

         The first-visit funnel is untouched: an empty kit still has to answer
         the question, which is what the step is for. */
      var skipPick = inPick() && !anyPicked() && basket().units > 0;
      if (inPick() && lab) {
        lab.textContent = skipPick ? labelFor(PICK_STEP) : (cfg.t.pick_next || 'Set quantities');
      }
      go.disabled = inPick() && !anyPicked() && !skipPick;
    }
    var back = sec && el('[data-wb-kb-back]', sec);
    if (back) back.hidden = inPick();
    /* Lets the stylesheet swap the picking lede for the counting one. */
    if (sec) sec.classList.toggle('is-count', isCountList());
    /* Leaving the picking phase for the quantities also widens the bench. */
    if (syncWide()) { renderBoard(); fitBoard(); }
  }

  /* The chips fly to the places their pieces will occupy on the bench.
     ⚠ GHOSTS, not the chips themselves: renderBoard() rebuilds the board with
     innerHTML, so anything re-parented into it is destroyed mid-flight. A
     fixed-position clone is also immune to the board's own scale transform. */
  function flyToBench(fromRects){
    if (REDUCED) return;
    var board = el('[data-wb-kb-board]');
    if (!board) return;
    fromRects.forEach(function (f) {
      var target = el('[data-wb-kb-grp="' + cssq(f.key) + '"]', board);
      if (!target) return;
      var t = target.getBoundingClientRect();
      if (!t.width || !f.rect.width) return;
      /* Aim at the size's FIRST piece, not the whole group: the group also
         holds its plate, so its centre sits below the fasteners. */
      var landing = el('img', target) || target;
      var t2 = landing.getBoundingClientRect();
      var g = f.node.cloneNode(true);
      g.className = 'wb-kb__ghost-fly';
      g.style.left = f.rect.left + 'px';
      g.style.top = f.rect.top + 'px';
      g.style.width = f.rect.width + 'px';
      g.style.height = f.rect.height + 'px';
      document.body.appendChild(g);
      var dx = (t2.left + t2.width / 2) - (f.rect.left + f.rect.width / 2);
      var dy = (t2.top + t2.height / 2) - (f.rect.top + f.rect.height / 2);
      var sc = Math.max(.15, Math.min(1.6, t2.height / Math.max(1, f.rect.height)));
      /* The real piece holds still until its ghost lands on it, so the eye
         sees ONE object travelling rather than a copy chasing an original. */
      landing.style.opacity = '0';
      g.animate(
        [{ transform: 'none', opacity: 1 },
         { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + sc + ')', opacity: 1 }],
        { duration: 560, easing: 'cubic-bezier(.22,.9,.25,1)' }
      ).onfinish = function () {
        landing.style.opacity = '';
        if (g.parentNode) g.parentNode.removeChild(g);
      };
    });
  }

  /* ── which sizes the count step lists ────────────────────────────────
     The pick step IS the decision, so the count step shows only what was
     picked; listing the other sizes again asks the same question twice.

     ⚠ NOT simply "qty > 0". Counting a size to zero un-picks it, and a list
     filtered on the live count would make a row VANISH the moment "−" hits
     zero. So this is a set: seeded from the pick, grown whenever a size goes
     non-zero (a quick-add, "add 5 of each") or when the disclosure is opened,
     and only ever cleared by going back to re-pick. A row at zero stays put,
     bin and all, until the customer leaves. Memory only, never saved — a
     restored or shared kit rebuilds it from what is in it. */
  var shown = {};
  function isCountList() { return active === PICK_STEP && !inPick(); }
  function revealPicked() {
    var s = seriesOf(PICK_STEP);
    if (!s) return;
    for (var i = 0; i < s.sizes.length; i++) {
      var k = qtyKey(s.key, s.sizes[i].size);
      if ((state.qty[k] || 0) > 0) shown[k] = true;
    }
  }
  function revealAll() {
    var s = seriesOf(PICK_STEP);
    if (!s) return;
    for (var i = 0; i < s.sizes.length; i++) shown[qtyKey(s.key, s.sizes[i].size)] = true;
  }
  function paintShown() {
    var host = el('[data-wb-kb-list="' + cssq(PICK_STEP) + '"]');
    if (!host) return;
    var filter = isCountList(), hiddenN = 0;
    all('[data-wb-kb-opt]', host).forEach(function (row) {
      var k = row.getAttribute('data-wb-kb-opt');
      if ((state.qty[k] || 0) > 0) shown[k] = true;
      var hide = filter && !shown[k];
      row.hidden = hide;
      if (hide) hiddenN++;
    });
    var more = el('[data-wb-kb-more]');
    if (!more) return;
    more.hidden = !filter || hiddenN === 0;
    var n = el('[data-wb-kb-more-n]', more);
    if (n) n.textContent = fill(cfg.t.pick_more_sub || '', { '@@N@@': hiddenN });
  }

  function leavePick(){
    var chips = all('[data-wb-kb-pick]').filter(function (b) {
      return (state.qty[b.getAttribute('data-wb-kb-pick')] || 0) > 0;
    });
    /* FIRST: where each chosen size sits in the horizontal row. */
    var from = chips.map(function (b) {
      return { key: b.getAttribute('data-wb-kb-pick'),
               node: el('.wb-kb__chipart img', b) || b,
               rect: (el('.wb-kb__chipart img', b) || b).getBoundingClientRect() };
    });
    phase = '';
    paintPhase();
    revealPicked();
    paintShown();
    /* LAST: the bench must be on screen and re-fitted before it can be
       measured, so the layout change happens before the flight is planned. */
    renderBoard();
    flyToBench(from);
    slideInPanel();
    syncAdvance();
  }

  /* The counting column arrives the way the cart drawer does — from the right,
     over the layout that has just changed shape beneath it. Only here: steps
     2-8 do not change shape, and a panel that re-slides on every Next stops
     being a moment and becomes a tic. */
  function slideInPanel(){
    if (REDUCED) return;
    var panel = el('.wb-kb__flow');
    if (!panel) return;
    panel.animate(
      [{ transform: 'translateX(26px)', opacity: 0 }, { transform: 'none', opacity: 1 }],
      { duration: 420, easing: 'cubic-bezier(.22,.9,.25,1)' }
    );
  }

  function enterPick(){
    phase = 'pick';
    shown = {};
    paintPhase();
    paintShown();
    syncPickChips();
  }

  /* ── stepping: one step on screen at a time ───────────────────────────
     The walk was a scroll: every step rendered, and where you were in the
     page decided which one was "active". Stepping keeps every step in the
     DOM and hides all but one — so a crawler and a no-JS visitor still get
     the whole walk, including the server-rendered product list under each
     step, which is the only reason those lists exist.

     `active` and everything it drives (the large part on the bench, the
     typewriter, the Next label) are unchanged. Only what SETS it changes:
     an explicit move instead of a scroll position. */
  var STEP_HASH = 'step-';
  var pushed = 0;   /* how many steps we put in history — see stepBack() */

  function hashStep() {
    var h = (window.location.hash || '').replace(/^#/, '');
    if (h.indexOf(STEP_HASH) !== 0) return '';
    var id = h.slice(STEP_HASH.length);
    return sectionIds().indexOf(id) >= 0 ? id : '';
  }

  /* Put the top of the walk under the site chrome. Instant, not smooth: a
     wizard should land on the next step, and the theme's smooth scrolling is
     a silent no-op in some embedded views anyway. */
  function scrollWalkTop() {
    var split = el('.wb-kb__split');
    if (!split) return;
    var y = window.scrollY + split.getBoundingClientRect().top - stickyTop() - 4;
    window.scrollTo(0, Math.max(0, Math.round(y)));
  }

  /* How much screen the walk actually has, for the button panel that sits on
     the floor of it.

     ⚠ This cannot be a pure CSS sum. The walk's top depends on the scroll
     position — the bench above it is sticky, and at the top of the page the
     announcement bar is still on screen pushing everything down, so
     `100svh - header - bench` is right only once the page has scrolled to the
     walk. Measuring the walk's real top is right at every position.

     Reading the top and writing the height is not a feedback loop: what sits
     ABOVE the flow decides its top, and nothing above it depends on its
     height. */
  function syncAvail() {
    var flow = el('.wb-kb__flow');
    if (!flow) return;
    var avail = Math.round(window.innerHeight - flow.getBoundingClientRect().top);
    /* A floor, because a walk squeezed under a tall header is worse than one
       that scrolls: below this the step would have no room for its own copy. */
    avail = Math.max(260, Math.min(2000, avail));
    root.style.setProperty('--wb-kb-avail', avail + 'px');
  }

  function announceStep(id) {
    var sec = el('[data-wb-kb-sec="' + cssq(id) + '"]');
    if (!sec) return;
    /* Read what is already on screen rather than inventing a second set of
       strings to keep translated in 21 languages. */
    var num = el('.wb-kb__stepnum', sec), h = el('.wb-kb__sectitle', sec);
    if (h) announce((num ? num.textContent + '. ' : '') + h.textContent);
  }

  function showStep(id, opts) {
    opts = opts || {};
    var ids = sectionIds();
    if (ids.indexOf(id) < 0) id = ids[0];
    if (!id) return;

    all('[data-wb-kb-sec]').forEach(function (sec) {
      sec.classList.toggle('is-current', sec.getAttribute('data-wb-kb-sec') === id);
    });
    active = id;
    /* The review carries its own Preview button, inside the editor header, so
       the fixed pill would be the SECOND one on that screen. The stylesheet
       drops the pill there — but only while the preview is shut, because the
       pill is also the only Close: the editor header lives in .wb-kb__flow,
       which the expanded bench hides. */
    root.classList.toggle('is-review', id === 'review');

    /* Same sequence the scroll watcher used, so the bench behaves identically:
       build the cell if it is new, otherwise just re-size the active one. */
    flip(function () {
      /* ⚠ Inside the FLIP, and BEFORE the redraw. The width change is what
         the bench is easing between, so it has to be part of the same
         measure-mutate-play as everything else on the board — and a cell
         that already exists still needs rebuilding when the shape changed,
         or the wide line survives into the compact corner. */
      var reshaped = syncWide();
      if (reshaped || !el('[data-wb-kb-cell="' + cssq(id) + '"]')) renderBoard();
      else setActiveCell();
      syncAdvance();
    });
    typeActive();
    setTimeout(fitBoard, DUR + 40);

    var i = ids.indexOf(id);
    all('[data-wb-kb-back]').forEach(function (b) { b.hidden = i <= 0; });
    /* Step one opens on the picking phase until something is in it — coming
       back to a kit you already built should not re-ask which sizes. */
    if (id === PICK_STEP) { phase = anyPicked() ? '' : 'pick'; }
    else if (inPick()) { phase = ''; }
    paintPhase();
    if (isCountList()) revealPicked();
    paintShown();

    if (!opts.silent) {
      var url = '#' + STEP_HASH + id;
      try {
        /* ⚠ Carry wbKbGuard across. A replace overwrites the CURRENT entry's
           state, and the deferred jump-to-review fires 140ms after load —
           long enough to have silently wiped the back-guard sentinel that
           had just been armed on the very same entry. */
        if (opts.replace) {
          history.replaceState(
            { wbKbStep: id, wbKbGuard: (history.state || {}).wbKbGuard }, '', url
          );
        }
        else {
          /* Carry wbKbGuard onto every step entry too, so the whole of the
             builder's own history is marked. Leaving that marked run is what
             the back guard watches for — see the popstate handler. */
          history.pushState(
            { wbKbStep: id, wbKbGuard: (history.state || {}).wbKbGuard }, '', url
          );
          pushed++;
        }
      } catch (e) {}
    }
    if (!opts.keepScroll) scrollWalkTop();
    /* After the scroll, so the walk is measured where it has just landed. The
       second pass catches a browser that clamped the scroll because hiding the
       previous step made the document shorter. */
    syncAvail();
    setTimeout(syncAvail, 80);
    announceStep(id);
  }

  /* ⚠ The Back button and the phone's Back gesture must be ONE operation, or
     they disagree the moment someone mixes them. So Back pops history and
     lets popstate do the work — except when there is nothing of ours to pop
     (someone opened a shared #step- link straight into the middle of the
     walk), where popping would leave the site entirely. */
  function stepBack() {
    /* Back on step one, past the picking phase, means "let me re-choose" —
       not "leave the builder". */
    if (active === PICK_STEP && !inPick()) { enterPick(); return; }
    if (pushed > 0) { history.back(); return; }
    var ids = sectionIds(), i = ids.indexOf(active);
    if (ids[i - 1]) showStep(ids[i - 1], { replace: true });
  }

  function startStepping() {
    root.classList.add('is-stepped');
    root.classList.add('is-phased');
    buildPick();
    window.addEventListener('popstate', function (e) {
      pushed = Math.max(0, pushed - 1);
      /* ⚠ The trigger is LEAVING the marked run, not landing on the sentinel.
         Every entry the builder owns — the sentinel and each step above it —
         carries wbKbGuard, so the first entry WITHOUT it is the one below the
         sentinel: the customer has walked back past everything the builder
         put in history and the next press takes them off the page.
         Walking between steps lands on marked entries and is left alone. */
      if (backGuard && dirty && !leaving && !(e && e.state && e.state.wbKbGuard) && basket().units) {
        backGuard = false;
        askLeave(null);
        return;
      }
      showStep(hashStep() || sectionIds()[0], { silent: true });
    });
    var start = hashStep();
    /* No hash: restore() already jumps a rebuilt kit to the review, and that
       is still the right landing for someone opening their own saved link. */
    showStep(start || sectionIds()[0], { replace: true, keepScroll: true });
  }

  function scrollToSec(id, opts) {
    /* Every existing caller — Next, the tray's Review button, the jump from a
       restored kit — means "take me to this step". Routing them all through
       here keeps one door, so nothing had to learn about stepping. */
    if (root.classList.contains('is-stepped')) { showStep(id, opts); return; }
    var s = el('[data-wb-kb-sec="' + cssq(id) + '"]');
    if (!s) return;
    /* ⚠ Only the EXPANDED BENCH blocks this, because only it takes the walk
       out of the document — there is nothing to scroll to. With the LIST
       expanded every step is still there, and snapping back to the split
       would undo a view the customer chose on purpose. */
    if (view === VIEWS.stage) setView('');
    /* ⚠ The jump pills used to be the sticky bar at the top of the walk, and
       this offset was ITS height. With them gone the only sticky chrome above
       a step is the site header — resolved by stickyTop(), or every jump
       parks the step title underneath it. */
    var stuck = stickyTop();
    var y = window.scrollY + s.getBoundingClientRect().top - stuck - 8;
    var from = window.scrollY;
    try { window.scrollTo({ top: y, behavior: REDUCED ? 'auto' : 'smooth' }); }
    catch (e) { window.scrollTo(0, y); }
    /* Smooth scrolling is silently a no-op in some embedded views, and a
       control that visibly does nothing is worse than one that jumps. */
    setTimeout(function () {
      if (Math.abs(window.scrollY - from) < 4 && Math.abs(y - from) > 8) window.scrollTo(0, y);
    }, 320);
  }

  /* ── events ───────────────────────────────────────────────────────── */

  /* ── keeping the tray still while you use it ──────────────────────────
     Owen, 2026-09-05: "when I add to the kit using the bubbles, after
     pressing the plus icon for the first time, it jumps scroll and I
     temporarily lose awareness of what happened."

     Measured on a 430px viewport: the FIRST + on a type inserts a whole new
     group into the review list ABOVE the tray and pushes the panel down
     127px. The second + moves nothing — by then the group exists and only a
     number inside it changes. That is why it happens once per type and then
     stops, and why it is so disorienting: the control you are pressing walks
     out from under your thumb exactly once.

     The browser's own scroll anchoring is supposed to absorb this and does
     not, because every render replaces innerHTML wholesale and the node it
     anchored to no longer exists.

     So the tray host is the anchor instead: it is a Liquid element that is
     never replaced (only its contents are), so the same node can be measured
     on both sides of the render. Note where it sits before the click is
     handled, and afterwards put the scroll back by however far it moved.

     ⚠ Measured, never predicted. If the browser's anchoring ever does do its
     job here, the delta is simply zero and this does nothing. A predicted
     correction would double up with it and throw the page the other way.

     ⚠ TWO LISTENERS, and neither a timer. The first version measured in a
     MICROTASK and tested perfectly — from a script. It did nothing for a
     real customer, and this is why: a microtask checkpoint runs after every
     listener whose JS stack unwinds to empty. A synthetic el.click() keeps
     the calling script on the stack, so the checkpoint is deferred to the
     end and the microtask lands after the render. A REAL click has an empty
     stack between listeners, so the microtask ran BETWEEN capture and
     bubble — before the render — and measured a delta of zero. Verify
     anything timing-sensitive with a real click, never el.click().
     requestAnimationFrame is no good either: it does not run at all while
     the document is not being rendered.
     The reliable shape is two listeners on the same element: capture to
     measure, then bubble REGISTERED AFTER the rendering handler so it runs
     immediately after it — same task, before any paint, no scheduling. */
  function scrollerFor(node) {
    var n = node && node.parentElement;
    while (n && n !== document.body && n !== document.documentElement) {
      var cs = getComputedStyle(n);
      if ((cs.overflowY === 'auto' || cs.overflowY === 'scroll') && n.scrollHeight > n.clientHeight + 1) return n;
      n = n.parentElement;
    }
    return null;
  }

  var trayAnchor = null;

  root.addEventListener('click', function (e) {
    var t = e.target;
    trayAnchor = null;
    if (!t || !t.closest || !t.closest('.wb-kb__add')) return;
    var host = el('[data-wb-kb-addtray]');
    if (host) trayAnchor = { host: host, top: host.getBoundingClientRect().top };
  }, true);

  root.addEventListener('click', function (e) {
    var t = e.target;

    var fs = t.closest('[data-wb-kb-fs]');
    if (fs) {
      var want = VIEWS[fs.getAttribute('data-wb-kb-fs')];
      var opening = view !== want;
      setView(opening ? want : '');
      announce(fs.getAttribute(opening ? 'data-fs-say-open' : 'data-fs-say-close') || '');
      return;
    }

    var rc = t.closest('[data-wb-kb-rowclear]');
    if (rc) {
      var rk = rc.getAttribute('data-wb-kb-rowclear');
      var had = state.qty[rk] || 0;
      setQty(rk, 0); render();
      if (had > 0) offerUndo(rk, had);
      return;
    }
    if (t.closest('[data-wb-kb-undo]')) {
      if (lastRemoved) { setQty(lastRemoved.key, lastRemoved.qty); render(); }
      hideUndo();
      return;
    }

    var add = t.closest('[data-wb-kb-add]');
    if (add) {
      var ak = add.getAttribute('data-wb-kb-add');
      var akWas = state.qty[ak] || 0;
      /* ⚠ The quick-add chips only. The stepper's own "+" is a different
         branch and must stay a true increment — counting its first press
         from zero would leave a freshly picked row sitting at 1, looking
         broken in the other direction. */
      var akBase = seeded[ak] ? 0 : akWas;
      setQty(ak, akBase + (parseInt(add.getAttribute('data-wb-kb-amt'), 10) || 0));
      pendingCascade = { key: ak, n: (state.qty[ak] || 0) - akWas };
      render();
      return;
    }
    var inc = t.closest('[data-wb-kb-inc]');
    if (inc) {
      var ik = inc.getAttribute('data-wb-kb-inc'), ikWas = state.qty[ik] || 0;
      setQty(ik, ikWas + 1);
      pendingCascade = { key: ik, n: (state.qty[ik] || 0) - ikWas };
      render(); return;
    }
    var dec = t.closest('[data-wb-kb-dec]');
    if (dec) { var dk = dec.getAttribute('data-wb-kb-dec'); setQty(dk, (state.qty[dk] || 0) - 1); render(); return; }

    var grip = t.closest('[data-wb-kb-grip]');
    if (grip) { setGrip(grip.getAttribute('data-wb-kb-grip')); return; }

    var uns = t.closest('[data-wb-kb-unsure]');
    if (uns) { unsure(uns.getAttribute('data-wb-kb-unsure')); render(); return; }

    if (t.closest('[data-wb-kb-more]')) { revealAll(); paintShown(); return; }

    if (t.closest('[data-wb-kb-savekit]')) { saveKit(); return; }
    if (t.closest('[data-wb-kb-emailbtn]')) { askEmail(); return; }

    if (t.closest('[data-wb-kb-linktoggle]')) {
      var lr = el('[data-wb-kb-linkrow]');
      if (lr) { lr.hidden = !lr.hidden; if (!lr.hidden) copyLink(); }
      return;
    }

    if (t.closest('[data-wb-kb-nopliers]')) {
      state.noPliers = true;
      save();
      render();
      return;
    }

    if (t.closest('[data-wb-kb-addpliers]')) {
      var pr = pliersRung();
      /* ⚠ pliersRung() returns { series, size } — there is no .key on it.
         setQty(undefined, …) threw in findSize, so the button rendered, looked
         alive, and did nothing but throw. */
      if (pr) {
        var pk = qtyKey(pr.series.key, pr.size.size);
        setQty(pk, (state.qty[pk] || 0) + 1);
        render();
      }
      return;
    }

    var pick = t.closest('[data-wb-kb-pick]');
    if (pick) {
      var pk = pick.getAttribute('data-wb-kb-pick');
      /* Choosing IS setting a quantity — see the note on the phase module.
         setQty clamps to real stock, so a nearly-sold-out size lands lower. */
      var pkOn = (state.qty[pk] || 0) > 0;
      setQty(pk, pkOn ? 0 : PICK_QTY);
      /* ⚠ After setQty, which clears the flag for every other caller. */
      if (!pkOn) { seeded[pk] = true; pendingCascade = { key: pk, n: state.qty[pk] || 0 }; }
      syncPickChips(); render(); paintPhase();
      return;
    }
    var pickAll = t.closest('[data-wb-kb-pickall]');
    if (pickAll) {
      pickSizes().forEach(function (z) {
        var k = qtyKey(PICK_STEP, z.size);
        if (state.qty[k] || 0) return;
        setQty(k, PICK_QTY);
        /* ⚠ Seeded, exactly as the single chip above marks it — and missing
           here is why "+10" went back to giving 11. The 1 this button leaves
           on a row is a PLACEHOLDER meaning "you chose this size", not a
           quantity anyone asked for, so the first quick-add has to count from
           zero. Picking sizes one at a time set the flag and behaved; "Add all
           N sizes" is the one-tap path most people actually use, and it did
           not, so the fix looked like it had been reverted.
           ⚠ After setQty, which clears the flag for every other caller. */
        seeded[k] = true;
      });
      syncPickChips(); render(); paintPhase();
      return;
    }

    if (t.closest('[data-wb-kb-back]')) { stepBack(); return; }

    var jump = t.closest('[data-wb-kb-jump]');
    if (jump) { scrollToSec(jump.getAttribute('data-wb-kb-jump')); return; }
    var next = t.closest('[data-wb-kb-next]');
    if (next) {
      /* On step one the first Next moves the PHASE, not the step. */
      if (inPick() && next.getAttribute('data-wb-kb-next') === PICK_STEP) {
        if (anyPicked()) { leavePick(); return; }
        /* Nothing picked, but the kit is not empty: skip the step rather than
           swallow the press. Going to the phase would land them on step one's
           counting list with nothing in it — a second dead screen. showStep
           clears the phase on the way out, so this leaves picking properly. */
        if (basket().units) {
          var pickIds = sectionIds();
          if (pickIds[1]) scrollToSec(pickIds[1]);
        }
        return;
      }
      var ids = sectionIds(), i = ids.indexOf(next.getAttribute('data-wb-kb-next'));
      if (ids[i + 1]) scrollToSec(ids[i + 1]);
      return;
    }

    var tray = t.closest('[data-wb-kb-traybtn]');
    if (tray) {
      trayOpen = !trayOpen;
      var body = el('[data-wb-kb-traybody]');
      if (body) body.hidden = !trayOpen;
      tray.setAttribute('aria-expanded', String(trayOpen));
      return;
    }

    var linkBtn = t.closest('[data-wb-kb-save]');
    if (linkBtn) {
      /* ⚠ Copy on THIS click. It used to open a panel holding the link and a
         second Copy button — Owen, 2026-09-06: "One click not 2." The panel
         is not deleted, it is demoted to the fallback: the async clipboard
         is refused outright in some embedded browsers, and a customer who
         gets nothing needs the field and the "press Cmd + C" line that were
         written for exactly that. So: try to copy, say "Link copied" on the
         button itself, and only open the panel when the copy did not land. */
      /* ⚠ Only the LINK variant copies. With the Klaviyo endpoint configured
         this same button becomes "Email me my kit" and its panel holds an
         address field — copying a URL and closing it would throw away the
         form the customer came for. */
      /* ⚠ The branch that used to sit here tested `cfg.email_url`, but the
         endpoint is emitted inside the t object as `cfg.t.email_url` — so it
         was always undefined and this button always fell through to the copy
         below. That is why pressing "Email me my kit" said "Link copied"
         (Owen, 2026-09-07). Emailing has its own button now, so there is
         nothing left for this one to decide: it copies, always. */
      var panel = el('[data-wb-kb-savepanel]');
      var href = linkFor();
      var openPanel = function () {
        if (!panel) return;
        panel.hidden = false;
        var f = el('[data-wb-kb-linkfield]');
        if (f) { f.value = href || ''; try { f.select(); } catch (e2) {} }
        var nt = el('[data-wb-kb-copynote]');
        if (nt) nt.textContent = href ? cfg.t.save_manual : cfg.t.save_empty;
      };
      if (!href) { openPanel(); return; }
      var lab = el('[data-wb-kb-savelabel]', linkBtn) || linkBtn;
      /* ⚠ Restore the label the LIQUID rendered, not cfg.t.save_btn — that
         key is not in the config blob (the same "used in markup, never sent
         to the script" trap as pick_next and name_label), so the button came
         back blank. Remembering what was there also keeps the email variant
         of this button correct without a second lookup. */
      if (!linkLabel) linkLabel = lab.textContent.trim();
      var said = function () {
        lab.textContent = cfg.t.save_copied;
        announce(cfg.t.save_copied);
        if (panel) panel.hidden = true;
        clearTimeout(linkTimer);
        linkTimer = setTimeout(function () { lab.textContent = linkLabel; }, 2600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(href).then(said, openPanel);
      } else {
        openPanel();
      }
      return;
    }
    if (t.closest('[data-wb-kb-copy]')) { copyLink(); return; }

    if (t.closest('[data-wb-kb-mclose]')) { closeModal(); return; }
    var cell = t.closest('[data-wb-kb-cell]');
    if (cell && !t.closest('[data-wb-kb-modal]')) { openModal(cell.getAttribute('data-wb-kb-cell')); return; }

    if (t.closest('[data-wb-kb-addcart]')) { addToCart(); return; }

    if (t.closest('[data-wb-kb-donesave]')) { saveAdded(); return; }
    if (t.closest('[data-wb-kb-again]')) {
      justAdded = null;
      /* ⚠ A full reset, not just an empty basket. addToCart clears the
         quantities because the kit has left the bench, but the walk carries
         more state than that: `shown` is the set of counting rows revealed so
         far, so last kit's sizes would reappear at zero in the new one;
         `seeded` marks placeholder quantities; and the editing flags belong to
         a kit that is now in the cart. Owen asked for a fresh start and this
         is what fresh means. */
      state.qty = {};
      state.name = '';
      state.cond = {};
      state.project = null;
      state.pliers = null;
      state.custom = false;
      state.noPliers = false;
      state.editingKit = null;
      shown = {};
      seeded = {};
      arrivedWithKit = false;
      shelfEditId = null;
      savedClean = false;
      root.classList.remove('is-editing');
      var againName = root.querySelector('[data-wb-kb-name]');
      if (againName) againName.value = '';
      syncPickChips();
      render();
      /* Back to the top of the walk, not to the review they are standing on:
         the review of an empty kit is the state this panel exists to replace. */
      scrollToSec(sectionIds()[0]);
      return;
    }
  });

  /* The second half of the tray anchor. Registered AFTER the handler above,
     on the same element and in the same phase, so it runs immediately after
     it: the render has happened, nothing has painted yet, and the correction
     is invisible. See the note on the capture half for why this is not a
     microtask and not a frame callback. */
  root.addEventListener('click', function () {
    var a = trayAnchor;
    trayAnchor = null;
    if (!a) return;
    var delta = a.host.getBoundingClientRect().top - a.top;
    /* A whole viewport of movement is not a list growing by one group, it is
       something else entirely. Leave it rather than throw the page. */
    if (!delta || Math.abs(delta) > window.innerHeight) return;
    var sp = scrollerFor(a.host);
    if (sp) sp.scrollTop += delta;
    else window.scrollBy(0, delta);
  });

  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var cell = e.target.closest('[data-wb-kb-cell]');
    if (cell) { e.preventDefault(); openModal(cell.getAttribute('data-wb-kb-cell')); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (modalSec) { closeModal(); return; }
    /* ⚠ And the preview, which had no keyboard exit at all — the only way out
       was the one fixed pill. A view with a single way to leave it is how this
       page has trapped people twice. */
    if (view) setView('');
  });

  root.addEventListener('input', function (e) {
    var input = e.target.closest('[data-wb-kb-in]');
    if (input) {
      /* ⚠ render() rebuilds the review list and the add-to-kit tray with
         innerHTML, and BOTH of them contain quantity fields — so the very
         input this event came from is removed from the document and focus
         falls to <body>. A customer changing a line from 4 to 12 typed the
         "1", watched the field become 1, and the "2" went nowhere: the row,
         the bench and the cart all ended up at 1. Silent, and it made every
         quantity in the editor a single digit. Verified on dev before the
         fix by typing one character at a time — the whole string sent at
         once only fires ONE input event and hides it completely.

         syncRows()'s `document.activeElement !== input` guard cannot help
         here: it re-values a surviving node, and this node is gone.

         So: note which field and where the caret was, then put the customer
         back in the replacement. Same key, same offset. */
      var key = input.getAttribute('data-wb-kb-in');
      var caret = null;
      try { caret = input.selectionStart; } catch (e2) {}
      /* ⚠ Scoped to the host the customer was actually typing in. The same
         key has a field in the walk row, the review row, the tray panel and
         the bench modal at once, and a bare el() returns whichever comes
         first in the document — the walk's, which in editor mode is
         display:none. Focus would have gone somewhere invisible. These four
         hosts all survive the render; only their contents are replaced. */
      var host = input.closest('[data-wb-kb-review], [data-wb-kb-addtray], [data-wb-kb-mbody], [data-wb-kb-list]');
      setQty(key, parseInt(String(input.value).replace(/\D/g, ''), 10) || 0);
      render();
      var again = input.isConnected ? input
        : (host ? el('[data-wb-kb-in="' + cssq(key) + '"]', host) : null);
      if (again && again !== input && again.focus) {
        try { again.focus({ preventScroll: true }); } catch (e3) { again.focus(); }
        if (caret !== null) {
          var at = Math.min(caret, String(again.value).length);
          try { again.setSelectionRange(at, at); } catch (e4) {}
        }
      }
      return;
    }
    var name = e.target.closest('[data-wb-kb-name]');
    if (name) {
      state.name = name.value;
      /* ⚠ save(), not a bare assignment. Without it the new name reached
         neither sessionStorage nor the shelf — a rename made on its own was
         simply lost on reload — and savedClean stayed true, so the button
         went on reading "Saved" over a name the customer had just changed
         and not yet saved. It also arms the leave guard, which is right:
         a renamed kit is unsaved work. */
      save();
      syncSaveBtn();
    }
  });

  /* ⚠ The CTA has its own attribute. It used to share data-wb-kb-add with the
     quick-add chips, so the chip handler matched it first, parsed an empty key
     and a NaN amount, and returned — the button looked alive and silently
     never added anything to the cart. */

  var rt;
  /* ⚠ A SECOND listener, on the document. The main one is bound to
     [data-wb-kb], and the shelf lives in the masthead while the confirm is
     appended to <body> — neither is inside it, so a click on either never
     reached the section's handler. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-wb-kb-shelf]')) { toggleMore(false); toggleShelf(); return; }
    if (t.closest('[data-wb-kb-moretoggle]')) { toggleMore(); return; }
    if (t.closest('[data-wb-kb-clearkit]')) { toggleMore(false); askClear(); return; }
    if (t.closest('[data-wb-kb-cno]')) { closeConfirm(); return; }
    var so = t.closest('[data-wb-kb-shelfopen]');
    if (so) { openKit(so.getAttribute('data-wb-kb-shelfopen')); return; }
    var edu = t.closest('[data-wb-kb-edu]');
    if (edu) {
      var ek = edu.getAttribute('data-wb-kb-edu');
      openEdu = openEdu === ek ? null : ek;
      renderReview();
      var back = el('[data-wb-kb-edu="' + cssq(ek) + '"]');
      if (back && back.focus) { try { back.focus({ preventScroll: true }); } catch (e2) { back.focus(); } }
      return;
    }

    var bub = t.closest('[data-wb-kb-bub]');
    if (bub) {
      var want = bub.getAttribute('data-wb-kb-bub');
      /* One open at a time. An accordion where everything can open is the
         eight-step list again, only vertical — and the total leaves the
         screen, which is the one thing the editor keeps in view. */
      var wasOpen = openBubble;
      openBubble = (!want || want === openBubble) ? null : want;
      renderAdd();
      /* renderAdd() replaces the tray's markup wholesale, so the button that
         was just pressed is gone from the document and focus has fallen back
         to <body>. A keyboard or screen-reader user would lose their place on
         every open and close, and with the five-bubble cap removed the walk
         back is now up to nine tab stops. Focus returns to the TRIGGER, which
         is where an accordion should leave it — and where aria-expanded is,
         so the state change is announced on the control that changed it.
         `want` is empty when the panel's own × was used; that closes the type
         named by wasOpen, and that is the tile to go back to. */
      var again = el('[data-wb-kb-bub="' + cssq(want || wasOpen || '') + '"]');
      /* preventScroll so this does not fight the nudge above. */
      if (again && again.focus) { try { again.focus({ preventScroll: true }); } catch (e2) { again.focus(); } }
      return;
    }

    if (t.closest('[data-wb-kb-sharekit]')) { shareKit(); return; }
    var sr = t.closest('[data-wb-kb-shelfrename]');
    if (sr) { askRename(sr.getAttribute('data-wb-kb-shelfrename')); return; }
    var se = t.closest('[data-wb-kb-shelfemail]');
    if (se) { askEmailSaved(se.getAttribute('data-wb-kb-shelfemail')); return; }
    var sd = t.closest('[data-wb-kb-shelfdel]');
    if (sd) { askDelete(sd.getAttribute('data-wb-kb-shelfdel')); return; }
    /* Anywhere else closes the shelf, the way a menu should — but not a click
       inside the panel itself, and not while a confirm is up. */
    if (t.closest('.wb-kb__cmodal')) return;
    var panel = dEl('[data-wb-kb-shelfpanel]');
    if (panel && !panel.hidden && !t.closest('[data-wb-kb-shelfpanel]')) toggleShelf(false);
    var menu = dEl('[data-wb-kb-moremenu]');
    if (menu && !menu.hidden && !t.closest('[data-wb-kb-moremenu]')) toggleMore(false);
  });

  /* ⚠ Enter in the email popup is handled by askConfirm itself — it binds
     onkeydown to whichever button carries `takes`, which is Send. The listener
     that used to live here pointed at an inline field and a function that no
     longer exist. */

  /* ⚠ Capture phase, so this runs before the drawers and menus that also
     listen for clicks. Only real navigations are caught: a modified click is
     the customer deliberately opening a new tab and keeps this one intact,
     a hash is the same page, and a download is not a navigation at all. */
  document.addEventListener('click', function (e) {
    if (!dirty || leaving) return;
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a || a.hasAttribute('download')) return;
    /* ⚠ aria-controls means this anchor OPENS SOMETHING ON THIS PAGE and only
       falls back to its href without JS — the cart button is exactly that.
       This listener runs in the capture phase, so without this it fired
       before the drawer's own handler and put "Save your kit before you go?"
       in front of a customer who just wanted to look in their cart. */
    if (a.hasAttribute('aria-controls')) return;
    if (a.target && a.target !== '_self') return;
    var raw = a.getAttribute('href') || '';
    if (!raw || raw.charAt(0) === '#') return;
    var u;
    try { u = new URL(a.href, window.location.href); } catch (err) { return; }
    if (u.pathname === window.location.pathname && u.origin === window.location.origin) return;
    if (!basket().units) return;
    e.preventDefault();
    e.stopPropagation();
    askLeave(u.href);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && confirmEl && !confirmEl.hidden) { closeConfirm(); return; }
    if (e.key === 'Escape') { toggleShelf(false); toggleMore(false); }
  });

  /* ⚠ The backstop for everything the click guard cannot see: closing the
     tab, the Back button walking off the end of the step history, a typed
     URL, a form submit. The browser draws its own dialog here and will not
     let us word it or offer Save/Discard — that is why the click guard
     exists as well and handles the common case properly.
     `leaving` and the cleared `dirty` both suppress it when the customer
     already chose in OUR dialog, so they are never asked twice. */
  window.addEventListener('beforeunload', function (e) {
    if (!dirty || leaving) return;
    if (!basket().units) return;
    e.preventDefault();
    e.returnValue = '';
    return '';
  });

  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      /* A rotate changes the header's height, and the expanded bench cannot
         scroll to discover that for itself. */
      if (view === VIEWS.stage) pinBench();
      syncAvail();
      /* Crossing the 1080 breakpoint changes the line length, which lives in
         the markup — a resize alone would leave the old one behind. */
      if (syncWide()) renderBoard();
      fitBoard();
      /* Crossing 1080 moves Save between the stage bar and the foot bar, and
         crossing 749 swaps "Save kit" for "Save". Neither redraws by itself. */
      syncSaveBtn();
      /* The tray re-wraps at a new width, so the row the open panel belongs
         under is a different row. Moved, not re-rendered — a re-render would
         take the focus out of whichever quantity field is being typed in. */
      placeBubPanel();
    }, 120);
  });
  /* No scroll listener for the header offset: --wb-kb-top is pure CSS now
     (see stickyTop's comment), so the bench follows the header's condense
     with no JS in the loop at all. */

  /* The cart can change in another tab or through the drawer, and the
     free-shipping bar must not promise progress against a stale total. */
  document.addEventListener('cart:updated', function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (cart && typeof cart.total_price === 'number') { cfg.cartTotal = cart.total_price; renderTray(); }
  });

  /* ── go ───────────────────────────────────────────────────────────── */

  buildLists();
  initGrip();
  initFilm();
  loadCartQty();
  buildModal();
  buildConfirm();
  var restored = restore();
  active = sectionIds()[0] || null;
  render();
  renderShelf();
  startStepping();
  typeActive();

  /* ⚠ Arm the guards for a kit that arrived rather than one that was built.
     A kit restored from a ?kit= link or from the session is in neither the
     shelf nor the cart, so it is exactly as unsaved as one typed in by hand —
     but nothing had called save(), so `dirty` was false and no history
     sentinel existed, and pressing Back straight after following a
     "Customise this kit" link threw it away in silence.
     After startStepping(), so the sentinel sits above the step entry it
     replaced rather than underneath it. */
  if (basket().units) {
    dirty = true;
    armBackGuard();
  }
  /* ⚠ replace, not push. This fires at LOAD, so a pushed entry would sit
     between the customer and the product page they arrived from — one Back
     press would land them on step 1 of the builder instead of the PDP. */
  /* One class, read by the stylesheet. The only JS that branches on the same
     fact is renderReview, which picks which host the saving line renders in. */
  root.classList.toggle('is-editing', arrivedWithKit);

  if (restored) setTimeout(function () { scrollToSec('review', { replace: true }); }, 140);

  /* ⚠ After startStepping(), not inside restore(). The dialog is answered
     asynchronously and both answers act on a builder that has to already be
     running: Continue calls openKit(), which renders and reveals the picked
     sizes, and neither is safe before `active` is set. */
  if (pendingOpen) askResume(pendingOpen);
})();
